import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createSlots as _createSlots, vModelText as _vModelText, withDirectives as _withDirectives, Transition as _Transition, Teleport as _Teleport, createBlock as _createBlock, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "hidden md:block mt-0.5 md:mt-1 text-xs md:text-sm text-black" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "hidden md:flex flex-wrap items-center gap-2" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "md:px-0" }
const _hoisted_6 = {
  key: 0,
  class: "sticky top-16 z-30 bg-gray-50 px-3 md:px-0 py-1"
}
const _hoisted_7 = { class: "pr-0 md:px-0" }
const _hoisted_8 = { class: "text-sm text-black mb-4" }
const _hoisted_9 = { class: "flex justify-end gap-2" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "space-y-3" }
const _hoisted_14 = { class: "text-sm text-black mb-3" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "flex gap-3 overflow-x-auto overscroll-x-contain pb-2 -mx-1 px-1 snap-x snap-mandatory" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "relative w-full aspect-square bg-gray-100 rounded-md overflow-hidden mb-2" }
const _hoisted_19 = ["src", "alt"]
const _hoisted_20 = {
  key: 1,
  class: "flex items-center justify-center h-full"
}
const _hoisted_21 = {
  key: 2,
  class: "absolute top-1 right-1 w-5 h-5 bg-red-500 rounded-full flex items-center justify-center shadow"
}
const _hoisted_22 = {
  key: 3,
  class: "absolute top-1 right-1 w-5 h-5 bg-white/90 border border-gray-300 rounded-full"
}
const _hoisted_23 = ["title"]
const _hoisted_24 = ["title"]
const _hoisted_25 = { class: "flex gap-3 overflow-x-auto overscroll-x-contain pb-2 -mx-1 px-1 snap-x snap-mandatory" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "relative w-full aspect-square bg-gray-100 rounded-md overflow-hidden mb-2" }
const _hoisted_28 = ["src", "alt"]
const _hoisted_29 = {
  key: 1,
  class: "flex items-center justify-center h-full"
}
const _hoisted_30 = {
  key: 2,
  class: "absolute top-1 right-1 w-5 h-5 bg-red-500 rounded-full flex items-center justify-center shadow"
}
const _hoisted_31 = {
  key: 3,
  class: "absolute top-1 right-1 w-5 h-5 bg-white/90 border border-gray-300 rounded-full"
}
const _hoisted_32 = ["title"]
const _hoisted_33 = ["title"]
const _hoisted_34 = {
  key: 0,
  class: "fixed inset-0 z-[9999] overflow-hidden"
}
const _hoisted_35 = { class: "relative flex h-full items-center justify-center p-4 pointer-events-none" }
const _hoisted_36 = { class: "pointer-events-auto bg-white rounded-lg shadow-xl w-full max-w-2xl max-h-[calc(100vh-2rem)] flex flex-col" }
const _hoisted_37 = { class: "flex-1 min-h-0 overflow-y-auto overscroll-contain px-6 py-5 space-y-4" }
const _hoisted_38 = { class: "text-sm text-black leading-relaxed whitespace-pre-line" }
const _hoisted_39 = {
  key: 0,
  class: "rounded-lg border border-gray-200 bg-gray-50 px-4 py-3 text-sm text-black"
}
const _hoisted_40 = {
  key: 1,
  class: "space-y-3"
}
const _hoisted_41 = { class: "flex items-center justify-between gap-3" }
const _hoisted_42 = { class: "text-sm font-medium text-black" }
const _hoisted_43 = { class: "space-y-3" }
const _hoisted_44 = { class: "text-sm text-black" }
const _hoisted_45 = { class: "font-medium" }
const _hoisted_46 = {
  key: 0,
  class: "text-black"
}
const _hoisted_47 = { class: "flex gap-3 overflow-x-auto overscroll-x-contain pb-1 -mx-1 px-1 snap-x snap-mandatory" }
const _hoisted_48 = ["onClick", "title"]
const _hoisted_49 = { class: "relative w-full aspect-square bg-gray-100 rounded-md overflow-hidden mb-2 flex items-center justify-center" }
const _hoisted_50 = {
  key: 0,
  class: "absolute top-1 right-1 w-5 h-5 bg-red-500 rounded-full flex items-center justify-center shadow"
}
const _hoisted_51 = { class: "text-[10px] text-black leading-tight" }
const _hoisted_52 = ["onClick"]
const _hoisted_53 = { class: "relative w-full aspect-square bg-gray-100 rounded-md overflow-hidden mb-2" }
const _hoisted_54 = ["src", "alt"]
const _hoisted_55 = {
  key: 1,
  class: "flex items-center justify-center h-full"
}
const _hoisted_56 = {
  key: 2,
  class: "absolute top-1 right-1 w-5 h-5 bg-orange-500 rounded-full flex items-center justify-center shadow"
}
const _hoisted_57 = {
  key: 3,
  class: "absolute top-1 right-1 w-5 h-5 bg-white/90 border border-gray-300 rounded-full"
}
const _hoisted_58 = ["title"]
const _hoisted_59 = ["title"]
const _hoisted_60 = { class: "flex-shrink-0 px-6 py-4 bg-gray-50 rounded-b-lg flex justify-end space-x-3 border-t border-gray-200" }
const _hoisted_61 = ["disabled"]
const _hoisted_62 = ["disabled"]
const _hoisted_63 = { class: "flex gap-3 overflow-x-auto overscroll-x-contain pb-2 -mx-1 px-1 snap-x snap-mandatory" }
const _hoisted_64 = ["disabled", "title"]
const _hoisted_65 = { class: "relative w-full aspect-square bg-gray-100 rounded-md overflow-hidden mb-2 flex items-center justify-center" }
const _hoisted_66 = {
  key: 0,
  class: "absolute top-1 right-1 w-5 h-5 bg-red-500 rounded-full flex items-center justify-center shadow"
}
const _hoisted_67 = { class: "text-[10px] text-black leading-tight" }
const _hoisted_68 = ["onClick"]
const _hoisted_69 = { class: "relative w-full aspect-square bg-gray-100 rounded-md overflow-hidden mb-2" }
const _hoisted_70 = ["src", "alt"]
const _hoisted_71 = {
  key: 1,
  class: "flex items-center justify-center h-full"
}
const _hoisted_72 = {
  key: 2,
  class: "absolute top-1 right-1 w-5 h-5 bg-orange-500 rounded-full flex items-center justify-center shadow"
}
const _hoisted_73 = {
  key: 3,
  class: "absolute top-1 right-1 w-5 h-5 bg-white/90 border border-gray-300 rounded-full"
}
const _hoisted_74 = ["title"]
const _hoisted_75 = ["title"]
const _hoisted_76 = { class: "space-y-3" }
const _hoisted_77 = {
  key: 0,
  class: "text-sm text-gray-600"
}
const _hoisted_78 = {
  key: 1,
  class: "rounded-md border border-red-200 bg-red-50 px-3 py-2"
}
const _hoisted_79 = { class: "space-y-1 text-xs text-red-700" }
const _hoisted_80 = {
  key: 2,
  class: "rounded-md border border-amber-200 bg-amber-50 px-3 py-2"
}
const _hoisted_81 = { class: "space-y-1 text-xs text-amber-800" }
const _hoisted_82 = { key: 0 }
const _hoisted_83 = {
  key: 3,
  class: "space-y-2 rounded-md border border-blue-200 bg-blue-50 px-3 py-2"
}
const _hoisted_84 = { class: "mb-2 text-xs font-semibold text-blue-900" }
const _hoisted_85 = { class: "grid grid-cols-1 md:grid-cols-2 gap-2" }
const _hoisted_86 = ["name", "checked", "disabled", "onChange"]
const _hoisted_87 = { class: "flex h-10 w-10 flex-shrink-0 items-center justify-center overflow-hidden rounded-md bg-gray-100" }
const _hoisted_88 = ["src", "alt"]
const _hoisted_89 = {
  key: 1,
  class: "fas fa-tshirt text-xs text-gray-500"
}
const _hoisted_90 = { class: "min-w-0" }
const _hoisted_91 = { class: "block text-sm font-medium text-black truncate" }
const _hoisted_92 = { class: "block text-xs text-gray-500 truncate" }
const _hoisted_93 = {
  key: 0,
  class: "text-blue-700"
}
const _hoisted_94 = {
  key: 1,
  class: "text-amber-700"
}
const _hoisted_95 = {
  key: 4,
  class: "space-y-2 rounded-md border border-blue-200 bg-blue-50 px-3 py-2"
}
const _hoisted_96 = { class: "grid grid-cols-1 md:grid-cols-2 gap-2" }
const _hoisted_97 = ["checked", "disabled", "onChange"]
const _hoisted_98 = { class: "min-w-0" }
const _hoisted_99 = { class: "block text-sm font-medium text-black truncate" }
const _hoisted_100 = { class: "block text-xs text-gray-500 truncate" }
const _hoisted_101 = {
  key: 5,
  class: "rounded-md border border-blue-100 bg-blue-50 px-3 py-2 text-xs text-blue-800"
}
const _hoisted_102 = {
  key: 6,
  class: "space-y-2"
}
const _hoisted_103 = { class: "grid grid-cols-1 md:grid-cols-2 gap-2" }
const _hoisted_104 = ["checked", "disabled", "onChange"]
const _hoisted_105 = { class: "flex h-11 w-11 flex-shrink-0 items-center justify-center overflow-hidden rounded-md bg-gray-100" }
const _hoisted_106 = ["src", "alt"]
const _hoisted_107 = {
  key: 1,
  class: "fas fa-tshirt text-xs text-gray-500"
}
const _hoisted_108 = { class: "min-w-0" }
const _hoisted_109 = { class: "flex items-center gap-1 text-sm font-medium text-black truncate" }
const _hoisted_110 = { class: "block text-xs text-gray-500 truncate" }
const _hoisted_111 = {
  key: 7,
  class: "space-y-2"
}
const _hoisted_112 = { class: "text-xs font-semibold uppercase text-gray-700" }
const _hoisted_113 = { class: "overflow-x-auto border border-gray-200 rounded-md" }
const _hoisted_114 = { class: "min-w-full text-xs" }
const _hoisted_115 = { class: "divide-y divide-gray-100 bg-white" }
const _hoisted_116 = { class: "px-3 py-2" }
const _hoisted_117 = { class: "flex items-center gap-2" }
const _hoisted_118 = { class: "flex h-10 w-10 flex-shrink-0 items-center justify-center overflow-hidden rounded-md bg-gray-100" }
const _hoisted_119 = ["src", "alt"]
const _hoisted_120 = {
  key: 1,
  class: "fas fa-tshirt text-xs text-gray-500"
}
const _hoisted_121 = { class: "min-w-0" }
const _hoisted_122 = { class: "flex items-center gap-1 font-medium text-black" }
const _hoisted_123 = { class: "truncate" }
const _hoisted_124 = {
  key: 0,
  class: "rounded-full bg-blue-100 px-1.5 py-0.5 text-[10px] font-medium text-blue-700"
}
const _hoisted_125 = { class: "block text-gray-500" }
const _hoisted_126 = {
  key: 0,
  class: "text-amber-700"
}
const _hoisted_127 = {
  key: 0,
  class: "block truncate text-amber-700"
}
const _hoisted_128 = { class: "px-3 py-2 text-gray-700" }
const _hoisted_129 = { class: "px-3 py-2" }
const _hoisted_130 = { class: "space-y-3" }
const _hoisted_131 = { class: "mb-2 text-xs text-gray-600" }
const _hoisted_132 = { class: "flex gap-3 overflow-x-auto overscroll-x-contain pb-1 -mx-1 px-1 snap-x snap-mandatory" }
const _hoisted_133 = ["onClick"]
const _hoisted_134 = { class: "relative mb-2 aspect-square w-full overflow-hidden rounded-md bg-gray-100" }
const _hoisted_135 = ["src", "alt"]
const _hoisted_136 = {
  key: 1,
  class: "flex h-full items-center justify-center"
}
const _hoisted_137 = {
  key: 2,
  class: "absolute right-1 top-1 flex h-5 w-5 items-center justify-center rounded-full bg-blue-500 shadow"
}
const _hoisted_138 = {
  key: 3,
  class: "absolute right-1 top-1 h-5 w-5 rounded-full border border-gray-300 bg-white/90"
}
const _hoisted_139 = ["title"]
const _hoisted_140 = ["title"]
const _hoisted_141 = {
  key: 0,
  class: "space-y-4"
}
const _hoisted_142 = { class: "text-xs font-medium text-gray-700 mb-2" }
const _hoisted_143 = { class: "flex gap-3 overflow-x-auto overscroll-x-contain pb-2 -mx-1 px-1 snap-x snap-mandatory" }
const _hoisted_144 = ["onClick"]
const _hoisted_145 = { class: "relative w-full aspect-square bg-gray-100 rounded-md overflow-hidden mb-2" }
const _hoisted_146 = ["src", "alt"]
const _hoisted_147 = {
  key: 1,
  class: "flex items-center justify-center h-full"
}
const _hoisted_148 = {
  key: 2,
  class: "absolute top-1 right-1 w-5 h-5 bg-orange-500 rounded-full flex items-center justify-center shadow"
}
const _hoisted_149 = {
  key: 3,
  class: "absolute top-1 right-1 w-5 h-5 bg-white/90 border border-gray-300 rounded-full"
}
const _hoisted_150 = ["title"]
const _hoisted_151 = ["title"]
const _hoisted_152 = { key: 1 }
const _hoisted_153 = { class: "flex gap-3 overflow-x-auto overscroll-x-contain pb-2 -mx-1 px-1 snap-x snap-mandatory" }
const _hoisted_154 = ["onClick"]
const _hoisted_155 = { class: "relative w-full aspect-square bg-gray-100 rounded-md overflow-hidden mb-2" }
const _hoisted_156 = ["src", "alt"]
const _hoisted_157 = {
  key: 1,
  class: "flex items-center justify-center h-full"
}
const _hoisted_158 = {
  key: 2,
  class: "absolute top-1 right-1 w-5 h-5 bg-orange-500 rounded-full flex items-center justify-center shadow"
}
const _hoisted_159 = {
  key: 3,
  class: "absolute top-1 right-1 w-5 h-5 bg-white/90 border border-gray-300 rounded-full"
}
const _hoisted_160 = ["title"]
const _hoisted_161 = ["title"]
const _hoisted_162 = { class: "bg-white rounded-lg shadow-xl w-full max-w-md transform transition-all" }
const _hoisted_163 = { class: "px-6 py-5 space-y-4" }
const _hoisted_164 = {
  key: 0,
  class: "flex items-center justify-center gap-2 py-3 text-black text-sm"
}
const _hoisted_165 = {
  key: 0,
  class: "font-medium text-green-700"
}
const _hoisted_166 = {
  key: 1,
  class: "font-medium text-red-700"
}
const _hoisted_167 = {
  key: 2,
  class: "mt-2 text-red-600 text-xs max-h-24 overflow-y-auto space-y-0.5"
}
const _hoisted_168 = {
  key: 3,
  class: "mt-2 text-red-600 text-xs max-h-24 overflow-y-auto space-y-0.5"
}
const _hoisted_169 = { class: "px-6 py-4 bg-gray-50 rounded-b-lg flex justify-end space-x-3" }
const _hoisted_170 = ["disabled"]
const _hoisted_171 = {
  key: 0,
  class: "fas fa-spinner fa-spin mr-1"
}
const _hoisted_172 = { class: "flex items-center gap-2 mb-4 mt-2" }
const _hoisted_173 = ["data-product-id", "onClick"]
const _hoisted_174 = {
  key: 0,
  class: "absolute -left-6 top-0 h-[4.5rem] w-5 pointer-events-none",
  "aria-hidden": "true"
}
const _hoisted_175 = { class: "flex items-center gap-2 mb-2 h-8" }
const _hoisted_176 = { class: "flex flex-col justify-center h-8 flex-shrink-0" }
const _hoisted_177 = ["id", "value", "checked", ".indeterminate", "onChange", "title"]
const _hoisted_178 = { class: "flex flex-col justify-center h-8 min-w-0 flex-1" }
const _hoisted_179 = ["title"]
const _hoisted_180 = ["onClick"]
const _hoisted_181 = ["onClick"]
const _hoisted_182 = ["onClick", "disabled"]
const _hoisted_183 = ["onClick"]
const _hoisted_184 = ["onClick"]
const _hoisted_185 = { class: "w-5 h-5 min-w-[1.25rem] bg-pink-500 rounded flex items-center justify-center" }
const _hoisted_186 = ["onClick"]
const _hoisted_187 = ["onClick"]
const _hoisted_188 = ["href", "onClick"]
const _hoisted_189 = ["onClick"]
const _hoisted_190 = ["src", "alt"]
const _hoisted_191 = {
  key: 1,
  class: "flex items-center justify-center h-full"
}
const _hoisted_192 = {
  key: 2,
  class: "absolute inset-0 bg-slate-900/55 flex flex-col items-center justify-center gap-0.5 pointer-events-none"
}
const _hoisted_193 = { class: "min-w-[1.75rem] h-7 px-2 rounded-full bg-white text-slate-900 text-sm font-bold flex items-center justify-center shadow" }
const _hoisted_194 = { class: "text-[9px] font-semibold text-white tracking-wide" }
const _hoisted_195 = { class: "flex-1 min-w-0 relative -mt-2" }
const _hoisted_196 = {
  key: 0,
  class: "inline-flex items-center px-1.5 py-0.5 rounded-full text-[9px] font-bold bg-blue-600 text-white whitespace-nowrap leading-none"
}
const _hoisted_197 = {
  key: 1,
  class: "inline-flex items-center px-1.5 py-0.5 rounded-full text-[9px] font-medium bg-amber-600 text-white shadow-sm leading-none"
}
const _hoisted_198 = {
  key: 3,
  class: "ml-auto flex items-center gap-1.5 pl-2"
}
const _hoisted_199 = ["checked", "disabled", "onChange"]
const _hoisted_200 = { class: "flex items-baseline gap-1 py-px min-w-0" }
const _hoisted_201 = { class: "text-sm font-medium text-black truncate leading-tight" }
const _hoisted_202 = { class: "flex items-baseline gap-1 py-px min-w-0" }
const _hoisted_203 = { class: "text-sm font-medium text-black truncate leading-tight" }
const _hoisted_204 = { class: "flex items-center gap-1 py-px min-w-0" }
const _hoisted_205 = {
  key: 0,
  class: "inline-flex flex-wrap gap-1 items-center"
}
const _hoisted_206 = ["title", "disabled", "onClick"]
const _hoisted_207 = ["disabled", "onClick"]
const _hoisted_208 = { class: "flex items-baseline gap-1 py-px min-w-0" }
const _hoisted_209 = { class: "text-sm font-medium text-black truncate leading-tight" }
const _hoisted_210 = { class: "flex items-baseline gap-1 py-px min-w-0" }
const _hoisted_211 = { class: "text-sm font-medium text-black leading-tight" }
const _hoisted_212 = { class: "flex items-baseline gap-1 py-px min-w-0" }
const _hoisted_213 = { class: "text-sm font-medium text-black leading-tight" }
const _hoisted_214 = { class: "flex items-baseline gap-1 py-px min-w-0" }
const _hoisted_215 = { class: "text-sm font-medium text-black leading-tight" }
const _hoisted_216 = ["onClick"]
const _hoisted_217 = {
  key: 1,
  class: "hidden xl:block bg-white rounded-lg border border-gray-200 shadow-sm overflow-x-auto product-table-custom"
}
const _hoisted_218 = {
  key: 0,
  class: "flex items-center justify-center h-64 py-10 text-black"
}
const _hoisted_219 = ["checked"]
const _hoisted_220 = ["id", "value", "checked", ".indeterminate", "onChange", "title"]
const _hoisted_221 = { class: "flex items-center gap-1.5" }
const _hoisted_222 = {
  key: 0,
  class: "relative flex-shrink-0 w-5 h-12",
  "aria-hidden": "true"
}
const _hoisted_223 = ["onClick"]
const _hoisted_224 = ["src", "alt", "onError"]
const _hoisted_225 = {
  key: 1,
  class: "flex items-center justify-center"
}
const _hoisted_226 = {
  key: 2,
  class: "absolute inset-0 bg-slate-900/55 flex flex-col items-center justify-center pointer-events-none"
}
const _hoisted_227 = { class: "min-w-[1.5rem] h-6 px-1.5 rounded-full bg-white text-slate-900 text-xs font-bold flex items-center justify-center shadow" }
const _hoisted_228 = { class: "text-[10px] text-black" }
const _hoisted_229 = { class: "flex items-center min-h-[32px] justify-start w-[220px] pointer-events-auto" }
const _hoisted_230 = { class: "flex flex-col gap-0.5 max-w-[220px] pl-2" }
const _hoisted_231 = {
  key: 0,
  class: "flex items-center justify-center px-1.5 py-0.5 text-[10px] font-bold bg-blue-600 text-white rounded whitespace-nowrap flex-shrink-0 mb-0.5",
  style: {"align-self":"flex-start"}
}
const _hoisted_232 = { class: "flex" }
const _hoisted_233 = ["title"]
const _hoisted_234 = { class: "w-6 flex items-center justify-center flex-shrink-0 mt-0.5 ml-1" }
const _hoisted_235 = ["onClick", "title"]
const _hoisted_236 = ["value", "disabled", "onChange"]
const _hoisted_237 = ["value"]
const _hoisted_238 = ["value", "onChange"]
const _hoisted_239 = ["value"]
const _hoisted_240 = { class: "flex gap-1" }
const _hoisted_241 = ["onUpdate:modelValue", "onChange"]
const _hoisted_242 = ["value"]
const _hoisted_243 = ["onUpdate:modelValue", "onChange"]
const _hoisted_244 = ["value"]
const _hoisted_245 = ["onUpdate:modelValue", "onChange"]
const _hoisted_246 = ["value"]
const _hoisted_247 = ["value", "disabled", "onChange"]
const _hoisted_248 = { class: "relative w-14" }
const _hoisted_249 = {
  key: 0,
  class: "absolute -top-3 right-0 whitespace-nowrap text-[9px] font-medium leading-none text-red-600"
}
const _hoisted_250 = ["value", "disabled", "onChange"]
const _hoisted_251 = ["value", "onChange"]
const _hoisted_252 = ["title", "disabled", "onClick"]
const _hoisted_253 = ["disabled", "onClick"]
const _hoisted_254 = ["onClick"]
const _hoisted_255 = ["value", "onChange"]
const _hoisted_256 = ["onClick"]
const _hoisted_257 = ["value", "onChange"]
const _hoisted_258 = {
  key: 2,
  class: "text-[10px] text-black"
}
const _hoisted_259 = {
  key: 0,
  class: "text-[10px] text-black italic"
}
const _hoisted_260 = ["checked", "disabled", "onChange"]
const _hoisted_261 = ["onClick"]
const _hoisted_262 = ["onClick"]
const _hoisted_263 = ["onClick", "disabled"]
const _hoisted_264 = ["onClick"]
const _hoisted_265 = ["onClick"]
const _hoisted_266 = { class: "w-5 h-5 min-w-[1.25rem] bg-pink-500 rounded flex items-center justify-center" }
const _hoisted_267 = ["onClick"]
const _hoisted_268 = ["onClick"]
const _hoisted_269 = ["href", "onClick"]
const _hoisted_270 = {
  key: 2,
  class: "bg-white rounded-lg border border-gray-200 shadow-sm p-6"
}
const _hoisted_271 = { class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" }
const _hoisted_272 = ["onClick"]
const _hoisted_273 = ["src", "alt"]
const _hoisted_274 = {
  key: 1,
  class: "text-black text-sm"
}
const _hoisted_275 = { class: "p-4" }
const _hoisted_276 = { class: "mb-2" }
const _hoisted_277 = { class: "font-bold xl:font-medium text-sm text-black truncate" }
const _hoisted_278 = { class: "mt-1 flex items-center gap-2" }
const _hoisted_279 = ["value", "disabled", "onChange"]
const _hoisted_280 = { class: "mt-1 flex items-center gap-2" }
const _hoisted_281 = ["value", "disabled", "onChange"]
const _hoisted_282 = { class: "text-xs text-black mt-1" }
const _hoisted_283 = { class: "flex items-center gap-4 mb-3" }
const _hoisted_284 = { class: "flex items-center gap-2 text-xs" }
const _hoisted_285 = ["checked", "onChange"]
const _hoisted_286 = ["onClick"]

import { ref, computed, onMounted, onUnmounted, nextTick, watch } from "vue";
import {
  PageHeader,
  ProductFilters,
  ProductBulkActions,
  ProductMeaRowModal,
  UnifiedPagination,
  ConfirmModal,
  ModalComp,
  BaseInput,
} from "@/components";
//import { genererProduitsCatalogue } from '@/data'
import {
  getProductsPage,
  getTotalProduitsByVendeur,
  updateProduit,
  updateProduitPromotion,
  duplicateProduit,
  duplicateProduitForMel,
  updateProduitCouleursProduit,
  updateProduitCouleur,
  getProduitCompositions,
  getProduitDescription,
  getProvenances,
  softDeleteProduits,
  restoreProduit,
  restoreProduits,
  setProduitsVisible,
  getProduitCouleurs,
  getProductAcheteurUrl,
  getProduitStocks,
  duplicateWithNewColor,
  toggleMainProduct,
  getAllUsedColorIdsByMainProduct,
  publishBrouillon,
  publishBrouillonBulk,
  upsertProduitStock,
  previewProduitLink,
  applyProduitLink,
} from "@/api/produits";
import type {
  ProduitLinkDuplicateColorGroup,
  ProduitLinkPreview,
  ProduitLinkPreviewItem,
  ProduitLinkReferenceBaseOption,
} from "@/api/produits";
import type { Produit, FilterProduitInput, ProduitCatalogue } from "@/types";
import type { Filters } from "@/types/filter";
import { getVendeurMarques } from "@/api/brands";
import { getCouleursOfficielles } from "@/api/couleurs";
import { getColorSwatchStyle } from "@/utils/colorFamilies";
import { getMelUnitWeightError } from "@/utils/melCompositions";
import {
  formatDescriptionPaquet,
  parseDescriptionPaquet,
} from "@/utils/descriptionPaquet";
import type { Brand } from "@/types/brand";

import { getCategoriesTree } from "@/api/categories";
import type { CategorieNode } from "@/types/categorie";
import { getCollections } from "@/api/collections";
import type { CollectionOption } from "@/api/collections";
import { getDeclinaisonById } from "@/api/gammesTailles";
import { useAuthStore } from "@/stores/auth";
import { useProductsStore } from "@/stores/productsStore";
import ProductColorsModal from "@/components/modals/ProductColorsModal.vue";
import NewColorsModal from "@/components/modals/NewColorsModal.vue";
import ProductSheetModal from "@/components/modals/ProductSheetModal.vue";
import type { ColorOption } from "@/components/modals/NewColorsModal.vue";
import { useMelStore } from "@/stores/melStore";
import { useRouter, useRoute } from "vue-router";
import { PackOption } from "@/types/packOption";
import { ProvenanceOption } from "@/types/provenanceOption";
import ListProduitTable from "@/components/tables/ListProduitTable.vue";
import { useNotification } from "@/composables/useNotification";
import { useBodyScrollLock } from "@/composables/useBodyScrollLock";
import {
  getProductPhotosBatch,
  getReferenceData,
  uploadProductPhotos,
} from "@/api/shooting";
import {
  fetchRest,
  getProductImageUrl as getProductStorageUrl,
} from "@/config/api";
import { bumpPhotoVersion, getPhotoVersion } from "@/utils/photoVersion";
import { getRemises } from "@/api/discounts";
import {
  exportStockExcel,
  importStockExcel,
  validateStockExcel,
} from "@/api/stock";

interface VendeurDeclinaison {
  id_declinaison: number;
  id_vendeur: number;
  titre: string; // ex: "SMLXL" / "34-42"
  tailles: string; // ex: "S,M,L,XL" 或 "34,36,38,40,42"
}

// Router (déclaré en premier pour être utilisé dans les refs)
type ImportSheetResult = {
  total: number;
  updated: number;
  errors: { ligne: number; message: string }[];
};
type PendingMainPick = {
  oldMainId: number;
  oldMainRef: string;
  candidates: ProduitCatalogue[];
};
type ChooseMainGroup = {
  oldMainId: number;
  oldMainRef: string;
  selectedId: number;
  candidates: ProduitCatalogue[];
};
const BULK_WHOLE_GROUP_OFFLINE = -1;

type DelinkMainGroup = {
  oldMainId: number;
  oldMainRef: string;
  selectedId: number | null;
  candidates: ProduitCatalogue[];
  remainingProducts: ProduitCatalogue[];
};
interface ColorStockRow {
  id_produit_stock?: number;
  id_couleur: number;
  colorLabel: string;
  quantity: number | null;
  hexColor?: string;
}
const ID_COULEUR_MELANGEES = 43;

// Global store-wide discount (remise) percentage if active (type 1)

type ProductRowWithMeta = ProduitCatalogue & { isChild?: boolean };

type BulkDeleteMainGroup = {
  liaison: string;
  oldMain: ProduitCatalogue;
  successors: ProduitCatalogue[];
};

type BulkInvisibleGroup = {
  liaison: string;
  oldMain: ProduitCatalogue;
  successors: ProduitCatalogue[];
};

const RESTORE_BASE_PROMPT = "Indiquez une nouvelle référence de base";


export default /*@__PURE__*/_defineComponent({
  __name: 'ProductListView',
  setup(__props) {

const route = useRoute();
const router = useRouter();

// Stores
const melStore = useMelStore();
const authStore = useAuthStore();
const productsStore = useProductsStore();

// UPGR user detection
const isUpgrUser = computed(() => String((authStore.user as any)?.mel) === "1");

// État global de la page
const products = ref<ProduitCatalogue[]>([]);
const selectedProducts = ref<number[]>([]);

const isFiltering = ref(false);
const viewMode = ref<"list" | "grid">("list");
const activeTab = ref<"en_ligne" | "brouillon" | "supprime">("en_ligne");
const isInitialLoad = ref(true); // Flag pour éviter de réinitialiser la page au premier chargement

// Détection du zoom arrière (pinch-to-zoom out) pour basculer en 2 colonnes
const isZoomedOut = ref(false);

const checkZoomLevel = () => {
  if (window.visualViewport) {
    isZoomedOut.value = window.visualViewport.scale < 0.85;
  }
};
// Pagination persistée via URL query params
const currentPage = ref(Number(route.query.page) || 1);
const itemsPerPage = ref(10);
// Active server-side filters coming from ProductFilters component
const activeFilters = ref<Filters | null>(null);
const brands = ref<Brand[]>([]);
const declinaisons = ref<VendeurDeclinaison[]>([]);

const categoriesTree = ref<CategorieNode[]>([]);
const collections = ref<CollectionOption[]>([]);
const colorModalVisible = ref(false);
const activeProductForColors = ref<ProduitCatalogue | null>(null);
const allColors = ref<ColorOption[]>([]);
const selectedColorIds = ref<number[]>([]);
const colorsWithQuantitiesForModal = ref<
  Array<{ id_couleur: number; quantitesParTaille?: number[] }>
>([]);
const taillesListForModal = ref<string[]>([]);
const disabledColorIdsForModal = ref<number[]>([]);
const packs = ref<PackOption[]>([]);
const ficheModalVisible = ref(false);
const activeProductForSheet = ref<ProduitCatalogue | null>(null);
// Photo de couverture "en attente" (choisie dans la modal, pas encore enregistrée)
const pendingCoverByProductId = ref<Record<number, string>>({});
const provenances = ref<ProvenanceOption[]>([]);
const showStockImportModal = ref(false);
const stockExporting = ref(false);
const stockImportFile = ref<File | null>(null);
const stockImporting = ref(false);
const stockValidating = ref(false);
let stockValidationRun = 0;
const stockImportResult = ref<{
  stock: ImportSheetResult;
  promo: ImportSheetResult;
} | null>(null);
const stockImportTotalErrors = computed(
  () =>
    (stockImportResult.value?.stock.errors.length || 0) +
    (stockImportResult.value?.promo.errors.length || 0),
);

const resetStockImportState = () => {
  stockValidationRun++;
  stockImportFile.value = null;
  stockImportResult.value = null;
  stockValidating.value = false;
  stockImporting.value = false;
};

const openStockImportModal = () => {
  resetStockImportState();
  showStockImportModal.value = true;
};

const closeStockImportModal = () => {
  showStockImportModal.value = false;
  resetStockImportState();
};

const handleExportStock = async () => {
  const id_vendeur = authStore.user?.id;
  if (!id_vendeur) return;
  stockExporting.value = true;
  try {
    await exportStockExcel(id_vendeur);
  } catch (err: any) {
    alert(err.message || "Erreur lors de l'export");
  } finally {
    stockExporting.value = false;
  }
};

const onStockFileSelected = async (e: Event) => {
  const target = e.target as HTMLInputElement;
  stockImportFile.value = target.files?.[0] || null;
  stockImportResult.value = null;

  if (!stockImportFile.value) return;

  stockValidating.value = true;
  const validationRun = ++stockValidationRun;
  try {
    const result = await validateStockExcel(stockImportFile.value);
    if (validationRun === stockValidationRun) {
      stockImportResult.value = result;
    }
  } catch (err: any) {
    if (validationRun === stockValidationRun) {
      stockImportResult.value = {
        stock: { total: 0, updated: 0, errors: [] },
        promo: {
          total: 0,
          updated: 0,
          errors: [
            { ligne: 0, message: err.message || "Erreur de validation" },
          ],
        },
      };
    }
  } finally {
    if (validationRun === stockValidationRun) {
      stockValidating.value = false;
    }
  }
};

const handleImportStock = async () => {
  if (!stockImportFile.value) return;
  stockImporting.value = true;
  try {
    const result = await importStockExcel(stockImportFile.value);

    notification.success(
      `Catalogue importé : stock ${result.stock.updated}/${result.stock.total}, promotions ${result.promo.updated}/${result.promo.total} lignes mises à jour`,
    );

    closeStockImportModal();

    await loadProducts();
    productStocksMap.value.clear();
  } catch (err: any) {
    alert(err.message || "Erreur lors de l'import");
  } finally {
    stockImporting.value = false;
  }
};

const duplicateConfirmVisible = ref(false);
const productToDuplicateId = ref<number | null>(null);
const duplicateOriginalRef = ref("");
const duplicateNewReference = ref("");
const isDuplicating = ref(false);
const deleteConfirmVisible = ref(false);
const bulkDeleteSuccessorChoices = ref<Map<string, number | null>>(new Map());
const deleteMainConfirmVisible = ref(false);
const deleteMainPending = ref<{
  product: ProduitCatalogue;
  successorId: number | null;
  successors: ProduitCatalogue[];
} | null>(null);
const makeVisibleConfirmVisible = ref(false);
const makeInvisibleConfirmVisible = ref(false);
useBodyScrollLock(makeInvisibleConfirmVisible);
const isBulkMakingInvisible = ref(false);
const bulkInvisibleSuccessorChoices = ref<Map<string, number | null>>(
  new Map(),
);
const bulkInvisibleGroupSearch = ref("");
const singleVisibilityMainConfirmVisible = ref(false);
const isPromotingMainChange = ref(false);
// Modal "choisir une nouvelle principale" quand la principale n'a pas de photo
const chooseMainModalVisible = ref(false);
const chooseMainCandidates = ref<ProduitCatalogue[]>([]);
const chooseMainSelectedId = ref<number | null>(null);
const chooseMainOldMainId = ref<number | null>(null);
const isChoosingMain = ref(false);
// === Bulk publish: file d'attente des groupes "principale sans photo" ===
const bulkPendingMainPicks = ref<PendingMainPick[]>([]);
const bulkReadyPublishIds = ref<number[]>([]);
const isBulkChooseMainFlow = ref(false);
// Groupes affichés simultanément dans la modale (flux bulk multi-groupes)
const chooseMainGroups = ref<ChooseMainGroup[]>([]);
// La modale affiche plusieurs groupes (flux bulk) dès qu'il y en a au moins un
const isMultiGroupChoose = computed(() => chooseMainGroups.value.length > 0);
const chooseMainModalMessage = computed(() =>
  isMultiGroupChoose.value
    ? "Certaines couleurs principales n'ont pas de photo et ne peuvent pas être mises en ligne. Choisissez pour chaque groupe une autre couleur (avec photo) qui deviendra la nouvelle principale. L'ancienne principale restera en brouillon comme variante."
    : "La couleur principale actuelle n'a pas de photo et ne peut pas être mise en ligne. Choisissez une autre couleur (avec photo) qui prendra sa place comme nouvelle couleur principale. L'ancienne principale restera en brouillon comme variante.",
);
const chooseMainConfirmDisabled = computed(
  () =>
    isChoosingMain.value ||
    (isMultiGroupChoose.value
      ? chooseMainGroups.value.some((g) => !g.selectedId)
      : !chooseMainSelectedId.value),
);
const isSettingMainProduct = ref(false);
const invisibleSecondaryToMainConfirmVisible = ref(false);
const pendingSetMainProductId = ref<number | null>(null);
/** Sentinelle bulk : tout le groupe hors ligne (pas de nouveau principal). */
const singleVisibilityPending = ref<{
  productId: number;
  value: boolean;
  successorId?: number | null;
  wholeGroupOffline?: boolean;
} | null>(null);
const linkColorsConfirmVisible = ref(false);
const linkPreviewLoading = ref(false);
const linkApplying = ref(false);
const linkPreview = ref<ProduitLinkPreview | null>(null);
const selectedLinkMainId = ref<number | null>(null);
const duplicateColorKeepByKey = ref<Record<string, number>>({});
const selectedTargetReferenceBase = ref<string | null>(null);
const linkPreviewImageByProductId = ref<Record<number, string>>({});
const linkExtraProductIds = ref<number[]>([]);
const delinkColorsConfirmVisible = ref(false);
const delinkApplying = ref(false);
const delinkMainGroups = ref<DelinkMainGroup[]>([]);
const publishBrouillonConfirmVisible = ref(false);
const bulkPublishConfirmVisible = ref(false);
const productToPublishId = ref<number | null>(null);
const meaModalVisible = ref(false);
const singleProductMeaReference = ref<string | null>(null);
const openActionMenuId = ref<number | null>(null);
const actionMenuPosition = ref({ top: 0, left: 0 });

// État pour le modal "Ajouter une couleur" (créer variante)
const addColorModalVisible = ref(false);
const productForAddColor = ref<ProduitCatalogue | null>(null);
// ID du produit principal (liaison) utilisé pour créer une nouvelle variante couleur
const addColorSourceProductId = ref<number | null>(null);

// Cache des couleurs utilisées par liaison (clé: id_produit principal, valeur: Set de id_couleur)
// Ce cache est rempli lors du chargement des produits pour éviter les problèmes de pagination
const liaisonColorsCache = ref<Map<number, Set<number>>>(new Map());

// Normaliser un id_couleur en number
const toColorId = (v: unknown): number | null => {
  if (v == null || v === "") return null;
  const n = Number(v);
  return Number.isNaN(n) ? null : n;
};

// Même critère que groupedProducts : l'id du produit principal = liaison (string).
// Donc mainId = Number(liaison) ou id_couleur_liee ou id du produit courant.
const getMainProductId = (p: ProduitCatalogue): number => {
  const lid = p.liaison?.trim();
  if (lid && lid !== "0") {
    const n = Number(lid);
    if (!Number.isNaN(n)) return n;
  }
  return Number((p as any).id_couleur_liee) || Number(p.id);
};

/**
 * Retourne la catégorie effectivement enregistrée pour un produit.
 *
 * Les lignes chargées par l'API portent encore `id_categorie`, alors que les
 * sélecteurs de la liste utilisent les trois niveaux `catLevel*Id`.  Utiliser
 * uniquement le niveau 3 ici faisait considérer un produit catégorisé comme
 * « sans catégorie » (et inversement après une édition partielle).
 */
const getProductCategoryId = (product: ProduitCatalogue): number | null => {
  const raw =
    product.catLevel3Id ??
    product.catLevel2Id ??
    product.catLevel1Id ??
    (product as any).id_categorie;
  const id = Number(raw);
  return Number.isFinite(id) && id > 0 ? id : null;
};

const findCategoryNode = (
  nodes: CategorieNode[],
  id: number,
): CategorieNode | null => {
  for (const node of nodes) {
    if (Number(node.id_categorie) === id) return node;
    const child = node.children?.length
      ? findCategoryNode(node.children, id)
      : null;
    if (child) return child;
  }
  return null;
};

const getPublishBlocker = (product: ProduitCatalogue): string | null => {
  const categoryId = getProductCategoryId(product);
  if (!categoryId) {
    return "Une catégorie est obligatoire avant la mise en ligne.";
  }
  const categoryNode = findCategoryNode(categoriesTree.value, categoryId);
  if (categoryNode?.children?.length) {
    return "Une catégorie finale est obligatoire avant la mise en ligne.";
  }
  if (Number(product.nb_photos ?? 0) <= 0) {
    return "Au moins une photo est obligatoire avant la mise en ligne.";
  }
  const weight = Number(product.poids);
  if (!Number.isFinite(weight) || weight <= 0) {
    return "Le poids du produit doit être renseigné avant la mise en ligne.";
  }
  return null;
};

const getPublishBlockerWithoutPhotos = (product: ProduitCatalogue): string | null => {
  if (!getProductCategoryId(product)) {
    return "Une catégorie est obligatoire avant la mise en ligne.";
  }
  const weight = Number(product.poids);
  if (!Number.isFinite(weight) || weight <= 0) {
    return "Le poids du produit doit être renseigné avant la mise en ligne.";
  }
  return null;
};

const hasVisibleProductInGroup = (product: ProduitCatalogue): boolean => {
  const groupId = getMainProductId(product);
  return products.value.some(
    (candidate) =>
      candidate.visible && getMainProductId(candidate) === groupId,
  );
};

// Produits liés au principal : exactement le même groupe que l'UI (groupedProducts).
// Groupe = tous les produits avec la même liaison (liaison = id du produit principal).
const getProductsLinkedToMain = (currentProduct: ProduitCatalogue) => {
  const mainId = getMainProductId(currentProduct);
  const mainIdStr = String(mainId);
  return products.value.filter(
    (p) =>
      p.liaison != null &&
      p.liaison !== "" &&
      p.liaison !== "0" &&
      String(p.liaison).trim() === mainIdStr,
  );
};

// Couleurs déjà utilisées = couleurs du produit principal + toutes les couleurs liées au principal
// (même logique que l'affichage des groupes : liaison = id principal, on prend tout le groupe).
const usedColorIdsInLiaison = computed(() => {
  if (!productForAddColor.value) return [];

  const currentProduct = productForAddColor.value;
  const mainId = getMainProductId(currentProduct);
  const usedIds = new Set<number>();

  // 1. Cache (Priorité aux données fraîches venant du backend pour ce mainId)
  const cachedColors = liaisonColorsCache.value.get(mainId);
  if (cachedColors && cachedColors.size > 0) {
    cachedColors.forEach((id) => usedIds.add(id));
  }

  const addColorsFromProduct = (p: ProduitCatalogue) => {
    const cid = toColorId((p as any).id_couleur);
    if (cid != null) usedIds.add(cid);
    if (p.colorIds && Array.isArray(p.colorIds)) {
      p.colorIds.forEach((cid: unknown) => {
        const n = toColorId(cid);
        if (n != null) usedIds.add(n);
      });
    }
  };

  // 2. Couleurs du produit courant
  addColorsFromProduct(currentProduct);

  // 3. Toutes les couleurs des produits liés au principal (ceux chargés dans la page)
  const linkedToMain = getProductsLinkedToMain(currentProduct);
  for (const p of linkedToMain) {
    addColorsFromProduct(p);
  }

  return Array.from(usedIds);
});

// Stock data per product (keyed by product id)
const productStocksMap = ref<Map<number, ColorStockRow[]>>(new Map());
const loadingStocksForProduct = ref<Set<number>>(new Set());
// id_couleur système pour vendu_par = melangees (aligné StockManagementView / config PHP)
const notification = useNotification();
const notifySuccess = (message: string, duration = 3000) => {
  notification.show("success", message, duration);
};

const notifyError = (message: string, duration = 3000) => {
  notification.show("error", message, duration);
};

const notifyWarning = (message: string, duration = 3000) => {
  notification.show("warning", message, duration);
};

const loadProvenances = async () => {
  provenances.value = await getProvenances();
};

const readOptionalPrice = (value: unknown): number | null => {
  if (value == null || value === "") return null;
  const n = typeof value === "number" ? value : Number(value);
  return Number.isFinite(n) ? n : null;
};

// Une promotion n'existe que si le prix est strictement positif.
// 0 et une chaîne vide signifient « pas de promotion ».
const readPositivePrice = (value: unknown): number | null => {
  const price = readOptionalPrice(value);
  return price != null && price > 0 ? price : null;
};

// Valeur affichée dans l'input Promotion:
// - si le produit a un prix réduit strictement positif, on l'affiche
// - sinon, si le produit a une promotion propre strictement positive, on l'affiche
// - sinon, champ vide
const getPromotionInputValue = (row: ProduitCatalogue): string => {
  const price =
    readPositivePrice(row.prixReduit) ?? readPositivePrice(row.promotion);
  return price == null ? "" : price.toFixed(2);
};

const formatPromotionLabel = (row: ProduitCatalogue): string => {
  const value = getPromotionInputValue(row);
  return value === "" ? "—" : `${value} €`;
};

// Helper: API base (Nest backoffice). Resolve from multiple env names used across the app, fallback to same-origin
const getApiBase = (): string => {
  const metaEnv: any = (import.meta as any)?.env || {};
  const pe: any = (process as any)?.env || {};

  const candidates = [
    pe.VUE_APP_API_BASE_URL as string | undefined,
    metaEnv.VUE_APP_API_BASE_URL as string | undefined,
    metaEnv.VITE_API_BASE_URL as string | undefined,
    metaEnv.VITE_BACKOFFICE_BASE_URL as string | undefined,
  ].filter((v): v is string => typeof v === "string" && v.length > 0);

  let base = candidates[0];
  if (!base && typeof window !== "undefined" && window.location?.origin) {
    base = window.location.origin;
  }
  return base ? base.replace(/\/$/, "") : "";
};

// Try to get first uploaded product photo from backoffice uploads (preferred)
// Endpoint implemented in backend: GET /images/product-photos/:productId (auth required)
const fetchPreferredProductPhoto = async (
  idProduit: number,
): Promise<string | undefined> => {
  const base = getApiBase();
  if (!base) return undefined;
  try {
    const res = await fetchRest(`${base}/images/product-photos/${idProduit}`);
    if (!res.ok) return undefined;
    const data: any = await res.json();
    const first: string | undefined =
      Array.isArray(data?.photos) && data.photos.length > 0
        ? data.photos[0]
        : undefined;
    if (first) {
      return getProductStorageUrl(first);
    }
  } catch {
    // silent – fall back to legacy
  }
  return undefined;
};

const loadColors = async () => {
  const couleurs = await getCouleursOfficielles();
  const byId = new Map<number, ColorOption>();

  for (const c of couleurs) {
    const label = c.couleur_FR?.trim();
    if (!label) continue;
    const id = Number(c.id_couleur);
    if (!Number.isFinite(id) || byId.has(id)) continue;
    byId.set(id, {
      id_couleur: id,
      label,
      hexColor: c.hexColor || null,
      motifCategorie: c.motifCategorie ?? null,
      idCouleurEfashion: c.idCouleurEfashion ?? null,
      officiel: c.officiel ?? 1,
    });
  }

  allColors.value = [...byId.values()].sort((a, b) =>
    a.label.localeCompare(b.label, "fr"),
  );
};

const colorHexByLabel = computed(() => {
  const map = new Map<string, string | null>();
  for (const c of allColors.value) {
    map.set(c.label, c.hexColor ?? null);
  }
  return map;
});

const getRowColorSwatches = (row: ProductRowWithMeta) => {
  const details = row.couleursDetail;
  if (details?.length) {
    return details.map((c) => ({
      label: c.couleur_FR || `#${c.id_couleur}`,
      style: getColorSwatchStyle(c.couleur_FR || "", c.hexColor ?? null),
    }));
  }

  return getColorLabelsFromRow(row).map((label) => ({
    label,
    style: getColorSwatchStyle(label, colorHexByLabel.value.get(label) ?? null),
  }));
};

const getColorLabelsFromRow = (row: ProduitCatalogue): string[] => {
  if (row.couleursDetail?.length) {
    return row.couleursDetail
      .map((c) => c.couleur_FR?.trim())
      .filter(Boolean) as string[];
  }
  const raw = row.couleur;
  if (!raw || typeof raw !== "string") return [];
  return raw
    .split(",")
    .map((l) => l.trim())
    .filter(Boolean);
};

const getRowColorSwatchTitle = (row: ProductRowWithMeta) => {
  const labels = getColorLabelsFromRow(row);
  if (!labels.length) return "Choisir une couleur";
  return labels.join(", ");
};

const loadMelReferenceData = async () => {
  const data = await getReferenceData();

  packs.value = data.packs.map((p: any) => ({
    id_pack: p.id,
    id_vendeur: authStore.user?.id ?? 0,
    titre: p.label,
    valeur: p.value,
  }));

  // MEL 里的 déclinaisons: { id, label, value, tailles }
  //  VendeurDeclinaison
  declinaisons.value = data.declinaisons.map((d: any) => ({
    id_declinaison: d.id,
    id_vendeur: authStore.user?.id ?? 0,
    titre: d.label,
    tailles: d.tailles,
  }));
};
const loadCollections = async () => {
  collections.value = await getCollections("fr");
};
const loadBrands = async () => {
  brands.value = await getVendeurMarques();
};

const areAllCurrentSelected = computed(() => {
  const idsOnPage = filteredProducts.value
    .filter((p) => canSelectProduct(p))
    .map((p) => p.id);
  if (idsOnPage.length === 0) return false;
  return idsOnPage.every((id) => selectedProducts.value.includes(id));
});

// Computed property pour obtenir les références des produits sélectionnés
const selectedProductsForDeletion = computed(() => {
  const selectedIds = new Set(selectedProducts.value.map(Number));
  return products.value.filter((product) =>
    selectedIds.has(Number(product.id)),
  );
});

const selectedProductsReferences = computed(() => {
  return selectedProductsForDeletion.value
    .map((product) => {
      const reference = product.reference?.trim();
      if (!reference) return null;
      const couleur = product.couleur?.trim();
      return couleur ? `${reference} · ${couleur}` : reference;
    })
    .filter((label): label is string => Boolean(label));
});

const linkPreviewProducts = computed<ProduitLinkPreviewItem[]>(() => {
  const productsAfter = linkPreview.value?.groupAfter?.products ?? [];
  return [...productsAfter].sort((a, b) => {
    if (a.willBeMain !== b.willBeMain) return a.willBeMain ? -1 : 1;
    return (a.reference || `#${a.id_produit}`).localeCompare(
      b.reference || `#${b.id_produit}`,
    );
  });
});

const linkMainCandidates = computed<ProduitLinkPreviewItem[]>(() => {
  return linkPreviewProducts.value.length
    ? linkPreviewProducts.value
    : (linkPreview.value?.groupsBefore ?? []).flatMap((g) => g.products);
});

const productCatalogueById = computed(() => {
  const map = new Map<number, ProduitCatalogue>();
  products.value.forEach((product) => {
    map.set(Number(product.id), product);
  });
  return map;
});

const isAddToExistingGroupPreview = computed(
  () => linkExtraProductIds.value.length > 0,
);

const linkRequestProductIds = computed(() =>
  Array.from(
    new Set(
      [...selectedProducts.value, ...linkExtraProductIds.value]
        .map((id) => Number(id))
        .filter((id) => Number.isFinite(id) && id > 0),
    ),
  ),
);

const getCatalogueProductForPreview = (
  product: ProduitLinkPreviewItem,
): ProduitCatalogue | null => {
  return productCatalogueById.value.get(Number(product.id_produit)) ?? null;
};

const getLinkPreviewProductImageUrl = (
  product: ProduitLinkPreviewItem,
): string => {
  const catalogueProduct = getCatalogueProductForPreview(product);
  const catalogueImage = catalogueProduct
    ? getProductImageUrl(catalogueProduct)
    : "";
  return (
    catalogueImage ||
    linkPreviewImageByProductId.value[Number(product.id_produit)] ||
    ""
  );
};

const loadLinkPreviewImages = async (productIds: number[]) => {
  const ids = Array.from(
    new Set(
      productIds
        .map((id) => Number(id))
        .filter((id) => Number.isFinite(id) && id > 0),
    ),
  ).filter((id) => !linkPreviewImageByProductId.value[id]);

  if (!ids.length) return;

  try {
    const chunkSize = 100;
    const nextImages = { ...linkPreviewImageByProductId.value };
    for (let i = 0; i < ids.length; i += chunkSize) {
      const chunk = ids.slice(i, i + chunkSize);
      const { success, photosByProduct } = await getProductPhotosBatch(chunk);
      if (!success || !photosByProduct) continue;

      Object.entries(photosByProduct).forEach(([id, photos]) => {
        const first = Array.isArray(photos) && photos.length ? photos[0] : "";
        if (first) nextImages[Number(id)] = getProductStorageUrl(first);
      });
    }
    linkPreviewImageByProductId.value = nextImages;
  } catch {
    // Les images sont décoratives dans cette prévisualisation.
  }
};

const linkProductSourceLabel = (product: ProduitLinkPreviewItem): string =>
  product.selected ? "Choisi" : "Inclus par groupe";

const linkProductSourceClass = (product: ProduitLinkPreviewItem): string =>
  product.selected ? "text-gray-500" : "text-gray-400";

const linkProductSourceIcon = (product: ProduitLinkPreviewItem): string =>
  product.selected ? "fas fa-check text-[9px]" : "fas fa-link text-[9px]";

const duplicateColorKeepProductIds = computed(() =>
  Object.values(duplicateColorKeepByKey.value)
    .map((id) => Number(id))
    .filter((id) => Number.isInteger(id) && id > 0),
);

const targetReferenceBaseForRequest = computed(
  () =>
    selectedTargetReferenceBase.value ??
    linkPreview.value?.targetReferenceBase ??
    null,
);

const linkWarningsVisible = computed(() =>
  (linkPreview.value?.warnings ?? []).slice(0, 2),
);

const linkWarningsHiddenCount = computed(() =>
  Math.max(
    (linkPreview.value?.warnings?.length ?? 0) -
      linkWarningsVisible.value.length,
    0,
  ),
);

const linkPreviewMessage = computed(() => {
  if (linkPreviewLoading.value) return "Calcul de l'impact...";
  if (!linkPreview.value) {
    return "Choisissez le produit principal.";
  }

  const affected = linkPreview.value.affectedProductIds.length;
  const selected = linkRequestProductIds.value.length;
  const extra = Math.max(affected - selected, 0);
  const main = linkPreviewProducts.value.find((p) => p.willBeMain);
  const mainRef =
    main?.reference ??
    (selectedLinkMainId.value ? `#${selectedLinkMainId.value}` : "");
  const parts = [`${affected} produit(s)`];
  if (extra > 0) parts.push(`+${extra} inclus`);
  if (mainRef) parts.push(`principal: ${mainRef}`);

  return mainRef
    ? parts.join(" · ")
    : `${parts.join(" · ")} · principal à choisir`;
});

const linkPreviewConfirmDisabled = computed(() => {
  return (
    linkPreviewLoading.value ||
    linkApplying.value ||
    !selectedLinkMainId.value ||
    !linkPreview.value?.canApply ||
    !linkPreview.value?.confirmationToken
  );
});

const effectiveLinkReferenceBase = (
  product: ProduitLinkPreviewItem,
): string | null => {
  return (product.reference_base || product.reference || "").trim() || null;
};

const linkReferenceBaseChanged = (product: ProduitLinkPreviewItem): boolean => {
  const currentReferenceBase = effectiveLinkReferenceBase(product);
  const nextReferenceBase = (product.next_reference_base || "").trim() || null;
  return Boolean(
    nextReferenceBase && nextReferenceBase !== currentReferenceBase,
  );
};

const linkReferenceChanged = (product: ProduitLinkPreviewItem): boolean => {
  const nextReference = (product.next_reference || "").trim();
  const currentReference = (product.reference || "").trim();
  return Boolean(nextReference && nextReference !== currentReference);
};

const isDuplicateColorKeeper = (
  group: ProduitLinkDuplicateColorGroup,
  productId: number,
): boolean => {
  const selectedKeepId =
    duplicateColorKeepByKey.value[group.colorKey] ?? group.keepProductId;
  return Number(selectedKeepId) === Number(productId);
};

const isReferenceBaseSelected = (
  option: ProduitLinkReferenceBaseOption,
): boolean => {
  const selectedReferenceBase = targetReferenceBaseForRequest.value;
  return selectedReferenceBase === option.referenceBase;
};

const formatLinkStatus = (product: ProduitLinkPreviewItem): string => {
  if (product.supprimer) return "supprimé";
  if (String(product.premel ?? "").trim() === "1") return "brouillon";
  if (!product.visible) return "hors ligne";
  return "en ligne";
};

const linkStatusClass = (product: ProduitLinkPreviewItem): string => {
  const status = formatLinkStatus(product);
  if (status === "en ligne") return "bg-green-100 text-green-700";
  if (status === "brouillon") return "bg-amber-100 text-amber-700";
  if (status === "supprimé") return "bg-red-100 text-red-700";
  return "bg-gray-100 text-gray-700";
};

const formatCatalogueStatus = (product: ProduitCatalogue): string => {
  if (product.statut === "supprime") return "supprimé";
  if (product.premel === "1") return "brouillon";
  if (!product.visible || product.statut === "hors-ligne") return "hors ligne";
  if (product.statut === "rupture") return "rupture";
  return "en ligne";
};

const catalogueStatusClass = (product: ProduitCatalogue): string => {
  const status = formatCatalogueStatus(product);
  if (status === "en ligne") return "bg-green-100 text-green-700";
  if (status === "brouillon") return "bg-amber-100 text-amber-700";
  if (status === "supprimé" || status === "rupture")
    return "bg-red-100 text-red-700";
  return "bg-gray-100 text-gray-700";
};

// Détecte si un produit est une couleur principale (main ou id === liaison)
const isMainProduct = (
  p:
    | ProduitCatalogue
    | { id?: number; liaison?: string; main?: boolean | number },
): boolean => {
  if (!p) return false;
  const main = (p as any).main;
  if (main === true || main === 1) return true;
  if (p.liaison && String(p.id) === String(p.liaison)) return true;
  if (Number((p as any).id_couleur_liee) === Number(p.id)) return true;
  return false;
};

const isProductLocked = (product: any): boolean =>
  Boolean(product) &&
  (String((product as any).statut) === "supprime" ||
    Number((product as any).supprimer) === 1);

const canSelectProduct = (product: ProduitCatalogue): boolean => {
  if (activeTab.value === "supprime") return isProductLocked(product);
  return !isProductLocked(product);
};

const bulkDeleteMainGroups = computed<BulkDeleteMainGroup[]>(() => {
  const selectedIds = new Set(selectedProducts.value.map(Number));
  const selectedReferences = new Set(
    selectedProductsForDeletion.value
      .map((product) => product.reference?.trim())
      .filter((reference): reference is string => Boolean(reference)),
  );
  const groups = new Map<string, BulkDeleteMainGroup>();

  for (const oldMain of products.value.filter(
    (product) =>
      selectedIds.has(Number(product.id)) && isMainProduct(product),
  )) {
    const liaison = String(getMainProductId(oldMain));
    if (groups.has(liaison)) continue;

    const successors = getProductsLinkedToMain(oldMain).filter(
      (product) =>
        !selectedIds.has(Number(product.id)) &&
        !selectedReferences.has(product.reference?.trim() || "") &&
        !isProductLocked(product),
    );
    if (!successors.length) continue;

    groups.set(liaison, { liaison, oldMain, successors });
  }

  return Array.from(groups.values());
});

const bulkDeleteConfirmDisabled = computed(() =>
  bulkDeleteMainGroups.value.some(
    (group) => !bulkDeleteSuccessorChoices.value.get(group.liaison),
  ),
);

const deleteMainConfirmMessage = computed(() => {
  const product = deleteMainPending.value?.product;
  if (!product) return "";
  return `La couleur « ${product.reference} » est actuellement la couleur principale. Choisissez celle qui prendra sa place avant de la supprimer.`;
});

watch(
  () => products.value,
  () => {
    selectedProducts.value = selectedProducts.value.filter((id) => {
      const product = products.value.find((p) => p.id === id);
      return Boolean(product) && canSelectProduct(product as ProduitCatalogue);
    });
  },
  { deep: true },
);

// Trouve tous les siblings visibles (candidats pour devenir le nouveau produit principal)
const findVisibleSuccessors = (
  product: ProduitCatalogue,
): ProduitCatalogue[] => {
  const mainId = getMainProductId(product);
  return getProductsLinkedToMain(product).filter(
    (p) =>
      Number(p.id) !== Number(mainId) &&
      p.visible === true &&
      !isProductLocked(p) &&
      (p as any).premel !== "1",
  );
};

const buildDelinkMainGroups = (): DelinkMainGroup[] => {
  const selectedIds = new Set(selectedProducts.value.map((id) => Number(id)));
  const groups = new Map<number, DelinkMainGroup>();

  products.value
    .filter((product) => selectedIds.has(Number(product.id)))
    .filter((product) => isMainProduct(product))
    .forEach((oldMain) => {
      const oldMainId = Number(getMainProductId(oldMain));
      if (!Number.isFinite(oldMainId) || groups.has(oldMainId)) return;

      const remainingProducts = getProductsLinkedToMain(oldMain).filter(
        (product) =>
          !selectedIds.has(Number(product.id)) && !isProductLocked(product),
      );

      if (!remainingProducts.length) return;

      groups.set(oldMainId, {
        oldMainId,
        oldMainRef: oldMain.reference || `#${oldMain.id}`,
        selectedId: Number(remainingProducts[0].id),
        candidates: remainingProducts,
        remainingProducts,
      });
    });

  return Array.from(groups.values());
};

const delinkColorsMessage = computed(() => {
  const base = `Êtes-vous sûr de vouloir délier les couleurs pour ${selectedProducts.value.length} produit(s) ?`;
  if (!delinkMainGroups.value.length) return base;
  return `${base}\nLe produit principal sort d'un groupe : choisissez son remplaçant.`;
});

const delinkColorsConfirmDisabled = computed(() => {
  return (
    delinkApplying.value ||
    delinkMainGroups.value.some((group) => !group.selectedId)
  );
});

const bulkInvisiblePlan = computed(() => {
  const selectedIds = new Set(selectedProducts.value);
  const selected = products.value.filter((p) => selectedIds.has(p.id));
  const secondaryCount = selected.filter((p) => !isMainProduct(p)).length;
  const mainGroupsMap = new Map<string, BulkInvisibleGroup>();

  for (const product of selected.filter((p) => isMainProduct(p))) {
    const liaisonKey = String(getMainProductId(product));
    if (mainGroupsMap.has(liaisonKey)) continue;

    const oldMain =
      products.value.find(
        (p) => Number(p.id) === Number(liaisonKey) && isMainProduct(p),
      ) ?? product;

    const successors = findVisibleSuccessors(oldMain).filter(
      (s) => !selectedIds.has(s.id),
    );

    mainGroupsMap.set(liaisonKey, {
      liaison: liaisonKey,
      oldMain,
      successors,
    });
  }

  const allMainGroups = Array.from(mainGroupsMap.values());
  const groupsWithSuccessor = allMainGroups.filter(
    (g) => g.successors.length > 0,
  );

  return {
    secondaryCount,
    mainGroupCount: allMainGroups.length,
    groupsWithSuccessor,
  };
});

const bulkInvisibleModalMessage = computed(() => {
  const count = selectedProducts.value.length;
  const base = `Êtes-vous sûr de vouloir rendre invisible ${count} produit(s) ?`;
  const { mainGroupCount, groupsWithSuccessor } = bulkInvisiblePlan.value;

  if (mainGroupCount === 0) return base;

  const parts = [
    base,
    `\n${mainGroupCount} couleur(s) principale(s) concernée(s).`,
  ];

  if (groupsWithSuccessor.length > 0) {
    parts.push(
      `\nPour ${groupsWithSuccessor.length} groupe(s), choisissez la couleur qui prendra la place de la principale afin que la page reste visible.`,
    );
  }

  return parts.join("");
});

const filteredBulkGroupsWithSuccessor = computed(() => {
  const groups = bulkInvisiblePlan.value.groupsWithSuccessor;
  const query = bulkInvisibleGroupSearch.value.trim().toLowerCase();
  if (!query) return groups;

  return groups.filter((group) => {
    const ref = group.oldMain.reference?.toLowerCase() ?? "";
    const couleur = group.oldMain.couleur?.toLowerCase() ?? "";
    return ref.includes(query) || couleur.includes(query);
  });
});

const invisibleSecondaryToMainConfirmMessage = computed(() => {
  const pendingId = pendingSetMainProductId.value;
  const product = products.value.find(
    (p) => Number(p.id) === Number(pendingId),
  );
  const productRef = product?.reference ? ` "${product.reference}"` : "";
  return `Vous êtes sur le point de définir la couleur secondaire${productRef} en principale alors qu'elle est non visible.\n\nÊtes-vous sûr ? Tous les produits de ce groupe  ne seront plus visibles pour les acheteurs.`;
});

const singleVisibilityMainConfirmMessage = computed(() => {
  const pending = singleVisibilityPending.value;
  if (!pending) return "";

  const product = products.value.find((p) => p.id === pending.productId);
  const productRef = product?.reference ?? "";

  if (pending.wholeGroupOffline) {
    return `Vous êtes sur le point de mettre hors ligne toutes les couleurs du groupe${
      productRef ? ` de « ${productRef} »` : ""
    }.\n\nLa page produit ne sera plus visible pour les acheteurs. Cliquez sur Confirmer pour valider.`;
  }

  if (pending.successorId) {
    return `Vous êtes sur le point de mettre la couleur principale${
      productRef ? ` "${productRef}"` : ""
    } en non visible.\n\nSélectionnez ci-dessous la couleur qui prendra sa place comme nouvelle couleur principale. La page restera ainsi visible pour les acheteurs.`;
  }

  return `Attention : vous êtes sur le point de mettre la couleur principale${
    productRef ? ` "${productRef}"` : ""
  } en non visible.\n\nAucune autre couleur visible n'est disponible pour la remplacer : la page entière du produit deviendra invisible pour les acheteurs.\n\nSouhaitez-vous continuer ?`;
});

const meaModalReferences = computed(() => {
  if (singleProductMeaReference.value) {
    return [singleProductMeaReference.value];
  }
  return [];
});

const handleToggleSelectAll = (checked: boolean) => {
  const idsOnPage = filteredProducts.value
    .filter((p) => canSelectProduct(p))
    .map((p) => p.id);

  if (checked) {
    selectedProducts.value = Array.from(
      new Set([...selectedProducts.value, ...idsOnPage]),
    );
  } else {
    selectedProducts.value = selectedProducts.value.filter(
      (id) => !idsOnPage.includes(id),
    );
  }
};
const handleBulkDelete = () => {
  if (!selectedProducts.value.length) return;
  bulkDeleteSuccessorChoices.value = new Map(
    bulkDeleteMainGroups.value.map((group) => [group.liaison, null]),
  );
  deleteConfirmVisible.value = true;
};

const selectBulkDeleteSuccessor = (
  liaison: string,
  successorId: number,
) => {
  const next = new Map(bulkDeleteSuccessorChoices.value);
  next.set(liaison, successorId);
  bulkDeleteSuccessorChoices.value = next;
};

const cancelBulkDelete = () => {
  deleteConfirmVisible.value = false;
  bulkDeleteSuccessorChoices.value = new Map();
};

const confirmBulkDelete = async () => {
  if (!selectedProducts.value.length || bulkDeleteConfirmDisabled.value) {
    deleteConfirmVisible.value = false;
    return;
  }

  const ids = [...selectedProducts.value];

  try {
    // Le vendeur choisit explicitement le successeur de chaque couleur
    // principale supprimée. Aucun remplaçant n'est sélectionné implicitement.
    for (const group of bulkDeleteMainGroups.value) {
      const successorId = bulkDeleteSuccessorChoices.value.get(group.liaison);
      if (successorId) await toggleMainProduct(successorId);
    }

    await softDeleteProduits(ids);
    selectedProducts.value = [];
    await loadProducts();
    notifySuccess("Produits supprimés avec succès.");
  } catch (e) {
    notifyError("Erreur lors de la suppression des produits.");
    await loadProducts();
  } finally {
    deleteConfirmVisible.value = false;
    bulkDeleteSuccessorChoices.value = new Map();
  }
};

const restoreErrorMessage = (error: unknown): string =>
  error instanceof Error ? error.message : "Erreur lors de la réactivation des produits.";

const askReplacementReferenceBase = (message: string): string | null => {
  const nextBase = window.prompt(`${message}\n\nNouvelle référence de base :`, "");
  const trimmed = nextBase?.trim() ?? "";
  return trimmed.length > 0 ? trimmed : null;
};

const restoreProductsWithBaseFallback = async (ids: number[]) => {
  try {
    if (ids.length === 1) {
      await restoreProduit(ids[0]);
      return;
    }
    await restoreProduits(ids);
  } catch (error) {
    const message = restoreErrorMessage(error);
    if (!message.includes(RESTORE_BASE_PROMPT)) throw error;
    const replacement = askReplacementReferenceBase(message);
    if (!replacement) throw error;
    for (const id of ids) {
      await restoreProduit(id, replacement);
    }
  }
};

const handleBulkReactivate = async () => {
  if (!selectedProducts.value.length) return;

  const ids = [...selectedProducts.value];
  try {
    await restoreProductsWithBaseFallback(ids);
    selectedProducts.value = [];
    await loadProducts();
    notifySuccess("Produits réactivés avec succès.");
  } catch (e) {
    notifyError(restoreErrorMessage(e));
    selectedProducts.value = [];
    await loadProducts();
  }
};

const handleBulkMakeVisible = () => {
  if (!selectedProducts.value.length) return;
  makeVisibleConfirmVisible.value = true;
};

const confirmBulkMakeVisible = async () => {
  if (!selectedProducts.value.length) {
    makeVisibleConfirmVisible.value = false;
    return;
  }

  const idsArray = [...selectedProducts.value];
  const selected = products.value.filter((p) => idsArray.includes(p.id));
  const blocked = selected.find((p) => getPublishBlocker(p));
  if (blocked) {
    makeVisibleConfirmVisible.value = false;
    notifyError(
      `${blocked.reference} : ${getPublishBlocker(blocked)}`,
    );
    return;
  }

  try {
    await setProduitsVisible(idsArray, true);
    selectedProducts.value = [];
    await loadProducts();
    notifySuccess("Produits rendus visibles");
  } catch (e) {
    notifyError("Erreur lors de la mise en visibilité des produits.");
  } finally {
    makeVisibleConfirmVisible.value = false;
  }
};

const initBulkInvisibleSuccessorChoices = () => {
  const choices = new Map<string, number | null>();
  for (const group of bulkInvisiblePlan.value.groupsWithSuccessor) {
    choices.set(group.liaison, group.successors[0]?.id ?? null);
  }
  bulkInvisibleSuccessorChoices.value = choices;
  bulkInvisibleGroupSearch.value = "";
};

const selectBulkSuccessor = (liaison: string, successorId: number) => {
  const next = new Map(bulkInvisibleSuccessorChoices.value);
  next.set(liaison, successorId);
  bulkInvisibleSuccessorChoices.value = next;
};

const handleBulkMakeInvisible = () => {
  if (!selectedProducts.value.length) return;
  initBulkInvisibleSuccessorChoices();
  makeInvisibleConfirmVisible.value = true;
};

/**
 * Dans la modal : sélectionne « tout le groupe hors ligne »
 * (appliqué seulement au clic sur Confirmer).
 */
const markBulkGroupFullyOffline = (group: BulkInvisibleGroup) => {
  const next = new Map(bulkInvisibleSuccessorChoices.value);
  next.set(group.liaison, BULK_WHOLE_GROUP_OFFLINE);
  bulkInvisibleSuccessorChoices.value = next;
};

const handleCancelMakeInvisible = async () => {
  if (isBulkMakingInvisible.value) return;
  makeInvisibleConfirmVisible.value = false;
  bulkInvisibleSuccessorChoices.value = new Map();
  bulkInvisibleGroupSearch.value = "";
  await loadProducts();
};

const confirmBulkMakeInvisible = async () => {
  if (!selectedProducts.value.length || isBulkMakingInvisible.value) {
    makeInvisibleConfirmVisible.value = false;
    return;
  }

  const idsArray = [...selectedProducts.value];
  const idsToHide = new Set(idsArray);
  isBulkMakingInvisible.value = true;

  try {
    for (const group of bulkInvisiblePlan.value.groupsWithSuccessor) {
      const successorId = bulkInvisibleSuccessorChoices.value.get(
        group.liaison,
      );
      if (successorId === BULK_WHOLE_GROUP_OFFLINE) {
        idsToHide.add(Number(group.oldMain.id));
        for (const s of group.successors) {
          idsToHide.add(Number(s.id));
        }
        continue;
      }
      if (!successorId) continue;

      const newMain = products.value.find(
        (p) => Number(p.id) === Number(successorId),
      );
      if (newMain) {
        await promoteSuccessorAndHideMain(group.oldMain, newMain);
        idsToHide.delete(Number(newMain.id));
        idsToHide.delete(Number(group.oldMain.id));
      }
    }

    if (idsToHide.size > 0) {
      await setProduitsVisible([...idsToHide], false);
    }
    selectedProducts.value = [];
    await loadProducts();
    notifySuccess("Produits rendus invisibles");
  } catch (e) {
    notifyError("Erreur lors de la mise hors ligne des produits.");
    console.error(e);
  } finally {
    isBulkMakingInvisible.value = false;
    makeInvisibleConfirmVisible.value = false;
    bulkInvisibleSuccessorChoices.value = new Map();
    bulkInvisibleGroupSearch.value = "";
  }
};

// Liste réactive des successeurs visibles pour la modal en cours
const visibleSuccessors = computed<ProduitCatalogue[]>(() => {
  const pending = singleVisibilityPending.value;
  if (!pending) return [];
  const product = products.value.find((p) => p.id === pending.productId);
  if (!product) return [];
  return findVisibleSuccessors(product);
});

const selectSuccessor = (successorId: number) => {
  if (!singleVisibilityPending.value) return;
  singleVisibilityPending.value = {
    ...singleVisibilityPending.value,
    successorId,
    wholeGroupOffline: false,
  };
};

/** Sélectionne l'option « tout le groupe hors ligne » (appliquée au Confirmer). */
const selectSingleVisibilityWholeGroupOffline = () => {
  if (!singleVisibilityPending.value || isPromotingMainChange.value) return;
  singleVisibilityPending.value = {
    ...singleVisibilityPending.value,
    successorId: null,
    wholeGroupOffline: true,
  };
};

const getLoadedSiblingIdsForMainChange = (
  product: ProduitCatalogue,
): Set<number> => {
  const targetLiaison =
    product.liaison && product.liaison !== "0" && product.liaison !== ""
      ? String(product.liaison)
      : String(product.id);

  return new Set<number>(
    products.value
      .filter((p) => {
        const liaison = String(p.liaison ?? "").trim();
        return liaison === targetLiaison || String(p.id) === targetLiaison;
      })
      .map((p) => Number(p.id)),
  );
};

// Promeut `newMain` comme produit principal, et rend `oldMain` invisible.
const promoteSuccessorAndHideMain = async (
  oldMain: ProduitCatalogue,
  newMain: ProduitCatalogue,
) => {
  const allSiblingIds = getLoadedSiblingIdsForMainChange(oldMain);
  allSiblingIds.add(oldMain.id);
  allSiblingIds.add(newMain.id);

  const newMainId = Number(newMain.id);
  const oldMainId = Number(oldMain.id);

  // Source de vérité backend pour garantir la cohérence du groupe
  // (inclut variantes non chargées, brouillons/supprimées).
  await toggleMainProduct(newMainId);

  // Masquer explicitement l'ancien principal après la promotion.
  await updateProduit({
    id_produit: oldMainId,
    visible: false,
  });

  // Synchroniser marque/prix/promo sur les produits chargés.
  for (const siblingIdRaw of allSiblingIds) {
    const siblingId = Number(siblingIdRaw);
    await updateProduit({
      id_produit: siblingId,
      id_vendeur_marque: newMain.marqueId ?? null,
      prix: newMain.prix,
      prixReduit: newMain.prixReduit ?? null,
    });
  }
};

const handleVisibilityChange = async (
  productId: number,
  checked: boolean,
  product: ProduitCatalogue,
  event?: Event,
) => {
  if (isProductLocked(product)) return;
  if (checked) {
    const blocker = getPublishBlocker(product);
    if (blocker) {
      const target = event?.target as HTMLInputElement | null;
      if (target) target.checked = false;
      notifyError(`${product.reference} : ${blocker}`);
      return;
    }
    saveProductData(productId, "visible", true);
    return;
  }
  if (isMainProduct(product)) {
    // On affiche toujours la confirmation, avec un message qui s'adapte
    // selon qu'au moins un successeur visible existe ou non.
    // Le premier successeur est pré-sélectionné par défaut.
    const successors = findVisibleSuccessors(product);
    singleVisibilityPending.value = {
      productId,
      value: false,
      successorId: successors[0]?.id ?? null,
      wholeGroupOffline: false,
    };
    singleVisibilityMainConfirmVisible.value = true;
    return;
  }
  saveProductData(productId, "visible", false);
};

const confirmSingleVisibilityMainChange = async () => {
  if (!singleVisibilityPending.value || isPromotingMainChange.value) return;
  const { productId, value, successorId, wholeGroupOffline } =
    singleVisibilityPending.value;
  let successMessage = "";
  isPromotingMainChange.value = true;

  try {
    if (wholeGroupOffline) {
      const ids = [
        Number(productId),
        ...visibleSuccessors.value.map((s) => Number(s.id)),
      ];
      await setProduitsVisible(ids, false);
      successMessage = `${ids.length} couleur(s) du groupe mises hors ligne`;
    } else if (successorId) {
      // Successeur visible : on le promeut en principal et on masque l'ancien.
      const oldMain = products.value.find(
        (p) => Number(p.id) === Number(productId),
      );
      const newMain = products.value.find(
        (p) => Number(p.id) === Number(successorId),
      );
      if (oldMain && newMain) {
        await promoteSuccessorAndHideMain(oldMain, newMain);
        successMessage = `${newMain.reference} est désormais le produit principal. ${oldMain.reference} a été mis hors ligne.`;
      } else {
        await saveProductData(productId, "visible", value);
        successMessage = "Produit mis à jour avec succès.";
      }
    } else {
      await saveProductData(productId, "visible", value);
      successMessage = "Produit mis à jour avec succès.";
    }

    // Ordre demandé: DB -> fermeture modal -> refresh front
    singleVisibilityMainConfirmVisible.value = false;
    singleVisibilityPending.value = null;
    await loadProducts();
    if (successMessage) notifySuccess(successMessage);
  } catch (e) {
    notifyError(
      wholeGroupOffline
        ? "Erreur lors de la mise hors ligne du groupe."
        : "Erreur lors du changement de produit principal",
    );
    console.error(e);
  } finally {
    isPromotingMainChange.value = false;
  }
};

const cancelSingleVisibilityMainChange = async () => {
  if (isPromotingMainChange.value) return;
  singleVisibilityMainConfirmVisible.value = false;
  singleVisibilityPending.value = null;
  await loadProducts();
};

const handleBulkLinkColors = () => {
  if (!selectedProducts.value.length) return;
  linkExtraProductIds.value = [];
  selectedLinkMainId.value = null;
  duplicateColorKeepByKey.value = {};
  selectedTargetReferenceBase.value = null;
  linkPreview.value = null;
  linkColorsConfirmVisible.value = true;
  refreshLinkPreview();
};

const handleBulkDelinkColors = () => {
  if (!selectedProducts.value.length) return;
  delinkApplying.value = false;
  delinkMainGroups.value = buildDelinkMainGroups();
  delinkColorsConfirmVisible.value = true;
};

const handleBulkMea = () => {
  singleProductMeaReference.value = null;
  meaModalVisible.value = true;
};

const openMeaModalForRow = (row: any) => {
  singleProductMeaReference.value =
    row.referenceBase || row.reference_base || row.reference;
  meaModalVisible.value = true;
};

const handleMeaSuccess = async () => {
  selectedProducts.value = [];
  singleProductMeaReference.value = null;
  await loadProducts();
};

const refreshLinkPreview = async (mainProductId?: number | null) => {
  if (!linkRequestProductIds.value.length) return;
  linkPreviewLoading.value = true;
  try {
    const preview = await previewProduitLink(
      linkRequestProductIds.value,
      mainProductId ?? null,
      duplicateColorKeepProductIds.value,
      selectedTargetReferenceBase.value,
    );
    linkPreview.value = preview;
    void loadLinkPreviewImages(preview.affectedProductIds);
  } catch (e: any) {
    console.error("Erreur previewProduitLink:", e);
    notifyError(
      e?.message || "Erreur lors de la prévisualisation de la liaison.",
    );
    linkPreview.value = null;
  } finally {
    linkPreviewLoading.value = false;
  }
};

const handleSelectLinkMain = async (productId: number) => {
  selectedLinkMainId.value = Number(productId);
  await refreshLinkPreview(Number(productId));
};

const handleSelectDuplicateColorKeeper = async (
  colorKey: string,
  productId: number,
) => {
  duplicateColorKeepByKey.value = {
    ...duplicateColorKeepByKey.value,
    [colorKey]: Number(productId),
  };
  await refreshLinkPreview(selectedLinkMainId.value);
};

const handleSelectReferenceBase = async (referenceBase: string) => {
  selectedTargetReferenceBase.value = referenceBase;
  await refreshLinkPreview(selectedLinkMainId.value);
};

const cancelLinkPreview = () => {
  if (linkApplying.value) return;
  linkColorsConfirmVisible.value = false;
  linkPreview.value = null;
  linkExtraProductIds.value = [];
  selectedLinkMainId.value = null;
  duplicateColorKeepByKey.value = {};
  selectedTargetReferenceBase.value = null;
};

const confirmBulkLinkColors = async () => {
  if (!selectedProducts.value.length) {
    linkColorsConfirmVisible.value = false;
    return;
  }

  if (!selectedLinkMainId.value || !linkPreview.value?.confirmationToken) {
    notifyError("Choisissez un produit principal avant de confirmer.");
    return;
  }

  linkApplying.value = true;
  try {
    const result = await applyProduitLink(
      linkRequestProductIds.value,
      selectedLinkMainId.value,
      linkPreview.value.confirmationToken,
      duplicateColorKeepProductIds.value,
      targetReferenceBaseForRequest.value,
    );

    notifySuccess(
      `Liaison appliquée pour ${result.affectedProductIds.length} produit(s).`,
    );

    linkColorsConfirmVisible.value = false;
    linkPreview.value = null;
    linkExtraProductIds.value = [];
    selectedLinkMainId.value = null;
    duplicateColorKeepByKey.value = {};
    selectedTargetReferenceBase.value = null;
    await loadProducts();
    selectedProducts.value = [];
  } catch (e: any) {
    console.error("Erreur applyProduitLink:", e);
    notifyError(e?.message || "Erreur lors de la liaison des couleurs");
    if (selectedLinkMainId.value) {
      await refreshLinkPreview(selectedLinkMainId.value);
    }
  } finally {
    linkApplying.value = false;
  }
};

const cancelReorganizeColors = () => {
  if (delinkApplying.value) return;
  delinkColorsConfirmVisible.value = false;
  delinkMainGroups.value = [];
};

const confirmBulkDelinkColors = async () => {
  if (!selectedProducts.value.length) {
    delinkColorsConfirmVisible.value = false;
    return;
  }

  delinkApplying.value = true;
  try {
    const idsToUpdate = [...selectedProducts.value];

    for (const group of delinkMainGroups.value) {
      const nextMainId = Number(group.selectedId);
      if (!Number.isFinite(nextMainId) || nextMainId <= 0) {
        notifyError("Choisissez le nouveau produit principal.");
        return;
      }

      for (const product of group.remainingProducts) {
        await updateProduit({
          id_produit: Number(product.id),
          id_couleur_liee: nextMainId,
          main: Number(product.id) === nextMainId,
        });
      }
    }

    for (const idToUpdate of idsToUpdate) {
      const product = products.value.find(
        (item) => Number(item.id) === Number(idToUpdate),
      );
      const currentBase = String(
        (product as any)?.reference_base || product?.reference || "REF",
      ).trim();
      const nextBase = `${currentBase}-${idToUpdate}`;
      const color = (product?.couleur || "").trim();
      await updateProduit({
        id_produit: idToUpdate,
        id_couleur_liee: idToUpdate,
        main: true,
        reference_base: nextBase,
        reference: color
          ? `${nextBase}-${color.toUpperCase()}`
          : nextBase,
      });
    }

    notifySuccess(
      `Les produits ont été déliés avec succès (${idsToUpdate.length} produit(s)).`,
    );

    delinkColorsConfirmVisible.value = false;
    delinkMainGroups.value = [];
    await loadProducts();
    selectedProducts.value = [];
  } catch (e: any) {
    console.error(e);
    notifyError(e?.message || "Erreur lors de la suppression de la liaison");
  } finally {
    delinkApplying.value = false;
  }
};

// Headers du tableau
// NOTE: Demande produit: "Collection" et "CATÉGORIE" ne doivent pas s'afficher temporairement.
// Pour cela, nous les retirons de la définition des colonnes ci‑dessous.
// Pour réactiver plus tard, remettre les deux lignes commentées.
const tableHeaders = [
  { key: "checkbox", label: "", cellClass: "pl-1.5 pr-0  !py-0.5" },
  {
    key: "image",
    label: "Image",
    cellClass: "pl-0 pr-2  !py-0.5",
    align: "right",
    headerAlign: "center",
  },
  {
    key: "reference",
    label: "Référence",
    cellClass: "!py-0.5",
    align: "center",
    headerAlign: "center",
  },
  { key: "date", label: "Date", cellClass: "pl-0 pr-0  !py-0.5" },
  { key: "marque", label: "Marque", cellClass: "pl-2 pr-0  !py-0.5" },
  // { key: 'collection', label: 'Collection',     cellClass:"pl-0 pr-0  !py-0.5"},
  // { key: 'categories', label: 'CATÉGORIE',      cellClass:"pl-0 pr-0  !py-0.5"},
  { key: "prix", label: "Prix", cellClass: "pl-0 pr-0  !py-0.5" },
  { key: "promotion", label: "Promotion", cellClass: "pl-3 pr-0  !py-0.5" },
  { key: "couleur", label: "Couleur", cellClass: "pl-0 pr-0  !py-0.5" },
  { key: "stock", label: "Stock", cellClass: "pl-0 pr-0  !py-0.5" },
  { key: "visible", label: "VISIBLE", cellClass: "pl-0 pr-0  !py-0.5" },
  { key: "statut", label: "Statut", cellClass: "pl-0 pr-0  !py-0.5" },
  { key: "actions", label: "Actions", cellClass: "pl-0 pr-2  !py-0.5" },
];

// Données filtrées (gérées par ProductFilters)
const filteredProducts = ref<ProduitCatalogue[]>([]);
const totalProducts = ref(0);
const totalAllProducts = ref(0);

// Cache buster pour forcer le rechargement de l'image d'un produit après sauvegarde de la fiche (photos modifiées)
const productImageCacheBuster = ref<Record<number, number>>({});
const getDisplayImageForProduct = (prod: {
  id: number;
  image?: string;
}): string => {
  const pending = pendingCoverByProductId.value[prod.id];
  const url = pending || prod?.image;
  if (!url || typeof url !== "string") return "";
  return getProductStorageUrl(url);
};
const getProductImageUrl = (prod: {
  id: number;
  image?: string;
  dateModification?: string | null;
}): string => {
  const url = getDisplayImageForProduct(prod);
  if (!url) return "";
  // Buster en mémoire (opération en cours) sinon version persistante (localStorage)
  const local =
    productImageCacheBuster.value[prod.id] ?? getPhotoVersion(prod.id);
  const server = prod.dateModification
    ? Date.parse(prod.dateModification)
    : 0;
  const buster = Math.max(local || 0, Number.isFinite(server) ? server : 0);
  if (!buster) return url;
  const sep = url.includes("?") ? "&" : "?";
  return `${url}${sep}t=${buster}`;
};

const clearPendingCoverForProduct = (productId: number) => {
  const next = { ...pendingCoverByProductId.value };
  delete next[productId];
  pendingCoverByProductId.value = next;
};

const expandedLiaisons = ref(new Set<string>());

const toggleLiaison = (liaison: string) => {
  if (expandedLiaisons.value.has(liaison)) {
    expandedLiaisons.value.delete(liaison);
  } else {
    expandedLiaisons.value.add(liaison);
  }
};

const isExpanded = (liaison: string) => expandedLiaisons.value.has(liaison);

/**
 * Calcule les produits à afficher en groupant par liaison (couleur liée)
 */
const groupedProducts = computed(() => {
  const result: (ProduitCatalogue & {
    isChild?: boolean;
    hasSiblings?: boolean;
  })[] = [];
  const liaisonGroups = new Map<string, ProduitCatalogue[]>();

  // Grouper les produits par liaison
  filteredProducts.value.forEach((p) => {
    if (p.liaison && p.liaison !== "0" && p.liaison !== "") {
      if (!liaisonGroups.has(p.liaison)) {
        liaisonGroups.set(p.liaison, []);
      }
      liaisonGroups.get(p.liaison)!.push(p);
    }
  });

  const processedLiaisons = new Set<string>();

  filteredProducts.value.forEach((p) => {
    // Si pas de liaison, produit indépendant
    if (!p.liaison || p.liaison === "0" || p.liaison === "") {
      result.push(p);
    } else {
      // Si déjà traité dans un groupe, on ignore
      if (processedLiaisons.has(p.liaison)) return;

      const group = liaisonGroups.get(p.liaison)!;

      if (group.length > 1) {
        // Identifier le produit principal : celui dont l'id correspond à la liaison
        let parentIndex = group.findIndex(
          (item) => String(item.id) === String(item.liaison),
        );

        // Si aucun ne correspond, on prend le premier par défaut
        if (parentIndex === -1) parentIndex = 0;

        const parent = group[parentIndex];
        const children = group.filter((_, idx) => idx !== parentIndex);

        result.push({ ...parent, hasSiblings: true, main: true });

        // Si le groupe est déplié, on ajoute les autres comme "enfants"
        if (expandedLiaisons.value.has(p.liaison)) {
          children.forEach((child) => {
            result.push({
              ...child,
              isChild: true,
              descriptionFr:
                (child as any).descriptionFr ||
                (parent as any).descriptionFr ||
                "",
            });
          });
        }
      } else {
        // Groupe d'un seul élément, on l'affiche normalement
        result.push(p);
      }
      processedLiaisons.add(p.liaison);
    }
  });

  return result;
});

const getRowClass = (row: any) => {
  let classes = "";
  if (row.isChild) classes += " bg-gray-50/50 h-8";
  if (row.hasSiblings) classes += " font-medium";
  if (isProductLocked(row) && activeTab.value !== "supprime")
    classes += " bg-gray-50/70 pointer-events-none select-none";
  return classes;
};

// Pagination côté serveur - plus besoin de pagination côté client
// const totalPages = computed(() => Math.ceil(totalProducts.value / itemsPerPage.value))

/* ---------- 3-level category cascade ---------- */

// Level 1 options: root categories from categoriesTree
const level1Options = computed(() => categoriesTree.value);

// Level 2: based on the selected catLevel1Id for the current row
const getLevel2Options = (row: ProduitCatalogue): CategorieNode[] => {
  const parent = categoriesTree.value.find(
    (c) => c.id_categorie === row.catLevel1Id,
  );
  return parent?.children ?? [];
};

// Level 3: based on the selected catLevel1Id + catLevel2Id for the current row
const getLevel3Options = (row: ProduitCatalogue): CategorieNode[] => {
  const level1 = categoriesTree.value.find(
    (c) => c.id_categorie === row.catLevel1Id,
  );
  const level2 = level1?.children?.find(
    (c) => c.id_categorie === row.catLevel2Id,
  );
  return level2?.children ?? [];
};

const findCategoryLabelById = (
  nodes: CategorieNode[],
  id: number,
): string | null => {
  for (const node of nodes) {
    if (node.id_categorie === id) return node.label;
    if (node.children?.length) {
      const found = findCategoryLabelById(node.children, id);
      if (found) return found;
    }
  }
  return null;
};

const getLastCategoryLabel = (product: ProduitCatalogue): string => {
  const leafId =
    product.catLevel3Id || product.catLevel2Id || product.catLevel1Id;
  if (!leafId) {
    const fallback = (product as any).categorie || product.categories?.[0];
    return typeof fallback === "string" && fallback.trim()
      ? fallback
      : "—";
  }
  return (
    findCategoryLabelById(categoriesTree.value, Number(leafId)) || "—"
  );
};

const getDeclinaisonLabel = (product: ProduitCatalogue): string => {
  const id =
    (product as any).declinaisonId ??
    (product as any).id_declinaison ??
    product.declinaison;
  if (!id) return "—";
  const match = declinaisons.value.find(
    (d) => Number(d.id_declinaison) === Number(id),
  );
  return match?.titre || "—";
};

const categoryFilterOptions = computed(() =>
  categoriesTree.value.map((cat) => ({
    id_categorie: cat.id_categorie,
    label: cat.label,
  })),
);

const openColorModal = async (product: ProduitCatalogue) => {
  if (isProductLocked(product)) return;
  openActionMenuId.value = null;
  try {
    // Toujours rafraîchir le catalogue officiel (ajouts admin inclus)
    await loadColors();

    // Charger les couleurs depuis la DB
    const produitCouleurs = await getProduitCouleurs(product.id);

    // Extraire les IDs de couleurs
    const ids = produitCouleurs
      .filter((c) => c.id_couleur !== null)
      .map((c) => c.id_couleur as number);

    selectedColorIds.value =
      ids.length > 0
        ? ids
        : product.colorIds && product.colorIds.length > 0
        ? [product.colorIds[0]]
        : [];

    // Si couleurs mélangées, charger la déclinaison et extraire les tailles
    if (product.venduPar === "melangees" && product.declinaisonId) {
      const declinaison = await getDeclinaisonById(product.declinaisonId);
      if (declinaison) {
        // Extraire les tailles depuis les colonnes d1_FR à d12_FR
        const tailles: string[] = [];
        for (let i = 1; i <= 12; i++) {
          const taille = (declinaison as any)[`d${i}_FR`];
          if (
            taille &&
            typeof taille === "string" &&
            taille.trim().length > 0
          ) {
            tailles.push(taille.trim());
          }
        }
        taillesListForModal.value = tailles;

        // Convertir les descriptions_paquet en quantitesParTaille
        colorsWithQuantitiesForModal.value = produitCouleurs
          .filter((c) => c.id_couleur !== null)
          .map((c) => {
            let quantites: number[] | undefined;
            if (c.description_paquet) {
              quantites = parseDescriptionPaquet(c.description_paquet);
            } else if (tailles.length > 0) {
              quantites = new Array(tailles.length).fill(0);
            }

            return {
              id_couleur: c.id_couleur as number,
              quantitesParTaille: quantites,
            };
          });
      } else {
        taillesListForModal.value = [];
        colorsWithQuantitiesForModal.value = [];
      }
    } else {
      taillesListForModal.value = [];
      colorsWithQuantitiesForModal.value = [];
    }

    // Collecter les couleurs utilisées par les autres produits du même liaison
    disabledColorIdsForModal.value = [];
    if (
      product.liaison &&
      (product.venduPar === "couleurs" || product.venduPar === "tailles")
    ) {
      const siblingProducts = products.value.filter(
        (p) => p.liaison === product.liaison && p.id !== product.id,
      );
      for (const sibling of siblingProducts) {
        if (sibling.colorIds && sibling.colorIds.length > 0) {
          disabledColorIdsForModal.value.push(...sibling.colorIds);
        }
      }
    }

    activeProductForColors.value = product;
    colorModalVisible.value = true;
  } catch (e) {
    selectedColorIds.value =
      product.colorIds && product.colorIds.length > 0
        ? [...product.colorIds]
        : [];
    taillesListForModal.value = [];
    colorsWithQuantitiesForModal.value = [];
    activeProductForColors.value = product;
    colorModalVisible.value = true;
  }
};

const handleSaveColors = async (payload: {
  productId: number;
  selectedIds: number[];
  colorsWithQuantities?: Array<{
    id_couleur: number;
    quantitesParTaille?: number[];
  }>;
}) => {
  const product = products.value.find((p) => p.id === payload.productId);
  if (!product) return;

  if (!payload.selectedIds || payload.selectedIds.length === 0) {
    notifyError("Au moins une couleur doit être sélectionnée.");
    return;
  }

  // Garde-fou: empêcher de choisir une couleur déjà utilisée
  // dans le même groupe de liaison par un autre produit.
  if (payload.selectedIds.length > 0) {
    const mainId = getMainProductId(product);
    const usedInGroup = await getAllUsedColorIdsByMainProduct(mainId);

    const currentProductColorIds = new Set<number>();
    if (product.venduPar === "melangees") {
      const produitCouleurs = await getProduitCouleurs(payload.productId);
      produitCouleurs.forEach((c) => {
        const n = Number(c.id_couleur);
        if (Number.isFinite(n) && n > 0) currentProductColorIds.add(n);
      });
    }
    if (Array.isArray(product.colorIds)) {
      product.colorIds.forEach((id) => {
        const n = Number(id);
        if (Number.isFinite(n) && n > 0) currentProductColorIds.add(n);
      });
    }

    const directColorId = Number((product as any).id_couleur);
    if (Number.isFinite(directColorId) && directColorId > 0) {
      currentProductColorIds.add(directColorId);
    }

    const unavailableColorIds = new Set<number>(
      usedInGroup
        .map((id) => Number(id))
        .filter(
          (id) =>
            Number.isFinite(id) && id > 0 && !currentProductColorIds.has(id),
        ),
    );

    const collisions = [...new Set(payload.selectedIds)].filter((id) =>
      unavailableColorIds.has(id),
    );

    if (collisions.length > 0) {
      const labels = collisions.map((id) => {
        const color = allColors.value.find((c) => c.id_couleur === id);
        return color?.label ?? `#${id}`;
      });

      notifyError(
        `Impossible de modifier la couleur: déjà utilisée dans ce groupe (${labels.join(
          ", ",
        )}).`,
      );
      return;
    }
  }

  // Validation: vérifier que la somme des quantités des couleurs = quantités du pack
  if (
    product.venduPar === "melangees" &&
    payload.colorsWithQuantities &&
    payload.colorsWithQuantities.length > 0
  ) {
    const anyProd = product as any;
    const quantitePaquetId =
      anyProd.quantitePaquet || anyProd.packId || anyProd.id_pack;

    if (quantitePaquetId) {
      const selectedPack = packs.value.find(
        (p) => p.id_pack.toString() === quantitePaquetId.toString(),
      );

      if (selectedPack && selectedPack.valeur) {
        const packQuantites = parseDescriptionPaquet(selectedPack.valeur);

        const sommeQuantites: number[] = new Array(packQuantites.length).fill(
          0,
        );

        for (const c of payload.colorsWithQuantities) {
          if (c.quantitesParTaille) {
            c.quantitesParTaille.forEach((qte: number, index: number) => {
              if (index < sommeQuantites.length) {
                sommeQuantites[index] += qte || 0;
              }
            });
          }
        }

        let mismatch = false;
        for (let i = 0; i < packQuantites.length; i++) {
          if (packQuantites[i] !== sommeQuantites[i]) {
            mismatch = true;
            break;
          }
        }

        if (mismatch) {
          notifyError(
            `La somme des quantités des couleurs (${formatDescriptionPaquet(
              sommeQuantites,
            )}) ne correspond pas aux quantités du paquet (${formatDescriptionPaquet(
              packQuantites,
            )})`,
          );
          return;
        }
      }
    }
  }

  try {
    const couleurs_with_quantities =
      payload.colorsWithQuantities && product.venduPar === "melangees"
        ? payload.colorsWithQuantities.map((c) => ({
            id_couleur: c.id_couleur,
            description_paquet:
              c.quantitesParTaille && Array.isArray(c.quantitesParTaille)
                ? formatDescriptionPaquet(c.quantitesParTaille)
                : null,
          }))
        : undefined;

    await updateProduitCouleursProduit({
      id_produit: payload.productId,
      ids_couleur_efashion: payload.selectedIds,
      couleurs_with_quantities,
      vendu_par: product.venduPar ?? null,
    });

    product.colorIds = [...payload.selectedIds];
    product.couleursDetail = payload.selectedIds.map((id) => {
      const match = allColors.value.find((c) => c.id_couleur === id);
      return {
        id_couleur: id,
        couleur_FR: match?.label ?? "",
        hexColor: match?.hexColor ?? null,
      };
    });

    const labels = product.couleursDetail
      .map((c) => c.couleur_FR)
      .filter(Boolean);

    product.couleur = labels.join(", ");

    // 单色产品：更新颜色时同步更新reference
    let updatedReference = product.reference;
    if (product.venduPar !== "melangees" && payload.selectedIds.length === 1) {
      const selectedColor = allColors.value.find(
        (c) => c.id_couleur === payload.selectedIds[0],
      );
      if (selectedColor) {
        await updateProduitCouleur(
          payload.productId,
          selectedColor.id_couleur,
          selectedColor.label,
        );
        // 更新本地显示的reference
        const anyProd = product as any;
        let baseRef = anyProd.reference_base;

        // 如果 reference_base 不存在，从当前 reference 中提取（去掉最后的 -颜色 部分）
        if (!baseRef && product.reference) {
          const lastDashIndex = product.reference.lastIndexOf("-");
          if (lastDashIndex > 0) {
            baseRef = product.reference.substring(0, lastDashIndex);
          }
        }

        if (baseRef) {
          updatedReference = `${baseRef}-${selectedColor.label.toUpperCase()}`;
          product.reference = updatedReference;
        }
      }
    }

    if (product.venduPar === "melangees" && payload.selectedIds.length > 0) {
      const anyProd = product as any;
      let baseRef = anyProd.reference_base;
      if (!baseRef && product.reference) {
        const lastDashIndex = product.reference.lastIndexOf("-");
        if (lastDashIndex > 0) {
          baseRef = product.reference.substring(0, lastDashIndex);
        }
      }
      if (baseRef) {
        const colorNames = allColors.value
          .filter((c) => payload.selectedIds.includes(c.id_couleur))
          .map((c) => c.label.toUpperCase())
          .join(", ");
        updatedReference = `${baseRef}-${colorNames}`;
        product.reference = updatedReference;
      }
    }

    // 使用更新后的颜色名称显示提示
    notifySuccess(`Couleurs du produit ${updatedReference} enregistrées`);

    // Resync couleurs dans la fiche si ouverte (sans tout recharger)
    if (
      ficheModalVisible.value &&
      activeProductForSheet.value &&
      Number(activeProductForSheet.value.id) === Number(product.id)
    ) {
      activeProductForSheet.value.colorIds = [...(product.colorIds || [])];
      activeProductForSheet.value.couleursDetail = product.couleursDetail
        ? [...product.couleursDetail]
        : [];
      activeProductForSheet.value.couleur = product.couleur;
      activeProductForSheet.value.reference = product.reference;
    }
  } catch (e) {
    console.error(e);
    notifyError(
      `Erreur lors de l'enregistrement des couleurs du produit ${product.reference}`,
    );
  }
};

// Charger les stocks d'un produit pour l'affichage dans la liste
const loadStocksForRow = async (row: any) => {
  const idProduit = Number(row.id);
  if (
    productStocksMap.value.has(idProduit) ||
    loadingStocksForProduct.value.has(idProduit)
  ) {
    return;
  }

  loadingStocksForProduct.value.add(idProduit);
  try {
    const venduPar = row.venduPar ?? row.vendu_par;

    if (venduPar === "melangees") {
      // id_couleur 43 = couleur système « Couleurs mélangées » (pas 0 : FK couleurs_defaut)
      const stocks: ColorStockRow[] = [
        {
          id_couleur: ID_COULEUR_MELANGEES,
          colorLabel: "",
          quantity:
            row.stock_renseigne && row.stock_value != null
              ? Number(row.stock_value)
              : null,
          hexColor: undefined,
        },
      ];
      productStocksMap.value.set(idProduit, stocks);
    } else if (venduPar === "couleurs") {
      // Mode couleurs: stock par couleur depuis produits_stock (taille: null)
      const produitStocks = await getProduitStocks(idProduit);
      const byColor = new Map<
        number,
        { label: string; hex: string | undefined; total: number }
      >();
      for (const ps of produitStocks) {
        if (ps.id_couleur == null) continue;
        const existing = byColor.get(ps.id_couleur);
        const val = ps.value != null ? Number(ps.value) : 0;
        if (existing) {
          existing.total += val;
        } else {
          byColor.set(ps.id_couleur, {
            label: String(ps.couleur_FR || "Couleur").toUpperCase(),
            hex: ps.hexColor ?? undefined,
            total: val,
          });
        }
      }
      const stocks: ColorStockRow[] = Array.from(byColor.entries()).map(
        ([id_couleur, data]) => ({
          id_couleur,
          colorLabel: data.label,
          quantity: data.total,
          hexColor: data.hex,
        }),
      );
      productStocksMap.value.set(idProduit, stocks);
    } else if (venduPar === "tailles") {
      // Mode tailles: agréger les stocks par couleur depuis produits_stock
      const produitStocks = await getProduitStocks(idProduit);
      // Grouper par id_couleur
      const byColor = new Map<
        number,
        { label: string; hex: string | undefined; total: number }
      >();
      for (const ps of produitStocks) {
        if (ps.id_couleur == null) continue;
        const existing = byColor.get(ps.id_couleur);
        const val = ps.value != null ? Number(ps.value) : 0;
        if (existing) {
          existing.total += val;
        } else {
          byColor.set(ps.id_couleur, {
            label: String(ps.couleur_FR || "Couleur").toUpperCase(),
            hex: ps.hexColor ?? undefined,
            total: val,
          });
        }
      }
      const stocks: ColorStockRow[] = Array.from(byColor.entries()).map(
        ([id_couleur, data]) => ({
          id_couleur,
          colorLabel: data.label,
          quantity: data.total,
          hexColor: data.hex,
        }),
      );
      productStocksMap.value.set(idProduit, stocks);
    } else {
      // Fallback : agréger par couleur via description_paquet
      const produitCouleurs = await getProduitCouleurs(idProduit);
      const stocks: ColorStockRow[] = produitCouleurs
        .filter((pc: any) => pc.id_couleur != null)
        .map((pc: any) => {
          let total = 0;
          if (pc.description_paquet) {
            total = parseDescriptionPaquet(pc.description_paquet).reduce(
              (sum, n) => sum + n,
              0,
            );
          }
          const rawLabel =
            pc.couleur_FR ??
            (typeof pc.couleur === "string"
              ? pc.couleur
              : pc.couleur?.couleur_FR ??
                pc.couleur?.label ??
                pc.couleur?.libelle) ??
            "Couleur";
          const hex =
            pc.hexColor ??
            (typeof pc.couleur === "object" ? pc.couleur.hexColor : undefined);

          return {
            id_couleur: pc.id_couleur as number,
            colorLabel: String(rawLabel || "Couleur").toUpperCase(),
            quantity: total,
            hexColor: hex,
          };
        });

      // Une seule couleur : n'afficher la valeur que si stock_renseigne true
      if (stocks.length === 1) {
        stocks[0].quantity =
          row.stock_renseigne && row.stock_value != null
            ? Number(row.stock_value)
            : null;
      }

      productStocksMap.value.set(idProduit, stocks);
    }
  } catch (e) {
    console.error("Error loading stocks for product", idProduit, e);
    productStocksMap.value.set(idProduit, []);
  } finally {
    loadingStocksForProduct.value.delete(idProduit);
  }
};

// Obtenir les stocks d'un produit (déclenche le chargement si nécessaire)
const getStocksForRow = (row: any): ColorStockRow[] => {
  const idProduit = Number(row.id);
  if (
    !productStocksMap.value.has(idProduit) &&
    !loadingStocksForProduct.value.has(idProduit)
  ) {
    loadStocksForRow(row);
  }
  return productStocksMap.value.get(idProduit) || [];
};

/** stock_renseigne false → rien ; true → afficher la vraie donnée (stock_value) */
const getStockInputDisplay = (row: any): string => {
  if (!row.stock_renseigne) return "";
  const val = row.stock_value;
  if (val == null) return "";
  const n = Number(val);
  return isNaN(n) ? "" : String(n);
};

// Handler pour l'input quantité (multi-couleurs / melangees) : afficher vide si rien renseigné
const onStockQuantityChange = (
  row: any,
  stock: ColorStockRow,
  rawValue: string,
) => {
  if (isProductLocked(row)) return;
  const trimmed = rawValue.trim();
  stock.quantity =
    trimmed === "" ? null : Math.max(0, parseInt(trimmed, 10) || 0);
  saveStockItem(row, stock);
};

// Persiste une quantité via upsert (sans écraser les autres couleurs)
const persistRowStock = async (
  row: any,
  idCouleur: number,
  value: number,
): Promise<void> => {
  const venduPar = row.venduPar ?? row.vendu_par;
  const colorId =
    venduPar === "melangees" ? ID_COULEUR_MELANGEES : idCouleur;
  if (!colorId) {
    throw new Error("id_couleur manquant pour la sauvegarde du stock");
  }
  const synced = await syncToGestionDeStock(row, colorId, value);
  if (!synced) {
    await upsertProduitStock(Number(row.id), colorId, value, null);
  }
};

const stockStatut = (
  visible: boolean,
  renseigne: boolean,
  value: number | null,
) =>
  !visible
    ? "hors-ligne"
    : renseigne && value === 0
      ? "rupture"
      : "en-vente";

const patchProductStockLocal = (
  idProduit: number,
  stock_value: number | null,
  stock_renseigne: boolean,
  row?: any,
) => {
  const visible = !!(
    row?.visible ?? products.value.find((p) => p.id === idProduit)?.visible
  );
  const statut = stockStatut(visible, stock_renseigne, stock_value);
  if (row) {
    row.stock_value = stock_value;
    row.stock_renseigne = stock_renseigne;
    row.statut = statut;
  }
  for (const list of [products.value, filteredProducts.value]) {
    const p = list.find((item) => item.id === idProduit);
    if (!p) continue;
    (p as any).stock_value = stock_value;
    (p as any).stock_renseigne = stock_renseigne;
    p.statut = statut as any;
  }
};

const saveStockItem = async (row: any, stock: ColorStockRow) => {
  try {
    const idProduit = Number(row.id);
    if (stock.quantity !== null) {
      await persistRowStock(row, stock.id_couleur, stock.quantity);
    }

    const stocks = productStocksMap.value.get(idProduit) || [];
    const allEmpty = stocks.every((s) => s.quantity == null);
    const total = allEmpty
      ? null
      : stocks.reduce((sum, s) => sum + (s.quantity ?? 0), 0);
    patchProductStockLocal(idProduit, total, !allEmpty, row);

    if (stock.quantity !== null) notifySuccess("Stock mis à jour");
  } catch (e) {
    console.error(e);
    notifyError("Erreur lors de la mise à jour du stock");
  }
};

// Sauvegarder le stock depuis l'input simple (fallback)
const onFallbackStockChange = (row: any, rawValue: string) => {
  if (isProductLocked(row)) return;
  const trimmed = rawValue.trim();
  if (trimmed === "") {
    const idProduit = Number(row.id);
    patchProductStockLocal(idProduit, null, false, row);
    const stocks = productStocksMap.value.get(idProduit);
    if (stocks?.length) stocks[0].quantity = null;
    return;
  }
  const num = parseInt(trimmed, 10);
  if (!isNaN(num) && num >= 0) saveStockData(row, num);
};

const saveStockData = async (row: any, newStockValue: number) => {
  try {
    const idProduit = Number(row.id);
    const venduPar = row.venduPar ?? row.vendu_par;
    let idCouleur =
      venduPar === "melangees"
        ? ID_COULEUR_MELANGEES
        : (row.id_couleur ?? null);
    if (idCouleur == null) {
      const couleurs = await getProduitCouleurs(idProduit);
      idCouleur = couleurs?.[0]?.id_couleur ?? null;
    }
    if (idCouleur == null) {
      notifyError(
        `Ce produit n'a pas de couleur associée. Veuillez d'abord ajouter une couleur.`,
      );
      return;
    }

    await persistRowStock(row, idCouleur, newStockValue);
    patchProductStockLocal(idProduit, newStockValue, true, row);

    const stocks = productStocksMap.value.get(idProduit);
    if (stocks?.length) {
      stocks[0].quantity = newStockValue;
    } else {
      productStocksMap.value.set(idProduit, [
        { id_couleur: idCouleur, colorLabel: "", quantity: newStockValue },
      ]);
    }

    notifySuccess(`Stock du produit ${row.reference} mis à jour`);
  } catch (e) {
    console.error(e);
    notifyError(`Erreur lors de la mise à jour du stock`);
  }
};

// Sync stock to gestion de stock (StockManagementView) when product is "à la couleur" with only 1 taille
// Returns true if sync was performed (meaning save was handled via upsertProduitStock with taille)
const syncToGestionDeStock = async (
  row: any,
  idCouleur: number,
  value: number,
): Promise<boolean> => {
  try {
    const venduPar = row.venduPar ?? row.vendu_par;
    if (venduPar !== "couleurs") return false;

    const idDeclinaison = row.declinaisonId ?? row.id_declinaison;
    if (!idDeclinaison) return false;

    const declinaison = await getDeclinaisonById(idDeclinaison);
    if (!declinaison) return false;

    // Extract tailles from declinaison (d1_FR to d12_FR)
    const tailles = [
      declinaison.d1_FR,
      declinaison.d2_FR,
      declinaison.d3_FR,
      declinaison.d4_FR,
      declinaison.d5_FR,
      declinaison.d6_FR,
      declinaison.d7_FR,
      declinaison.d8_FR,
      declinaison.d9_FR,
      declinaison.d10_FR,
      declinaison.d11_FR,
      declinaison.d12_FR,
    ].filter((t): t is string => !!t && t.trim() !== "");
    const uniqueTailles = [...new Set(tailles)];

    // Only sync if exactly 1 taille
    if (uniqueTailles.length !== 1) return false;

    const taille = uniqueTailles[0];
    await upsertProduitStock(Number(row.id), idCouleur, value, taille);
    return true;
  } catch (err) {
    console.error(
      "Erreur lors de la synchronisation vers gestion de stock:",
      err,
    );
    return false;
  }
};

// Produit（GraphQL）==> ProduitCatalogue — stock : rien si stock_renseigne false, sinon la vraie valeur
const mapProduitToCatalogue = (p: Produit): ProduitCatalogue => {
  const stockRenseigne = Boolean((p as any).stock_renseigne);
  const raw = p.stock_value;
  const num = typeof raw === "number" ? raw : Number(raw);
  const stockValue =
    stockRenseigne && raw != null && !isNaN(num) ? num : undefined;

  // Aligné ancien système : pas de ligne produits_stock = dispo ; lignes présentes et tout à 0 = rupture
  let statut: "en-vente" | "hors-ligne" | "rupture" | "supprime";
  if (Number((p as any).supprimer) === 1) {
    statut = "supprime";
  } else if (!p.visible) {
    statut = "hors-ligne";
  } else if (stockRenseigne && stockValue === 0) {
    statut = "rupture";
  } else {
    statut = "en-vente";
  }

  return {
    id: p.id_produit,
    date: p.date_produit ?? "",
    reference: p.reference ?? "",
    reference_base: (p as any).reference_base ?? "",
    marque: p.marque ?? "",
    marqueId: p.id_vendeur_marque,
    collection: p.collection ?? "",
    collectionId: p.id_collection != null ? Number(p.id_collection) : undefined,
    // keep legacy key used by ProductSheetModal v-model for echo
    ...(p.id_collection != null
      ? { id_collection: Number(p.id_collection) }
      : {}),
    id_provenance:
      (p as any).id_provenance != null
        ? Number((p as any).id_provenance)
        : null,
    compositionsRaw: (p as any).compositions ?? null,

    prix: p.prix ?? 0,
    promotion: p.promotion != null ? Number(p.promotion) : undefined,
    poids: p.poids ?? 0,
    dimensions: p.dimension ?? null,
    couleur: p.couleur ?? "",
    colorIds: (p.couleursDetail ?? []).map((c) => c.id_couleur),
    couleursDetail: p.couleursDetail ?? [],
    liaison: String(p.liaison ?? ""),
    venduPar: p.vendu_par ?? "",
    pack: p.id_pack ?? 0,
    packId: p.id_pack ?? 0,
    declinaison: p.id_declinaison ?? 0,
    declinaisonId: p.id_declinaison ?? 0,
    visible: p.visible ?? false,
    statut,
    image: "",
    id_produit: p.id_produit,
    id_vendeur: p.id_vendeur,
    main: p.main ?? false,
    id_couleur: (p as any).id_couleur ?? null,
    id_couleur_liee: (p as any).id_couleur_liee ?? null,
    prixReduit: p.prixReduit != null ? Number(p.prixReduit) : null,
    stock_value: stockValue,
    stock_renseigne: stockRenseigne,

    // catLevel1Id: p.id_parent_categorie ?? '',
    // catLevel2Id: p.id_categorie ?? '',
    // catLevel3Id: p.id_top_categorie ?? '',
    categories: p.categorie ? [p.categorie] : [],
    id_categorie:
      (p as any).id_categorie != null ? Number((p as any).id_categorie) : null,
    catLevel1Id: undefined,
    catLevel2Id: undefined,
    catLevel3Id: p.id_categorie,
    // URL du site acheteur générée par le backend
    acheteurUrl: (p as any).acheteurUrl || null,
    premel: (p as any).premel ?? "0",
    nb_photos: (p as any).nb_photos ?? 0,
    dateModification: (p as any).date_modification ?? null,
    finalisation: (p as any).finalisation ?? null,
    prestationValeur:
      (p as any).prestationValeur != null
        ? Number((p as any).prestationValeur)
        : null,
    dateFinalisation: (p as any).dateFinalisation ?? null,
    id_shooting: (p as any).id_shooting ?? null,
  };
};
const switchTab = async (tab: "en_ligne" | "brouillon" | "supprime") => {
  if (activeTab.value === tab) return;
  activeTab.value = tab;
  currentPage.value = 1;
  await loadProducts();
};

// Méthodes
const loadProducts = async () => {
  isFiltering.value = true;

  try {
    const authStore = useAuthStore();
    const id_vendeur = authStore.user?.id;
    const isUpgr = String((authStore.user as any)?.mel) === "1";
    // Déterminer le tri en fonction du filtre sélectionné
    const triValue = activeFilters.value?.tri || "date";
    const sortOrderBy = triValue === "alphabet" ? "reference" : "dateCreation";
    const sortOrderDir = triValue === "alphabet" ? "ASC" : "DESC";

    const filter: FilterProduitInput = {
      id_vendeur,
      // Server-side pagination (like Upload Photo page) to avoid loading too many items at once
      take: itemsPerPage.value,
      skip: (currentPage.value - 1) * itemsPerPage.value,
      orderBy: sortOrderBy,
      orderDir: sortOrderDir,
      includePremel: isUpgr,
      premelFilter:
        activeTab.value === "supprime" ? undefined : activeTab.value,
    };

    // Merge server-side filters if any
    if (activeFilters.value) {
      const f = activeFilters.value;
      // Backend FilterProduitInput currently does not support reference_contains
      // Use "reference" which the API accepts
      if (f.reference) (filter as any).reference = f.reference.trim();
      if (f.marque) filter.marque = f.marque;
      if (f.collection) filter.collection = f.collection;

      if (f.categories != null && f.categories !== "") {
        const selectedId = Number(f.categories);
        if (Number.isFinite(selectedId) && selectedId > 0) {
          (filter as any).id_categorie = selectedId;
        }
      }

      if (f.prixMin) filter.prix_min = Number(f.prixMin);
      if (f.prixMax) filter.prix_max = Number(f.prixMax);
      if (f.statut) {
        const map: Record<string, FilterProduitInput["statut"]> = {
          "en-vente": "EN_VENTE",
          "hors-ligne": "HORS_LIGNE",
          rupture: "RUPTURE",
          supprime: "SUPPRIME",
        };
        filter.statut = map[f.statut] || undefined;
      }
      if (f.dateFrom) filter.dateFrom = f.dateFrom;
      if (f.dateTo) filter.dateTo = f.dateTo;
      if (f.remise) (filter as any).remise = f.remise;
    }

    // Le bouton "Supprimé" force l'affichage des produits supprimés
    if (activeTab.value === "supprime") {
      filter.statut = "SUPPRIME";
    }

    const [page, totalAll] = await Promise.all([
      getProductsPage(filter),
      id_vendeur ? getTotalProduitsByVendeur(id_vendeur) : Promise.resolve(0),
    ]);

    // backend items: Produit[] →  ProduitCatalogue[]
    products.value = page.items.map(mapProduitToCatalogue);
    totalProducts.value = page.total;
    totalAllProducts.value = totalAll;

    // Mettre à jour le cache des couleurs par liaison (IDs normalisés en number)
    for (const prod of products.value) {
      const mainId = Number((prod as any).id_couleur_liee) || Number(prod.id);
      if (!liaisonColorsCache.value.has(mainId)) {
        liaisonColorsCache.value.set(mainId, new Set());
      }
      const colorSet = liaisonColorsCache.value.get(mainId)!;
      const cid = toColorId((prod as any).id_couleur);
      if (cid != null) colorSet.add(cid);
      if (prod.colorIds && Array.isArray(prod.colorIds)) {
        prod.colorIds.forEach((cid: unknown) => {
          const n = toColorId(cid);
          if (n != null) colorSet.add(n);
        });
      }
    }

    // Prefer images from backoffice uploads folder when available
    // Load lazily to avoid blocking list rendering
    const toAbsUrl = (p: string) => {
      if (!p) return "";
      // /uploads/products/{id}/Produits/... -> {storage}/Images/Boutiques/...
      return getProductStorageUrl(p);
    };

    // Mettre immédiatement à jour l'affichage de la liste
    filteredProducts.value = products.value;

    // Initialiser les niveaux de catégories pour les produits chargés
    initProductCategories();

    const loadImagesBatch = async (prods: ProduitCatalogue[]) => {
      if (!prods.length) return;
      try {
        const ids = prods
          .map((p) => Number(p.id))
          .filter((id) => Number.isFinite(id) && id > 0);
        const chunkSize = 200;
        const mergedPhotosByProduct: Record<number, string[]> = {};

        for (let i = 0; i < ids.length; i += chunkSize) {
          const chunk = ids.slice(i, i + chunkSize);
          const { success, photosByProduct } = await getProductPhotosBatch(
            chunk,
          );
          if (!success || !photosByProduct) continue;
          Object.assign(mergedPhotosByProduct, photosByProduct);
        }

        // Mettre à jour les images en une seule passe réactive
        const nextProducts = prods.map((prod) => {
          const photos = mergedPhotosByProduct[prod.id];
          const first =
            Array.isArray(photos) && photos.length ? photos[0] : undefined;
          // batch a une photo -> storage ; sinon, pas d'image (placeholder)
          const image = first ? toAbsUrl(first) : "";
          return {
            ...prod,
            image,
            nb_photos: first
              ? Math.max(Number(prod.nb_photos ?? 0), 1)
              : prod.nb_photos,
          };
        });

        products.value = nextProducts;
        filteredProducts.value = nextProducts;
        // Pas de fallback vers l’ancien serveur : les photos viennent du back Nest (symlink)
      } catch {
        // Ignorer les erreurs de chargement d'images
      }
    };
    await loadImagesBatch(products.value);
  } catch (err) {
    // Ne pas afficher d'alerte bloquante si l'erreur est liée à l'authentification.
    // Le garde d'auth se charge de rediriger vers la page de connexion.
    const message = String((err as any)?.message ?? err ?? "");
    if (
      message === "Unauthorized" ||
      message === "Non authentifié" ||
      message === "Authentification requise" ||
      /401/.test(message)
    ) {
      console.warn("Chargement produits interrompu (auth requise):", message);
    } else {
      console.error("Erreur lors du chargement des produits:", err);
      notifyError(
        "Impossible de charger la liste des produits. Veuillez réessayer.",
      );
    }
  } finally {
    isFiltering.value = false;
  }
};

const loadTotalAllProducts = async () => {
  try {
    const idVendeur = authStore.user?.id;
    if (!idVendeur) return;
    totalAllProducts.value = await getTotalProduitsByVendeur(idVendeur);
  } catch (err) {
    console.warn("Impossible de charger le total global des produits:", err);
  }
};

// Gestionnaires de pagination
const handlePageChange = async (newPage: number) => {
  currentPage.value = newPage;
  // Mettre à jour l'URL pour persister la page au refresh
  await router.replace({ query: { ...route.query, page: String(newPage) } });
  await loadProducts();
};

const handleItemsPerPageChange = async (newItemsPerPage: number) => {
  itemsPerPage.value = newItemsPerPage;
  currentPage.value = 1; // Retour à la première page lors du changement
  // Réinitialiser à la page 1 dans l'URL
  await router.replace({ query: { ...route.query, page: "1" } });
  await loadProducts();
};

// Filtres initiaux pour le composant ProductFilters
const initialFilters = computed<Partial<Filters>>(() => {
  // Récupérer depuis le store Pinia
  if (productsStore.filters) {
    return productsStore.filters;
  }

  // Par défaut, retourner un objet vide
  return {};
});

// Receive filters from child and reload with server-side filtering
const handleServerFilter = async (filters: Filters) => {
  // Vérifier si des filtres (hors tri par défaut) sont actifs
  const hasActiveFilters = Object.entries(filters).some(([key, value]) => {
    if (key === "tri") return value !== "date";
    return value !== null && value !== undefined && value !== "";
  });

  // Toujours conserver les filtres pour garder le tri sélectionné
  activeFilters.value = { ...filters };

  // Sauvegarder les filtres dans le store Pinia (null si tous vides et tri par défaut)
  productsStore.setFilters(
    hasActiveFilters || filters.tri !== "date" ? filters : null,
  );

  // Reset to first page when filters change (sauf au chargement initial)
  if (!isInitialLoad.value) {
    currentPage.value = 1;
    // Réinitialiser à la page 1 dans l'URL
    await router.replace({ query: { ...route.query, page: "1" } });
  }
  await loadProducts();
};

const loadCategories = async () => {
  categoriesTree.value = await getCategoriesTree("fr");
};

// Les filtres sont maintenant gérés par ProductFilters

/** IDs sélectionnables du groupe de couleurs liées (même liaison). */
const getSelectableLiaisonIds = (product: ProduitCatalogue): number[] => {
  const liaison = product.liaison?.trim();
  if (!liaison || liaison === "0") {
    return canSelectProduct(product) ? [Number(product.id)] : [];
  }
  return getProductsLinkedToMain(product)
    .filter((p) => canSelectProduct(p))
    .map((p) => Number(p.id));
};

/**
 * Option A : groupe replié → cocher la principale sélectionne toute la ref.
 * Groupe ouvert (ou vue grille) → chaque checkbox est indépendante.
 */
const shouldToggleWholeLiaisonGroup = (product: ProduitCatalogue): boolean => {
  if (viewMode.value === "grid") return false;
  if ((product as { isChild?: boolean }).isChild) return false;
  const liaison = product.liaison?.trim();
  if (!liaison || liaison === "0") return false;
  if (isExpanded(liaison)) return false;
  return getSelectableLiaisonIds(product).length > 1;
};

const isProductSelected = (product: ProduitCatalogue): boolean => {
  if (shouldToggleWholeLiaisonGroup(product)) {
    const ids = getSelectableLiaisonIds(product);
    return (
      ids.length > 0 &&
      ids.every((groupId) => selectedProducts.value.includes(groupId))
    );
  }
  return selectedProducts.value.includes(Number(product.id));
};

const isProductSelectionIndeterminate = (
  product: ProduitCatalogue,
): boolean => {
  if (!shouldToggleWholeLiaisonGroup(product)) return false;
  const ids = getSelectableLiaisonIds(product);
  const selectedCount = ids.filter((groupId) =>
    selectedProducts.value.includes(groupId),
  ).length;
  return selectedCount > 0 && selectedCount < ids.length;
};

/** Nombre sélectionné du groupe, affiché en overlay photo seulement si le groupe est replié. */
const getCollapsedGroupSelectedCount = (
  product: ProduitCatalogue & { hasSiblings?: boolean; isChild?: boolean },
): number => {
  if (viewMode.value === "grid") return 0;
  if (product.isChild) return 0;
  const liaison = product.liaison?.trim();
  if (!liaison || liaison === "0") return 0;
  if (isExpanded(liaison)) return 0;
  const ids = getSelectableLiaisonIds(product);
  if (ids.length <= 1) return 0;
  return ids.filter((groupId) => selectedProducts.value.includes(groupId))
    .length;
};

const handleProductSelection = (id: number, checked: boolean) => {
  const product =
    filteredProducts.value.find((p) => Number(p.id) === id) ??
    products.value.find((p) => Number(p.id) === id);
  if (!product || !canSelectProduct(product)) return;

  if (shouldToggleWholeLiaisonGroup(product)) {
    const groupIds = getSelectableLiaisonIds(product);
    const count = groupIds.length;
    if (checked) {
      selectedProducts.value = Array.from(
        new Set([...selectedProducts.value, ...groupIds]),
      );
      notifySuccess(
        count > 1
          ? `${count} couleurs sélectionnées pour cette référence`
          : `1 produit sélectionné`,
        2000,
      );
    } else {
      const toRemove = new Set(groupIds);
      selectedProducts.value = selectedProducts.value.filter(
        (pid) => !toRemove.has(Number(pid)),
      );
      notifySuccess(
        count > 1
          ? `${count} couleurs retirées de la sélection`
          : `1 produit retiré de la sélection`,
        2000,
      );
    }
    return;
  }

  if (checked) {
    if (!selectedProducts.value.includes(id)) {
      selectedProducts.value.push(id);
    }
  } else {
    selectedProducts.value = selectedProducts.value.filter((pid) => pid !== id);
  }
};

const saveProductData = async (
  id: number,
  field: string,
  rawValue: string | number | boolean,
  inputEl?: HTMLInputElement,
) => {
  const product = products.value.find((p) => p.id === id);
  if (!product) return;
  if (isProductLocked(product)) return;

  // Rétablit l'affichage du champ promotion sur sa valeur d'origine après une erreur
  const restorePromotionInput = () => {
    if (!inputEl) return;
    inputEl.value = getPromotionInputValue(product);
  };

  const patch: any = { id_produit: id };
  const authStore = useAuthStore();
  const id_vendeur = authStore.user?.id;
  const toNumber = (v: string | number | boolean): number | undefined => {
    if (typeof v === "number") return v;
    if (typeof v === "string") {
      if (v.trim() === "") return undefined;
      const n = Number(v);
      return Number.isNaN(n) ? undefined : n;
    }
    return undefined;
  };

  const parseDecimalInput = (
    v: string | number | boolean,
  ): number | undefined | null => {
    if (typeof v === "number") {
      return Number.isFinite(v) ? v : undefined;
    }

    if (typeof v !== "string") {
      return undefined;
    }

    const normalized = v.trim().replace(/,/g, ".");

    if (normalized === "") {
      return null;
    }

    if (!/^\d+(\.\d+)?$/.test(normalized)) {
      return undefined;
    }

    const n = Number(normalized);
    return Number.isNaN(n) ? undefined : n;
  };

  // Un produit déjà en ligne ne peut pas perdre sa catégorie.  Sans ce garde,
  // le select pouvait être vidé localement puis le patch partait avec une
  // catégorie nulle (ou, auparavant, l'ancienne catégorie restait en base).
  const isCategoryField =
    field === "catLevel1Id" ||
    field === "catLevel2Id" ||
    field === "catLevel3Id";
  if (
    isCategoryField &&
    hasVisibleProductInGroup(product) &&
    (rawValue === "" || toNumber(rawValue) == null)
  ) {
    notifyError(
      `${product.reference} : une catégorie est obligatoire pour un produit en ligne.`,
    );
    return;
  }

  switch (field) {
    case "prix": {
      const val =
        typeof rawValue === "string"
          ? parseFloat(rawValue) || 0
          : (rawValue as number);

      if (val < 0) {
        notifyError("Le prix ne peut pas être négatif");
        return;
      }

      if (product.prixReduit != null && val < product.prixReduit) {
        notifyError(
          "Le prix original ne peut pas être inférieur au prix promotionnel",
        );
        return;
      }

      product.prix = val;
      patch.prix = product.prix;

      // Propager aux enfants si c'est un produit lié
      if (
        product.liaison &&
        product.liaison !== "0" &&
        product.liaison !== ""
      ) {
        const isMain =
          String(product.id) === String(product.liaison) || product.main;
        if (isMain) {
          await Promise.all(
            products.value.map(async (p) => {
              if (p.liaison === product.liaison && p.id !== product.id) {
                p.prix = val;
                const childPatch: any = { id_produit: p.id, prix: val };
                // S'assurer que le prix promotionnel des enfants ne dépasse pas le nouveau prix
                if (p.prixReduit != null && p.prixReduit > val) {
                  p.prixReduit = val;
                  p.promotion = val;
                  childPatch.prixReduit = val;
                }

                // Update in filteredProducts too
                const filteredP = filteredProducts.value.find(
                  (fp) => fp.id === p.id,
                );
                if (filteredP) {
                  filteredP.prix = val;
                  if (
                    filteredP.prixReduit != null &&
                    filteredP.prixReduit > val
                  ) {
                    filteredP.prixReduit = val;
                    filteredP.promotion = val;
                  }
                }

                await updateProduit(childPatch);
              }
            }),
          );
          // Forcer la mise à jour de la réactivité pour le tableau
          filteredProducts.value = [...filteredProducts.value];
        }
      }
      break;
    }

    case "poids": {
      const parsedPoids =
        typeof rawValue === "string"
          ? parseFloat(rawValue) || 0
          : (rawValue as number);
      const poidsError = getMelUnitWeightError(parsedPoids);
      if (poidsError) {
        notifyError(poidsError);
        return;
      }
      product.poids = parsedPoids;
      patch.poids = product.poids;
      break;
    }

    case "reference":
      product.reference = rawValue as string;
      patch.reference = product.reference;
      break;

    case "marqueId": {
      const idMarque = toNumber(rawValue);
      product.marqueId = idMarque;

      const brand = brands.value.find((b) => b.number === idMarque);
      product.marque = brand?.name ?? "";

      patch.id_vendeur_marque = idMarque ?? null;

      // Propager aux enfants si c'est un produit lié
      if (
        product.liaison &&
        product.liaison !== "0" &&
        product.liaison !== ""
      ) {
        const isMain =
          String(product.id) === String(product.liaison) || product.main;
        if (isMain) {
          await Promise.all(
            products.value.map(async (p) => {
              if (p.liaison === product.liaison && p.id !== product.id) {
                p.marqueId = idMarque;
                p.marque = product.marque;

                // On met également à jour les objets dans filteredProducts pour la réactivité immédiate
                const filteredP = filteredProducts.value.find(
                  (fp) => fp.id === p.id,
                );
                if (filteredP) {
                  filteredP.marqueId = idMarque;
                  filteredP.marque = product.marque;
                }

                await updateProduit({
                  id_produit: p.id,
                  id_vendeur_marque: idMarque ?? null,
                });
              }
            }),
          );
          // Forcer la mise à jour de la réactivité pour le tableau
          filteredProducts.value = [...filteredProducts.value];
        }
      }
      break;
    }
    case "promotion": {
      if (typeof rawValue === "string" && rawValue.trim() === "") {
        product.prixReduit = null;

        await updateProduit({
          id_produit: id,
          prixReduit: null,
        });

        // Propager aux enfants si c'est un produit lié
        if (
          product.liaison &&
          product.liaison !== "0" &&
          product.liaison !== ""
        ) {
          const isMain =
            String(product.id) === String(product.liaison) || product.main;
          if (isMain) {
            await Promise.all(
              products.value.map(async (p) => {
                if (p.liaison === product.liaison && p.id !== product.id) {
                  p.prixReduit = null;
                  p.promotion = null;

                  // Update in filteredProducts too
                  const filteredP = filteredProducts.value.find(
                    (fp) => fp.id === p.id,
                  );
                  if (filteredP) {
                    filteredP.prixReduit = null;
                    filteredP.promotion = null;
                  }

                  await updateProduit({
                    id_produit: p.id,
                    prixReduit: null,
                  });
                }
              }),
            );
            // Forcer la mise à jour de la réactivité pour le tableau
            filteredProducts.value = [...filteredProducts.value];
          }
        }

        notifySuccess(
          `Prix promotionnel du produit ${product.reference} supprimé`,
        );
        return;
      }

      const parsedPromotion = parseDecimalInput(rawValue);

      if (parsedPromotion === undefined) {
        notifyError("Veuillez saisir un prix promotionnel valide");
        restorePromotionInput();
        return;
      }

      const num = parsedPromotion;

      if (num != null && num <= 0) {
        notifyError("Le prix promotionnel doit être supérieur à 0");
        restorePromotionInput();
        return;
      }

      if (num != null && product.prix != null && num > product.prix) {
        notifyError(
          "Le prix promotionnel ne peut pas être supérieur au prix original",
        );
        restorePromotionInput();
        return;
      }

      if (num != null && product.prix != null && num === product.prix) {
        notifyError(
          "Le prix promotionnel ne peut pas être identique au prix original",
        );
        restorePromotionInput();
        return;
      }

      product.prixReduit = num ?? null;

      try {
        await updateProduit({
          id_produit: id,
          prixReduit: num ?? null,
        });

        // Propager aux enfants si c'est un produit lié
        if (
          product.liaison &&
          product.liaison !== "0" &&
          product.liaison !== ""
        ) {
          const isMain =
            String(product.id) === String(product.liaison) || product.main;
          if (isMain) {
            await Promise.all(
              products.value.map(async (p) => {
                if (p.liaison === product.liaison && p.id !== product.id) {
                  p.prixReduit = num ?? null;
                  p.promotion = num ?? null;

                  // Update in filteredProducts too
                  const filteredP = filteredProducts.value.find(
                    (fp) => fp.id === p.id,
                  );
                  if (filteredP) {
                    filteredP.prixReduit = num ?? null;
                    filteredP.promotion = num ?? null;
                  }

                  await updateProduit({
                    id_produit: p.id,
                    prixReduit: num ?? null,
                  });
                }
              }),
            );
            // Forcer la mise à jour de la réactivité pour le tableau
            filteredProducts.value = [...filteredProducts.value];
          }
        }

        notifySuccess(
          `Prix promotionnel du produit ${product.reference} sauvegardé`,
        );
      } catch (e) {
        notifyError(
          `Erreur lors de la sauvegarde du prix promotionnel du produit ${product.reference}`,
        );
      }
      return;
    }

    case "venduPar":
      product.venduPar = rawValue as string;
      patch.vendu_par = product.venduPar;
      break;

    case "visible":
      if (rawValue) {
        const blocker = getPublishBlocker(product);
        if (blocker) {
          if (inputEl) inputEl.checked = false;
          notifyError(`${product.reference} : ${blocker}`);
          return;
        }
      }
      product.visible = Boolean(rawValue);
      patch.visible = product.visible;
      // Mettre à jour le statut en fonction de la visibilité et du stock
      product.statut = !product.visible
        ? "hors-ligne"
        : (product as any).stock_renseigne && (product as any).stock_value === 0
        ? "rupture"
        : "en-vente";
      break;

    case "packId": {
      const idPack = toNumber(rawValue);
      product.packId = idPack ?? 0;
      product.pack = idPack ?? 0;

      patch.id_pack = idPack ?? null;

      // Propager à tous les frères/sœurs (champ partagé entre toutes les couleurs)
      if (
        product.liaison &&
        product.liaison !== "0" &&
        product.liaison !== ""
      ) {
        await Promise.all(
          products.value.map(async (p) => {
            if (p.liaison === product.liaison && p.id !== product.id) {
              p.packId = idPack ?? 0;
              p.pack = idPack ?? 0;

              const filteredP = filteredProducts.value.find(
                (fp) => fp.id === p.id,
              );
              if (filteredP) {
                filteredP.packId = idPack ?? 0;
                filteredP.pack = idPack ?? 0;
              }
            }
          }),
        );
        filteredProducts.value = [...filteredProducts.value];
      }
      break;
    }
    case "declinaisonId": {
      const idDecl = toNumber(rawValue);

      if (idDecl == null) {
        product.declinaisonId = undefined;
        product.declinaison = 0;
        patch.id_declinaison = null;
      } else {
        product.declinaisonId = idDecl;
        product.declinaison = idDecl;
        patch.id_declinaison = idDecl;
      }

      // Propager à tous les frères/sœurs (champ partagé entre toutes les couleurs)
      if (
        product.liaison &&
        product.liaison !== "0" &&
        product.liaison !== ""
      ) {
        await Promise.all(
          products.value.map(async (p) => {
            if (p.liaison === product.liaison && p.id !== product.id) {
              p.declinaisonId = idDecl == null ? undefined : idDecl;
              p.declinaison = idDecl == null ? 0 : idDecl;

              const filteredP = filteredProducts.value.find(
                (fp) => fp.id === p.id,
              );
              if (filteredP) {
                filteredP.declinaisonId = idDecl == null ? undefined : idDecl;
                filteredP.declinaison = idDecl == null ? 0 : idDecl;
              }
            }
          }),
        );
        filteredProducts.value = [...filteredProducts.value];
      }
      break;
    }

    case "provenance": {
      const idProv = toNumber(rawValue);
      (product as any).id_provenance = idProv ?? null;
      patch.id_provenance = idProv ?? null;

      // Propager à tous les frères/sœurs (champ partagé entre toutes les couleurs)
      if (
        product.liaison &&
        product.liaison !== "0" &&
        product.liaison !== ""
      ) {
        await Promise.all(
          products.value.map(async (p) => {
            if (p.liaison === product.liaison && p.id !== product.id) {
              (p as any).id_provenance = idProv ?? null;

              const filteredP = filteredProducts.value.find(
                (fp) => fp.id === p.id,
              );
              if (filteredP) {
                (filteredP as any).id_provenance = idProv ?? null;
              }
            }
          }),
        );
        filteredProducts.value = [...filteredProducts.value];
      }
      break;
    }

    /* ---------- Collection ---------- */
    case "collectionId": {
      const idCol = toNumber(rawValue);
      product.collectionId = idCol;
      const col = collections.value.find((c) => c.id_collection === idCol);
      product.collection = col?.libelle ?? "";
      patch.id_collection = idCol ?? null;

      // Propager à tous les frères/sœurs (champ partagé entre toutes les couleurs)
      if (
        product.liaison &&
        product.liaison !== "0" &&
        product.liaison !== ""
      ) {
        await Promise.all(
          products.value.map(async (p) => {
            if (p.liaison === product.liaison && p.id !== product.id) {
              p.collectionId = idCol;
              p.collection = product.collection;
            }
          }),
        );
        // Forcer la mise à jour de la réactivité pour le tableau
        filteredProducts.value = [...filteredProducts.value];
      }
      break;
    }

    /* ---------- niveau 3 ---------- */
    case "catLevel1Id": {
      product.catLevel1Id = toNumber(rawValue);
      product.catLevel2Id = undefined;
      product.catLevel3Id = undefined;

      // Propager à tous les frères/sœurs (champ partagé entre toutes les couleurs)
      if (
        product.liaison &&
        product.liaison !== "0" &&
        product.liaison !== ""
      ) {
        await Promise.all(
          products.value.map(async (p) => {
            if (p.liaison === product.liaison && p.id !== product.id) {
              p.catLevel1Id = product.catLevel1Id;
              p.catLevel2Id = product.catLevel2Id;
              p.catLevel3Id = product.catLevel3Id;
            }
          }),
        );
        // Forcer la mise à jour de la réactivité pour le tableau
        filteredProducts.value = [...filteredProducts.value];
      }
      break;
    }

    case "catLevel2Id": {
      product.catLevel2Id = toNumber(rawValue);
      product.catLevel3Id = undefined;

      // Propager à tous les frères/sœurs (champ partagé entre toutes les couleurs)
      if (
        product.liaison &&
        product.liaison !== "0" &&
        product.liaison !== ""
      ) {
        await Promise.all(
          products.value.map(async (p) => {
            if (p.liaison === product.liaison && p.id !== product.id) {
              p.catLevel1Id = product.catLevel1Id;
              p.catLevel2Id = product.catLevel2Id;
              p.catLevel3Id = product.catLevel3Id;
            }
          }),
        );
        // Forcer la mise à jour de la réactivité pour le tableau
        filteredProducts.value = [...filteredProducts.value];
      }
      break;
    }

    case "catLevel3Id": {
      product.catLevel3Id = toNumber(rawValue);

      // Propager à tous les frères/sœurs (champ partagé entre toutes les couleurs)
      if (
        product.liaison &&
        product.liaison !== "0" &&
        product.liaison !== ""
      ) {
        await Promise.all(
          products.value.map(async (p) => {
            if (p.liaison === product.liaison && p.id !== product.id) {
              p.catLevel1Id = product.catLevel1Id;
              p.catLevel2Id = product.catLevel2Id;
              p.catLevel3Id = product.catLevel3Id;
            }
          }),
        );
        // Forcer la mise à jour de la réactivité pour le tableau
        filteredProducts.value = [...filteredProducts.value];
      }
      break;
    }
  }

  if (
    isCategoryField
  ) {
    const leafId =
      product.catLevel3Id ?? product.catLevel2Id ?? product.catLevel1Id;

    // Les sélecteurs sont en cascade : les changements de niveau 1/2 sont
    // intermédiaires. Ne pas écrire une catégorie parente en base pour un
    // produit dont une couleur est déjà en ligne ; l'écriture sera faite au
    // choix du niveau final.
    const selectedCategory = leafId
      ? findCategoryNode(categoriesTree.value, Number(leafId))
      : null;
    if (hasVisibleProductInGroup(product) && selectedCategory?.children?.length) {
      return;
    }

    patch.id_categorie = leafId ?? null;
    (product as any).id_categorie = leafId ?? null;
  }

  if (Object.keys(patch).length > 1) {
    try {
      const res = await updateProduit(patch);
      notifySuccess(`Produit ${product.reference} - ${field} sauvegardé`);
    } catch (e) {
      notifyError(
        e instanceof Error && e.message.trim()
          ? e.message
          : `Erreur lors de la sauvegarde du produit ${product.reference}`,
      );
    }
  }
};

// const handleEditProduct = (id: number) => {
//   const product = products.value.find(p => p.id === id)
//   if (product) {
//     alert(`Édition du produit ${product.reference}`)
//   }
// }
//
// const handleDuplicateProduct = (id: number) => {
//   const product = products.value.find(p => p.id === id)
//   if (product) {
//     const newProduct = { ...product, id: Date.now(), reference: `${product.reference}-COPY` }
//     products.value.push(newProduct)
//     alert(`Produit ${product.reference} dupliqué`)
//   }
// }

// const handleCopyProduct = (id: number) => {
//   const product = products.value.find(p => p.id === id)
//   if (product) {
//     const newProduct = { ...product, id: Date.now(), reference: `${product.reference}-COPY` }
//     products.value.push(newProduct)
//     alert(`Produit ${product.reference} copié`)
//   }
// }
const toggleActionMenu = async (id: number, event?: MouseEvent) => {
  if (openActionMenuId.value === id) {
    openActionMenuId.value = null;
  } else {
    if (event) {
      const button = (event.target as HTMLElement).closest("button");
      if (button) {
        const rect = button.getBoundingClientRect();
        // 先设置初始位置（在按钮下方）
        actionMenuPosition.value = {
          top: rect.bottom + 4,
          left: rect.left,
        };
        openActionMenuId.value = id;

        // 等待菜单渲染后调整位置
        await nextTick();
        const menu = document.querySelector(
          ".fixed.bg-white.border.border-gray-200.rounded-md.shadow-lg",
        ) as HTMLElement;
        if (menu) {
          const menuRect = menu.getBoundingClientRect();
          const viewportHeight = window.innerHeight;

          // 如果菜单超出视口底部，移到按钮上方
          if (menuRect.bottom > viewportHeight) {
            actionMenuPosition.value = {
              top: rect.top - menuRect.height - 4,
              left: rect.left,
            };
          }
        }
      }
    } else {
      openActionMenuId.value = id;
    }
  }
};

// Génère un slug URL-friendly à partir d'une chaîne
const getSlug = (str: string): string => {
  return str
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "") // Supprime les accents
    .replace(/[^a-z0-9]+/g, "-") // Remplace les caractères spéciaux par des tirets
    .replace(/^-+|-+$/g, ""); // Supprime les tirets en début/fin
};

// Fonction pour obtenir l'URL du site acheteur pour le produit
const getAcheteurUrl = (product: any): string => {
  // Si le produit a une URL acheteur générée par le backend (produit visible sur le site)
  if (product.acheteurUrl) {
    return product.acheteurUrl;
  }
  // Sinon, rediriger vers la page du vendeur (voir ma page)
  const idVendeur = authStore.user?.id;
  const nomBoutique = authStore.user?.nomBoutique || "";
  if (nomBoutique && idVendeur) {
    const slug = getSlug(nomBoutique);
    return `https://www.efashion-paris.com/vendeurs/${slug}-${idVendeur}.html`;
  }
  return `https://www.efashion-paris.com/boutique/${idVendeur}.html`;
};

// Fonction pour obtenir l'URL acheteur et naviguer
const logVoirMaPageClick = async (event: Event, product: any) => {
  // Empêcher la navigation par défaut du lien
  event.preventDefault();

  // Appeler l'API pour obtenir l'URL acheteur
  const acheteurUrl = await getProductAcheteurUrl(product.id);

  // Déterminer l'URL finale
  const finalUrl = acheteurUrl || getAcheteurUrl(product);

  // Ouvrir l'URL dans un nouvel onglet
  window.open(finalUrl, "_blank");
};

const handleEditProduct = (id: number) => {
  openActionMenuId.value = null;
  const product = products.value.find((p) => p.id === id);
  if (product) {
    activeProductForSheet.value = { ...product };
    ficheModalVisible.value = true;
  }
};

const handleRowClick = (row: ProduitCatalogue) => {
  if (isProductLocked(row)) {
    // Produit verrouille: autoriser uniquement l'ouverture/fermeture des sous-produits
    if (row.hasSiblings && row.liaison) {
      toggleLiaison(row.liaison);
    }
    return;
  }
  if (row.hasSiblings && row.liaison) {
    toggleLiaison(row.liaison);
  } else {
    handleEditProduct(Number(row.id));
  }
};

// Fonction helper pour détecter si on est sur mobile
const isMobileDevice = () => {
  if (typeof window === "undefined") return false;
  return window.matchMedia("(max-width: 767px)").matches;
};

const handleDuplicateProduct = (id: number) => {
  openActionMenuId.value = null;
  const product = products.value.find((p) => p.id === id);
  productToDuplicateId.value = id;
  duplicateOriginalRef.value = product?.reference || String(id);
  duplicateNewReference.value = "";
  duplicateConfirmVisible.value = true;
};

const runSetAsPrincipale = async (product: any) => {
  isSettingMainProduct.value = true;

  try {
    const siblingIds = getLoadedSiblingIdsForMainChange(
      product as ProduitCatalogue,
    );
    const productId = Number(product.id);
    siblingIds.add(productId);

    // Source de vérité côté backend:
    // recale la liaison et le main sur tout le groupe (même brouillons/supprimés).
    // Règle BOV : si la couleur promue est non visible (hors ligne), le backend
    // met tout le groupe hors ligne (applyOfflineRule = action manuelle).
    await toggleMainProduct(productId, product.visible === false);

    // Synchroniser ensuite marque/prix/promo sur les produits chargés.
    for (const siblingId of siblingIds) {
      await updateProduit({
        id_produit: siblingId,
        id_vendeur_marque: product.marqueId ?? null,
        prix: product.prix,
        prixReduit: product.prixReduit ?? null,
      });
    }

    await loadProducts();
    notifySuccess(
      `Le produit ${product.reference} est maintenant le produit principal`,
    );
  } catch (e) {
    notifyError(`Erreur lors du changement de produit principal`);
    console.error(e);
  } finally {
    isSettingMainProduct.value = false;
  }
};

const handleSetAsPrincipale = async (product: any) => {
  if (isSettingMainProduct.value) return;
  openActionMenuId.value = null;
  if (!product.liaison || product.liaison === "0") return;

  if (product.visible === false) {
    pendingSetMainProductId.value = Number(product.id);
    invisibleSecondaryToMainConfirmVisible.value = true;
    return;
  }

  await runSetAsPrincipale(product);
};

const confirmSetInvisibleSecondaryAsMain = async () => {
  if (isSettingMainProduct.value) return;
  const pendingId = pendingSetMainProductId.value;
  if (!pendingId) return;

  const product = products.value.find(
    (p) => Number(p.id) === Number(pendingId),
  );
  if (!product) {
    invisibleSecondaryToMainConfirmVisible.value = false;
    pendingSetMainProductId.value = null;
    notifyError("Produit introuvable pour le passage en principale.");
    return;
  }

  invisibleSecondaryToMainConfirmVisible.value = false;
  pendingSetMainProductId.value = null;
  await runSetAsPrincipale(product);
};

const cancelSetInvisibleSecondaryAsMain = () => {
  if (isSettingMainProduct.value) return;
  invisibleSecondaryToMainConfirmVisible.value = false;
  pendingSetMainProductId.value = null;
};

const confirmDuplicate = async () => {
  const newReference = duplicateNewReference.value.trim();
  if (!productToDuplicateId.value || !newReference) {
    notifyError("La nouvelle référence de base est obligatoire.");
    return;
  }

  const product = products.value.find(
    (p) => p.id === productToDuplicateId.value,
  );
  if (!product) {
    duplicateConfirmVisible.value = false;
    return;
  }

  isDuplicating.value = true;
  try {
    await duplicateProduitForMel(
      product.id,
      newReference,
      authStore.user?.id,
    );

    await loadProducts();
    initProductCategories();
    filteredProducts.value = products.value;

    notifySuccess(
      `Produit ${product.reference} dupliqué avec la référence ${newReference}`,
    );
  } catch (e: any) {
    notifyError(
      e.message ||
        `Erreur lors de la duplication du produit ${product.reference}`,
    );
  } finally {
    isDuplicating.value = false;
    duplicateConfirmVisible.value = false;
    productToDuplicateId.value = null;
    duplicateNewReference.value = "";
    duplicateOriginalRef.value = "";
  }
};

const handlePendingCover = (payload: {
  productId: number;
  coverUrl: string;
  nbPhotos?: number;
}) => {
  pendingCoverByProductId.value = {
    ...pendingCoverByProductId.value,
    [payload.productId]: payload.coverUrl,
  };
  // Bump cache buster pour forcer le rafraîchissement immédiat de l'image
  // dans la liste (sans F5, sans impact sur les autres modules)
  productImageCacheBuster.value = {
    ...productImageCacheBuster.value,
    [payload.productId]: bumpPhotoVersion(payload.productId),
  };

  // Synchroniser nb_photos pour éviter que la liste retombe sur le placeholder
  // "sans photo" après fermeture du modal / rechargement.
  const syncNbPhotos = (arr: ProduitCatalogue[]) => {
    const p = arr.find((x) => x.id === payload.productId);
    if (!p) return;
    if (typeof payload.nbPhotos === "number") {
      p.nb_photos = payload.nbPhotos;
    } else if ((p.nb_photos ?? 0) <= 0 && payload.coverUrl) {
      p.nb_photos = 1;
    }
  };
  syncNbPhotos(products.value);
  syncNbPhotos(filteredProducts.value);
};

const handleSheetVisibleUpdate = async (v: boolean) => {
  ficheModalVisible.value = v;
  if (!v) {
    const closedProductId = activeProductForSheet.value?.id;
    // Ne PAS supprimer pendingCoverByProductId[closedProductId] ici :
    // sinon, tant que loadProducts() n'a pas ramené le nouveau nb_photos
    // depuis le backend, la ligne retomberait sur le placeholder "sans photo".
    // Le cache temporaire sera nettoyé naturellement au prochain loadProducts
    // (ou laissé tel quel sans effet néfaste : il sert juste de fallback).
    if (closedProductId) {
      productImageCacheBuster.value = {
        ...productImageCacheBuster.value,
        [closedProductId]: bumpPhotoVersion(closedProductId),
      };
    }
    // Forcer la synchronisation depuis le backend (nb_photos, visible, stock, etc.)
    // pour éviter que l'utilisateur doive rafraîchir manuellement la page avant
    // de pouvoir cliquer sur « Mettre en ligne » après un upload de photo sur
    // une variante.
    try {
      await loadProducts();
    } catch (e) {
      console.error("Refresh after sheet close failed:", e);
    }
  }
};

const handleProductSheetStocksUpdated = (payload: {
  id_produit: number;
  stock_value: number;
  stock_renseigne: boolean;
  stocks: ColorStockRow[];
}) => {
  const idProduit = Number(payload.id_produit);
  productStocksMap.value.set(idProduit, payload.stocks);
  patchProductStockLocal(
    idProduit,
    payload.stock_value,
    payload.stock_renseigne,
  );
  filteredProducts.value = [...filteredProducts.value];
};

const handleSaveProductSheet = async (rawPayload: ProduitCatalogue & any) => {
  const {
    __resolveProductSave,
    __rejectProductSave,
    venduParChanged,
    ...payload
  } = rawPayload;

  const product = products.value.find((p) => p.id === payload.id);
  if (!product) {
    __rejectProductSave?.(new Error("Produit introuvable"));
    return;
  }

  const poidsError = getMelUnitWeightError(payload.poids);
  if (poidsError) {
    notifyError(poidsError);
    __rejectProductSave?.(new Error(poidsError));
    return;
  }

  // Préserver visible du payload ou utiliser celui du product existant
  const visible =
    payload.visible !== undefined ? payload.visible : product.visible;

  // Le formulaire peut envoyer explicitement `null` quand l'utilisateur
  // efface les trois niveaux.  Il faut distinguer ce cas d'un ancien payload
  // qui ne contenait aucun champ de catégorie, sinon la suppression restait
  // silencieusement ignorée par le patch.
  const hasCategoryFields =
    "catLevel1Id" in payload ||
    "catLevel2Id" in payload ||
    "catLevel3Id" in payload ||
    "id_categorie" in payload;
  const requestedCategoryRaw = hasCategoryFields
    ? payload.catLevel3Id ??
      payload.catLevel2Id ??
      payload.catLevel1Id ??
      payload.id_categorie
    : getProductCategoryId(product);
  const requestedCategoryId =
    requestedCategoryRaw == null || requestedCategoryRaw === ""
      ? null
      : Number(requestedCategoryRaw);
  const normalizedCategoryId =
    requestedCategoryId != null &&
    Number.isFinite(requestedCategoryId) &&
    requestedCategoryId > 0
      ? requestedCategoryId
      : null;

  if (!normalizedCategoryId && hasVisibleProductInGroup(product)) {
    const message =
      "Une catégorie est obligatoire pour enregistrer une référence dont une couleur est en ligne.";
    notifyError(message);
    __rejectProductSave?.(new Error(message));
    return;
  }
  if (hasVisibleProductInGroup(product)) {
    const selectedCategory = findCategoryNode(
      categoriesTree.value,
      normalizedCategoryId ?? 0,
    );
    if (selectedCategory?.children?.length) {
      const message =
        "Une catégorie finale est obligatoire pour enregistrer une référence en ligne.";
      notifyError(message);
      __rejectProductSave?.(new Error(message));
      return;
    }
  }

  // La référence de base est la clé métier affichée et propagée aux couleurs.
  // Ne jamais la remplacer implicitement par l'ancienne référence après une
  // saisie vide : cela donnait des doublons et rendait le changement de base
  // impossible à diagnostiquer dans la liste.
  const requestedReferenceBase =
    payload.reference_base !== undefined
      ? String(payload.reference_base ?? "").trim()
      : String(
          (product as any).reference_base ?? product.reference ?? "",
        ).trim();
  if (!requestedReferenceBase) {
    const message = "La référence de base est obligatoire.";
    notifyError(message);
    __rejectProductSave?.(new Error(message));
    return;
  }

  Object.assign(product, payload);

  // S'assurer que visible est bien défini
  product.visible = visible;

  // Mettre à jour stock_value et stock_renseigne si présents dans le payload
  const stockValue =
    (payload as any).stock_value !== undefined
      ? (payload as any).stock_value
      : (product as any).stock_value;
  const stockRenseigne =
    (payload as any).stock_renseigne !== undefined
      ? (payload as any).stock_renseigne
      : (product as any).stock_renseigne ?? false;

  (product as any).stock_value = stockValue;
  (product as any).stock_renseigne = stockRenseigne;

  // Recalculer le statut (aligné ancien système : rupture = stock renseigné et tout à 0)
  product.statut = !product.visible
    ? "hors-ligne"
    : stockRenseigne && stockValue === 0
    ? "rupture"
    : "en-vente";

  // Mettre à jour aussi dans filteredProducts pour rafraîchir le badge
  const filteredProduct = filteredProducts.value.find(
    (p) => p.id === payload.id,
  );
  if (filteredProduct) {
    // Préserver visible
    const filteredVisible =
      payload.visible !== undefined ? payload.visible : filteredProduct.visible;

    Object.assign(filteredProduct, payload);
    filteredProduct.visible = filteredVisible;

    const filteredStockValue =
      (payload as any).stock_value !== undefined
        ? (payload as any).stock_value
        : (filteredProduct as any).stock_value;
    const filteredStockRenseigne =
      (payload as any).stock_renseigne !== undefined
        ? (payload as any).stock_renseigne
        : (filteredProduct as any).stock_renseigne ?? false;

    (filteredProduct as any).stock_value = filteredStockValue;
    (filteredProduct as any).stock_renseigne = filteredStockRenseigne;

    filteredProduct.statut = !filteredProduct.visible
      ? "hors-ligne"
      : filteredStockRenseigne && filteredStockValue === 0
      ? "rupture"
      : "en-vente";
  }

  if (product.prix != null && product.prix < 0) {
    notifyError("Le prix ne peut pas être négatif");
    product.prix = 0;
  }

  if (product.promotion != null && Number(product.promotion) < 0) {
    notifyError("La promotion ne peut pas être négative");
    product.promotion = 0;
  }

  if (product.marqueId != null) {
    const brand = brands.value.find((b) => b.number === product.marqueId);
    product.marque = brand?.name ?? "";
  }

  const id_categorie = normalizedCategoryId;
  (product as any).id_categorie = id_categorie;

  const patch: any = { id_produit: product.id };

  const newReferenceBase = requestedReferenceBase;
  const productColor = (product.couleur || "").trim();
  if (!productColor) {
    notifyError(
      "Une couleur est obligatoire pour enregistrer la référence de base.",
    );
    __rejectProductSave?.(new Error("Couleur manquante"));
    return;
  }
  const newReference = `${newReferenceBase}-${productColor.toUpperCase()}`;

  (product as any).reference_base = newReferenceBase;
  product.reference = newReference;

  patch.reference_base = newReferenceBase;
  patch.reference = newReference;
  patch.prix = product.prix;
  // 0 n'est pas une promotion : on enregistre null, pas 0.
  patch.prixReduit =
    readPositivePrice(product.prixReduit) ??
    readPositivePrice(product.promotion);

  // Validation: prix réduit doit être inférieur au prix
  if (
    patch.prixReduit != null &&
    patch.prix != null &&
    patch.prixReduit >= patch.prix
  ) {
    notifyError("Le prix réduit doit être inférieur au prix.");
    __rejectProductSave?.(new Error("Prix réduit invalide"));
    return;
  }

  patch.poids = product.poids;
  patch.dimension = product.dimensions ?? null;
  patch.vendu_par = product.venduPar;
  patch.visible = product.visible;
  patch.id_vendeur_marque = product.marqueId ?? null;

  patch.id_provenance = (product as any).id_provenance ?? null;
  patch.id_collection = (product as any).id_collection ?? null;

  // Déclinaison et pack
  const declinaisonId =
    (product as any).declinaisonId ?? (product as any).id_declinaison;
  const packId = (product as any).packId ?? (product as any).id_pack;
  // Règle métier: si une déclinaison est sélectionnée, le pack doit être sélectionné
  // sauf lorsque le produit est vendu par « Tailles aux choix »
  const venduPar = (product as any).venduPar ?? (product as any).vendu_par;
  if (declinaisonId && !packId && venduPar !== "tailles") {
    notifyError(
      "Veuillez sélectionner un Pack lorsque vous choisissez une Déclinaison.",
    );
    return;
  }
  patch.id_declinaison = declinaisonId ?? null;
  patch.id_pack = packId ?? null;

  // Toujours envoyer le champ, y compris `null`, afin que le backend puisse
  // réellement retirer une catégorie lorsqu'un brouillon est édité.
  patch.id_categorie = id_categorie;

  try {
    await updateProduit(patch);

    // Propager les champs partagés à tous les frères/sœurs (toutes les couleurs)
    if (product.liaison && product.liaison !== "0" && product.liaison !== "") {
      const isMain =
        String(product.id) === String(product.liaison) || product.main;
      await Promise.all(
        products.value.map(async (p) => {
          if (p.liaison === product.liaison && p.id !== product.id) {
            const siblingColor = p.couleur || "";
            const siblingReference = siblingColor
              ? `${newReferenceBase}-${siblingColor.toUpperCase()}`
              : newReferenceBase;

            // Champs partagés entre toutes les couleurs (propagés par n'importe quel produit)
            const siblingPatch: any = {
              id_produit: p.id,
              id_declinaison: patch.id_declinaison,
              id_pack: patch.id_pack,
              id_provenance: patch.id_provenance,
              id_collection: patch.id_collection,
              id_categorie: patch.id_categorie,
              dimension: patch.dimension,
            };

            if (patch.vendu_par !== undefined) {
              siblingPatch.vendu_par = patch.vendu_par;
            }

            // Prix, prixReduit, marque et poids : propagés uniquement depuis le produit principal
            if (isMain) {
              siblingPatch.prix = product.prix;
              siblingPatch.id_vendeur_marque = product.marqueId ?? null;
              siblingPatch.prixReduit = patch.prixReduit;
              siblingPatch.poids = product.poids;
            }

            await updateProduit(siblingPatch);

            // Mettre à jour l'objet local pour la réactivité (champs partagés)
            (p as any).reference_base = newReferenceBase;
            p.reference = siblingReference;
            p.collectionId = product.collectionId;
            p.collection = product.collection;
            p.catLevel1Id = product.catLevel1Id;
            p.catLevel2Id = product.catLevel2Id;
            p.catLevel3Id = product.catLevel3Id;
            p.declinaisonId = (product as any).declinaisonId;
            p.packId = (product as any).packId;
            (p as any).id_provenance = (product as any).id_provenance;
            p.dimensions = product.dimensions;

            if (patch.vendu_par !== undefined) {
              p.venduPar = product.venduPar;
              (p as any).vendu_par = patch.vendu_par;
              productStocksMap.value.delete(p.id);
              if (venduParChanged) {
                (p as any).stock_value = 0;
                (p as any).stock_renseigne = false;
                if (!p.visible) {
                  p.statut = "hors-ligne";
                } else {
                  p.statut = "rupture";
                }
              }
            }

            // Prix, prixReduit, marque et poids : réactivité uniquement depuis le produit principal
            if (isMain) {
              p.prix = product.prix;
              p.marqueId = product.marqueId;
              p.marque = product.marque;
              p.prixReduit = patch.prixReduit;
              p.promotion = patch.prixReduit;
              p.poids = product.poids;
            }
          }
        }),
      );
      // Forcer la mise à jour de la réactivité
      filteredProducts.value = [...filteredProducts.value];
    }

    // prixReduit est déjà sauvegardé directement via updateProduit (patch.prixReduit)
    // Ne pas appeler updateProduitPromotion ici car c'est une interface de remise en pourcentage

    notifySuccess(`Fiche du produit ${product.reference} sauvegardée`);

    // Forcer la mise à jour de la réactivité pour rafraîchir les badges de statut
    filteredProducts.value = [...filteredProducts.value];

    // Forcer le rechargement de l'image du produit (éviter cache navigateur après modif photos)
    productImageCacheBuster.value = {
      ...productImageCacheBuster.value,
      [payload.id]: bumpPhotoVersion(payload.id),
    };

    __resolveProductSave?.();
  } catch (e) {
    console.error(e);
    notifyError(
      e instanceof Error && e.message.trim()
        ? e.message
        : `Erreur lors de la sauvegarde de la fiche du produit ${product.reference}`,
    );
    __rejectProductSave?.(e);
  }
};

const handleCopyProduct = async (id: number) => {
  openActionMenuId.value = null;
  const product = products.value.find((p) => p.id === id);
  if (!product) return;

  let compositionsRaw = "";
  try {
    const rows = await getProduitCompositions(id, "fr");
    compositionsRaw = rows
      .map((r: any) => {
        const fam = r.famille && r.famille.trim();
        const label = r.libelle?.trim() ?? "";
        const val = Number(r.value) || 0;

        if (!label) return "";

        if (fam) {
          return `${fam}*${label}*${val}`;
        }
        return `${label}*${val}`;
      })
      .filter(Boolean)
      .join(",");
  } catch (e) {
    // Erreur silencieuse lors du chargement des compositions
  }

  const productForMel = {
    ...product,
    compositionsRaw,
  };

  melStore.setPrefillProduct(productForMel);
  router.push({ name: "catalog/mel" });
};

// const handleDeleteProduct = (id: number) => {
//   const product = products.value.find(p => p.id === id)
//   if (product && confirm(`Êtes-vous sûr de vouloir supprimer le produit ${product.reference} ?`)) {
//     products.value = products.value.filter(p => p.id !== id)
//     alert(`Produit ${product.reference} supprimé`)
//   }
// }

const handleDeleteProduct = async (id: number) => {
  const product = products.value.find((p) => p.id === id);
  if (!product) return;

  if (isMainProduct(product)) {
    const successors = getProductsLinkedToMain(product).filter(
      (candidate) =>
        Number(candidate.id) !== Number(product.id) &&
        !isProductLocked(candidate),
    );

    if (successors.length > 0) {
      deleteMainPending.value = {
        product,
        successorId: null,
        successors,
      };
      deleteMainConfirmVisible.value = true;
      return;
    }
  }

  if (
    !confirm(
      `Êtes-vous sûr de vouloir supprimer le produit ${product.reference} ?`,
    )
  ) {
    return;
  }

  try {
    await softDeleteProduits([id]);
    selectedProducts.value = selectedProducts.value.filter((pid) => pid !== id);
    await loadProducts();
    notifySuccess(`Produit ${product.reference} supprimé avec succès.`);
  } catch (e) {
    notifyError(
      `Erreur lors de la suppression du produit ${product.reference}.`,
    );
  }
};

const selectDeleteMainSuccessor = (successorId: number) => {
  if (!deleteMainPending.value) return;
  deleteMainPending.value.successorId = successorId || null;
};

const cancelDeleteMainProduct = () => {
  deleteMainConfirmVisible.value = false;
  deleteMainPending.value = null;
};

const confirmDeleteMainProduct = async () => {
  const pending = deleteMainPending.value;
  if (!pending?.successorId) return;

  try {
    await toggleMainProduct(pending.successorId);
    await softDeleteProduits([pending.product.id]);

    products.value = products.value.filter(
      (product) => product.id !== pending.product.id,
    );
    filteredProducts.value = filteredProducts.value.filter(
      (product) => product.id !== pending.product.id,
    );
    selectedProducts.value = selectedProducts.value.filter(
      (id) => id !== pending.product.id,
    );

    notifySuccess(
      `Produit ${pending.product.reference} supprimé et nouvelle couleur principale définie.`,
    );
    deleteMainConfirmVisible.value = false;
    deleteMainPending.value = null;
    await loadProducts();
  } catch (e) {
    notifyError(
      `Erreur lors du changement de couleur principale ou de la suppression du produit ${pending.product.reference}.`,
    );
    await loadProducts();
  }
};

const handleReactivateProduct = async (id: number) => {
  const product = products.value.find((p) => p.id === id);
  if (!product) return;

  try {
    await restoreProductsWithBaseFallback([id]);
    openActionMenuId.value = null;
    selectedProducts.value = selectedProducts.value.filter((pid) => pid !== id);
    notifySuccess(`Produit ${product.reference} réactivé avec succès.`);
    await loadProducts();
  } catch (e) {
    notifyError(
      e instanceof Error
        ? e.message
        : `Erreur lors de la réactivation du produit ${product.reference}.`,
    );
  }
};

// Publier un produit brouillon (premel='1' → premel='0')
const handlePublishBrouillon = (productId: number) => {
  const product = products.value.find((p) => p.id === productId);
  if (!product) return;

  // Vérifier que le produit a des photos avant de publier
  if ((product.nb_photos ?? 0) <= 0) {
    // Cas spécial : la couleur principale n'a pas de photo, mais des variantes
    // liées en ont. On propose alors de désigner une autre couleur (avec photo)
    // comme principale (l'ancienne principale devient une variante) puis de
    // publier. La principale sans photo n'est JAMAIS mise en ligne.
    if (isMainProduct(product)) {
      const mainId = getMainProductId(product);
      const candidates = getProductsLinkedToMain(product).filter(
        (p) =>
          Number(p.id) !== Number(mainId) &&
          (p.nb_photos ?? 0) > 0 &&
          (p as any).premel === "1" &&
          !isProductLocked(p),
      );

      if (candidates.length > 0) {
        chooseMainCandidates.value = candidates;
        chooseMainSelectedId.value = Number(candidates[0].id);
        chooseMainOldMainId.value = product.id;
        chooseMainModalVisible.value = true;
        return;
      }
    }

    notifyError(
      `Le produit ${product.reference} doit avoir au moins une photo pour être mis en ligne.`,
    );
    return;
  }

  const publishBlocker = getPublishBlockerWithoutPhotos(product);
  if (publishBlocker && (product.nb_photos ?? 0) > 0) {
    notifyError(`${product.reference} : ${publishBlocker}`);
    return;
  }

  // Vérifier que le poids est renseigné et supérieur à 0
  if (!product.poids || product.poids <= 0) {
    notifyError(
      "Le poids du produit doit être renseigné avant la mise en ligne.",
    );
    return;
  }
  {
    const poidsError = getMelUnitWeightError(product.poids);
    if (poidsError) {
      notifyError(poidsError);
      return;
    }
  }

  // Cas : on publie une VARIANTE avec photo, alors que la couleur principale
  // actuelle n'a PAS de photo. On réutilise la modale « Choisir la couleur
  // principale » pour promouvoir la variante cliquée en principale, puis
  // enchaîner avec la publication (confirmChooseMainAndPublish).
  if (!isMainProduct(product)) {
    const mainId = getMainProductId(product);
    const currentMain = products.value.find(
      (p) => Number(p.id) === Number(mainId),
    );
    if (
      currentMain &&
      Number(currentMain.id) !== Number(product.id) &&
      (currentMain.nb_photos ?? 0) <= 0
    ) {
      // Publication unitaire : on ne met en ligne QUE la variante cliquée.
      // La modale ne propose donc qu'un seul candidat (celui sur lequel
      // l'utilisateur vient de cliquer), pour éviter de publier les autres
      // sœurs non sélectionnées. Les éventuelles autres variantes avec photo
      // restent en brouillon tant que l'utilisateur ne les publie pas.
      chooseMainCandidates.value = [product];
      chooseMainSelectedId.value = Number(product.id);
      chooseMainOldMainId.value = Number(currentMain.id);
      chooseMainModalVisible.value = true;
      return;
    }
  }

  productToPublishId.value = productId;
  publishBrouillonConfirmVisible.value = true;
};

const handleBulkPublish = () => {
  if (!selectedProducts.value.length) return;

  const selected = products.value.filter((p) =>
    selectedProducts.value.includes(p.id),
  );

  // Les couleurs sans photo sont ignorées ou remplacées via la modale
  // ci-dessous. Seules les candidates à publier doivent être complètes.
  const blocked = selected.find((p) => Number(p.nb_photos ?? 0) > 0 && getPublishBlocker(p));
  if (blocked) {
    notifyError(`${blocked.reference} : ${getPublishBlocker(blocked)}`);
    return;
  }

  // 1) Regrouper par produit principal
  const groups = new Map<number, ProduitCatalogue[]>();
  for (const p of selected) {
    const mainId = Number(getMainProductId(p));
    if (!groups.has(mainId)) groups.set(mainId, []);
    groups.get(mainId)!.push(p);
  }

  const pendingPicks: PendingMainPick[] = [];
  const readyIds: number[] = [];
  const ignoredRefs: string[] = [];

  for (const [mainId, items] of groups) {
    const main =
      products.value.find((p) => Number(p.id) === mainId) ??
      items.find((p) => isMainProduct(p));

    if (!main) {
      for (const it of items) {
        if ((it.nb_photos ?? 0) > 0) readyIds.push(it.id);
        else ignoredRefs.push(it.reference);
      }
      continue;
    }

    if ((main.nb_photos ?? 0) > 0) {
      readyIds.push(main.id);
      for (const it of items) {
        if (Number(it.id) !== Number(main.id) && (it.nb_photos ?? 0) > 0) {
          readyIds.push(it.id);
        }
      }
      continue;
    }

    // Principale SANS photo : chercher une variante éligible
    const candidates = getProductsLinkedToMain(main).filter(
      (p) =>
        Number(p.id) !== Number(main.id) &&
        (p.nb_photos ?? 0) > 0 &&
        (p as any).premel === "1" &&
        !isProductLocked(p),
    );

    if (candidates.length > 0) {
      pendingPicks.push({
        oldMainId: main.id,
        oldMainRef: main.reference,
        candidates,
      });
    } else {
      ignoredRefs.push(main.reference);
      for (const it of items) {
        if (
          Number(it.id) !== Number(main.id) &&
          (it.nb_photos ?? 0) > 0 &&
          !isProductLocked(it)
        ) {
          readyIds.push(it.id);
        }
      }
    }
  }

  bulkReadyPublishIds.value = Array.from(new Set(readyIds));
  bulkPendingMainPicks.value = pendingPicks;

  if (ignoredRefs.length) {
    notifyWarning(
      `${
        ignoredRefs.length
      } produit(s) sans photos seront ignorés (${ignoredRefs
        .slice(0, 3)
        .join(", ")}${ignoredRefs.length > 3 ? "…" : ""}).`,
    );
  }

  if (pendingPicks.length > 0) {
    isBulkChooseMainFlow.value = true;
    // Afficher TOUS les groupes simultanément dans la même modale (comme la page upload)
    chooseMainGroups.value = pendingPicks.map((p) => ({
      oldMainId: p.oldMainId,
      oldMainRef: p.oldMainRef,
      selectedId: Number(p.candidates[0].id),
      candidates: p.candidates,
    }));
    chooseMainModalVisible.value = true;
    return;
  }

  if (bulkReadyPublishIds.value.length === 0) {
    notifyError("Aucun produit éligible à la mise en ligne.");
    return;
  }
  bulkPublishConfirmVisible.value = true;
};

// Ouvre la modale "Choisir la couleur principale" pour le prochain groupe en attente
const openNextBulkChooseMain = () => {
  const next = bulkPendingMainPicks.value[0];
  if (!next) {
    finalizeBulkPublishAfterPicks();
    return;
  }
  chooseMainCandidates.value = next.candidates;
  chooseMainSelectedId.value = Number(next.candidates[0].id);
  chooseMainOldMainId.value = next.oldMainId;
  chooseMainModalVisible.value = true;
};

const finalizeBulkPublishAfterPicks = async () => {
  isBulkChooseMainFlow.value = false;
  if (bulkReadyPublishIds.value.length === 0) {
    notifyWarning("Aucun produit à publier après arbitrage.");
    selectedProducts.value = [];
    await loadProducts();
    return;
  }
  selectedProducts.value = [...bulkReadyPublishIds.value];
  bulkReadyPublishIds.value = [];
  bulkPublishConfirmVisible.value = true;
};

const onChooseMainCancel = () => {
  chooseMainModalVisible.value = false;

  // Flux bulk multi-groupes : on annule l'arbitrage de TOUS les groupes.
  // Les principales sans photo restent en brouillon ; on publie quand même
  // les produits déjà prêts (groupes dont la principale a une photo).
  if (chooseMainGroups.value.length > 0) {
    chooseMainGroups.value = [];
    chooseMainCandidates.value = [];
    chooseMainSelectedId.value = null;
    chooseMainOldMainId.value = null;
    bulkPendingMainPicks.value = [];
    notifyWarning(
      "Arbitrage annulé : les couleurs principales sans photo restent en brouillon.",
    );
    finalizeBulkPublishAfterPicks();
    return;
  }

  chooseMainCandidates.value = [];
  chooseMainSelectedId.value = null;
  chooseMainOldMainId.value = null;
  isBulkChooseMainFlow.value = false;
};

const confirmBulkPublish = async () => {
  bulkPublishConfirmVisible.value = false;

  const idsArray = [...selectedProducts.value];
  const blocked = products.value
    .filter((p) => idsArray.includes(p.id))
    .find((p) => getPublishBlocker(p));
  if (blocked) {
    notifyError(`${blocked.reference} : ${getPublishBlocker(blocked)}`);
    return;
  }
  try {
    const idVendeur = authStore.user?.id;
    if (!idVendeur) return;

    const publishedCount = await publishBrouillonBulk(idsArray, idVendeur);

    await loadProducts();
    selectedProducts.value = [];

    notifySuccess(`${publishedCount} produit(s) mis en ligne avec succès.`);

    if (publishedCount > 0 && idsArray.length > publishedCount) {
      notifyWarning(
        `${idsArray.length - publishedCount} produit(s) ignorés (sans photos).`,
      );
    }

    bulkReadyPublishIds.value = [];
    bulkPendingMainPicks.value = [];
    isBulkChooseMainFlow.value = false;
  } catch (e: any) {
    notifyError(e.message || "Erreur lors de la mise en ligne des produits.");
    bulkReadyPublishIds.value = [];
    bulkPendingMainPicks.value = [];
    isBulkChooseMainFlow.value = false;
  }
};

const confirmPublishBrouillon = async () => {
  publishBrouillonConfirmVisible.value = false;
  const productId = productToPublishId.value;
  if (!productId) return;
  productToPublishId.value = null;

  const product = products.value.find((p) => p.id === productId);
  if (!product) return;

  const publishBlocker = getPublishBlocker(product);
  if (publishBlocker) {
    notifyError(`${product.reference} : ${publishBlocker}`);
    return;
  }

  try {
    const idVendeur = authStore.user?.id;
    if (!idVendeur) return;
    const ok = await publishBrouillon(productId, idVendeur);

    // Le backend renvoie false lorsqu'il conserve le produit en brouillon
    // (produit déjà non-brouillon ou aucune photo détectée). On ne doit donc
    // pas afficher un faux message de succès.
    if (ok) {
      notifySuccess(`Produit ${product.reference} mis en ligne avec succès.`);
    } else {
      notifyWarning(
        `Produit ${product.reference} conservé en brouillon : aucune photo détectée ou produit déjà en ligne.`,
      );
    }

    // Recharger la liste depuis le backend pour garantir la cohérence des données (statut, stock, etc.)
    await loadProducts();
  } catch (e: any) {
    console.error("Erreur publishBrouillon:", e);
    notifyError(
      e?.message ||
        `Erreur lors de la mise en ligne du produit ${product.reference}.`,
    );
  }
};

// Confirmer le choix d'une nouvelle principale (la principale n'avait pas de photo)
// puis mettre le groupe en ligne via cette nouvelle principale.
const confirmChooseMainAndPublish = async () => {
  // === Flux bulk multi-groupes : traiter TOUS les groupes affichés à la fois ===
  if (chooseMainGroups.value.length > 0) {
    const idVendeur = authStore.user?.id;
    if (!idVendeur) return;

    const blockedCandidate = chooseMainGroups.value
      .map((group) =>
        products.value.find((p) => Number(p.id) === Number(group.selectedId)),
      )
      .find((candidate) => candidate && getPublishBlocker(candidate));
    if (blockedCandidate) {
      notifyError(
        `${blockedCandidate.reference} : ${getPublishBlocker(blockedCandidate)}`,
      );
      return;
    }

    isChoosingMain.value = true;
    try {
      const chosenIds: number[] = [];
      // Pour chaque groupe, la variante choisie (avec photo) devient la nouvelle
      // principale ; l'ancienne principale (sans photo) reste en brouillon.
      for (const g of chooseMainGroups.value) {
        await toggleMainProduct(g.selectedId);
        chosenIds.push(Number(g.selectedId));
      }

      bulkReadyPublishIds.value = Array.from(
        new Set([...bulkReadyPublishIds.value, ...chosenIds]),
      );

      notifySuccess(
        `${chosenIds.length} nouvelle(s) couleur(s) principale(s) définie(s).`,
      );

      chooseMainModalVisible.value = false;
      chooseMainGroups.value = [];
      chooseMainCandidates.value = [];
      chooseMainSelectedId.value = null;
      chooseMainOldMainId.value = null;
      isChoosingMain.value = false;

      await loadProducts();
      await finalizeBulkPublishAfterPicks();
    } catch (e: any) {
      console.error("Erreur confirmChooseMainAndPublish (bulk):", e);
      notifyError(
        e?.message ||
          "Erreur lors de la définition des nouvelles couleurs principales.",
      );
      isBulkChooseMainFlow.value = false;
      bulkPendingMainPicks.value = [];
      bulkReadyPublishIds.value = [];
      chooseMainGroups.value = [];
      chooseMainModalVisible.value = false;
      isChoosingMain.value = false;
    }
    return;
  }

  const chosenId = chooseMainSelectedId.value;
  if (!chosenId) return;

  const chosen = products.value.find((p) => Number(p.id) === Number(chosenId));
  if (!chosen) return;

  const chosenBlocker = getPublishBlocker(chosen);
  if (chosenBlocker) {
    notifyError(`${chosen.reference} : ${chosenBlocker}`);
    return;
  }

  const idVendeur = authStore.user?.id;
  if (!idVendeur) return;

  isChoosingMain.value = true;
  try {
    // 1) La variante choisie (avec photo) devient la nouvelle principale.
    //    L'ancienne principale (sans photo) est automatiquement rétrogradée
    //    en variante et reste en brouillon.
    await toggleMainProduct(chosenId);

    if (isBulkChooseMainFlow.value) {
      // === Flux BULK : ne pas publier ici, on accumule et on enchaîne ===
      bulkReadyPublishIds.value = Array.from(
        new Set([...bulkReadyPublishIds.value, Number(chosenId)]),
      );
      bulkPendingMainPicks.value = bulkPendingMainPicks.value.slice(1);

      notifySuccess(
        `Produit ${chosen.reference} défini comme nouvelle principale.`,
      );

      chooseMainModalVisible.value = false;
      chooseMainCandidates.value = [];
      chooseMainSelectedId.value = null;
      chooseMainOldMainId.value = null;
      isChoosingMain.value = false;

      await loadProducts();
      openNextBulkChooseMain();
      return;
    }

    // 2) Mettre en ligne via cette nouvelle principale (le backend publie
    //    automatiquement les variantes liées AVEC photo ; celles sans photo,
    //    dont l'ancienne principale, restent en brouillon).
    const ok = await publishBrouillon(chosenId, idVendeur);

    if (ok) {
      notifySuccess(
        `Produit ${chosen.reference} défini comme principale et mis en ligne avec succès.`,
      );
    } else {
      notifyWarning(
        `Produit ${chosen.reference} conservé en brouillon : aucune photo détectée.`,
      );
    }

    await loadProducts();
  } catch (e: any) {
    console.error("Erreur confirmChooseMainAndPublish:", e);
    notifyError(
      e?.message ||
        `Erreur lors de la mise en ligne du produit ${chosen.reference}.`,
    );
    if (isBulkChooseMainFlow.value) {
      isBulkChooseMainFlow.value = false;
      bulkPendingMainPicks.value = [];
      bulkReadyPublishIds.value = [];
    }
  } finally {
    isChoosingMain.value = false;
    chooseMainModalVisible.value = false;
    chooseMainCandidates.value = [];
    chooseMainSelectedId.value = null;
    chooseMainOldMainId.value = null;
  }
};

const handleAddColorFromColorModal = async () => {
  const product = activeProductForColors.value;
  if (!product) return;
  colorModalVisible.value = false;
  await openAddColorModal(product);
};

// Ouvrir le modal pour ajouter une couleur (créer variante)
const openAddColorModal = async (product: ProduitCatalogue) => {
  openActionMenuId.value = null;
  productForAddColor.value = product;
  addColorSourceProductId.value = getMainProductId(product);

  await loadColors();

  // Récupérer tous les IDs de couleur utilisés (même ceux qui ne sont pas dans la page courante ou dans l'autre onglet)
  try {
    const mainId = addColorSourceProductId.value;
    const usedIds = await getAllUsedColorIdsByMainProduct(mainId);

    if (Array.isArray(usedIds)) {
      liaisonColorsCache.value.set(mainId, new Set(usedIds));
    }
  } catch (err) {
    console.error(
      "Erreur lors de la récupération des couleurs utilisées:",
      err,
    );
  }

  addColorModalVisible.value = true;
};

// Gérer la création d'une variante avec nouvelle couleur
const handleAddColorVariant = async (payload: {
  productId: number;
  variants: Array<{
    couleurId: number;
    couleurName: string;
    photos?: File[];
    rotations?: number[];
  }>;
}) => {
  const currentProduct = productForAddColor.value;
  const venduPar =
    currentProduct?.venduPar ?? (currentProduct as any)?.vendu_par;

  try {
    if (venduPar === "melangees") {
      // Mode mélangées : uploader les photos directement au produit principal
      const variant = payload.variants[0];
      if (variant?.photos?.length) {
        await uploadProductPhotos(
          payload.productId,
          variant.photos,
          variant.rotations,
        );
        notifySuccess("Photos ajoutées avec succès");
      } else {
        notifySuccess("Variante créée en brouillon (sans photos).");
      }
    } else {
      if (!payload.variants.length) {
        notifyError("Veuillez sélectionner au moins une couleur.");
        return;
      }

      const createdProducts = [];
      for (const variant of payload.variants) {
        // Créer la variante avec la couleur
        const newProduct = await duplicateWithNewColor(
          payload.productId,
          variant.couleurId,
          variant.couleurName,
        );
        createdProducts.push(newProduct);

        // Uploader les photos correspondantes à cette couleur
        if (variant.photos?.length && newProduct?.id_produit) {
          try {
            await uploadProductPhotos(
              newProduct.id_produit,
              variant.photos,
              variant.rotations,
            );
          } catch (photoError) {
            console.error("Erreur upload photos:", photoError);
            notifyError(
              "Variante créée mais erreur lors de l'upload des photos.",
            );
          }
        }
      }

      const refs = createdProducts.map((p) => p.reference).join(", ");
      notifySuccess(
        `${createdProducts.length} variante${
          createdProducts.length > 1 ? "s créées" : " créée"
        } avec succès : ${refs}`,
      );
    }

    addColorModalVisible.value = false;
    productForAddColor.value = null;
    addColorSourceProductId.value = null;

    // Rafraîchir la liste des produits
    await loadProducts();
    initProductColors();
  } catch (e: any) {
    console.error(e);
    notifyError(e?.message || "Erreur lors de l'opération.");
  }
};

// Créer variante et mettre en ligne directement
const handleAddColorVariantAndPublish = async (payload: {
  productId: number;
  variants: Array<{
    couleurId: number;
    couleurName: string;
    photos?: File[];
    rotations?: number[];
  }>;
}) => {
  const currentProduct = productForAddColor.value;

  try {
    if (!payload.variants.length) {
      notifyError("Veuillez sélectionner au moins une couleur.");
      return;
    }

    const createdProducts = [];
    for (const variant of payload.variants) {
      const newProduct = await duplicateWithNewColor(
        payload.productId,
        variant.couleurId,
        variant.couleurName,
      );
      createdProducts.push(newProduct);

      if (variant.photos?.length && newProduct?.id_produit) {
        try {
          await uploadProductPhotos(
            newProduct.id_produit,
            variant.photos,
            variant.rotations,
          );
        } catch (photoError) {
          console.error("Erreur upload photos:", photoError);
          // Continue malgré l'erreur - le backend recalculera nb_photos depuis le disque
        }
      }
    }

    // Toujours tenter la mise en ligne (le backend recalcule nb_photos depuis le disque)
    const idVendeur = authStore.user?.id;
    if (!idVendeur) {
      notifyError("ID vendeur non trouvé. Impossible de mettre en ligne.");
      await loadProducts();
      initProductColors();
      return;
    }

    let publishedCount = 0;
    for (const newProduct of createdProducts) {
      if (!newProduct?.id_produit) continue;

      try {
        const published = await publishBrouillon(
          newProduct.id_produit,
          idVendeur,
        );
        if (published) {
          publishedCount++;
        } else {
          notifyWarning(
            `Variante ${newProduct.reference} créée en brouillon (photos non détectées par le serveur).`,
          );
        }
      } catch (publishError) {
        console.error("Erreur publication:", publishError);
        notifyError(
          `Variante ${newProduct.reference} créée mais erreur lors de la mise en ligne.`,
        );
      }
    }

    const refs = createdProducts.map((p: any) => p.reference).join(", ");
    if (publishedCount === createdProducts.length) {
      notifySuccess(
        `${createdProducts.length} variante${
          createdProducts.length > 1 ? "s créées et mises" : " créée et mise"
        } en ligne avec succès : ${refs}`,
      );
    } else if (publishedCount > 0) {
      notifySuccess(
        `${publishedCount}/${createdProducts.length} variante(s) créée(s) et mise(s) en ligne avec succès.`,
      );
    } else {
      notifyWarning(
        `Variantes créées en brouillon : ${refs}. La mise en ligne a échoué (vérifiez les photos).`,
      );
    }

    addColorModalVisible.value = false;
    productForAddColor.value = null;
    addColorSourceProductId.value = null;

    await loadProducts();
    initProductColors();
  } catch (e: any) {
    console.error(e);
    notifyError(e?.message || "Erreur lors de l'opération.");
  }
};

// Fonction pour formater les dates de manière sécurisée
const formatDate = (dateValue: any): string => {
  if (!dateValue) return "-";

  try {
    // Si c'est déjà une string valide, on l'affiche telle quelle
    if (typeof dateValue === "string") {
      // Vérifier si c'est une date valide
      const date = new Date(dateValue);
      if (isNaN(date.getTime())) {
        return dateValue; // Retourner la string originale si pas une date valide
      }
      return date.toLocaleDateString("fr-FR");
    }

    // Si c'est un objet Date
    if (dateValue instanceof Date) {
      return dateValue.toLocaleDateString("fr-FR");
    }

    // Si c'est un nombre (timestamp)
    if (typeof dateValue === "number") {
      const date = new Date(dateValue);
      if (isNaN(date.getTime())) {
        return "-";
      }
      return date.toLocaleDateString("fr-FR");
    }

    // Fallback
    return String(dateValue);
  } catch (error) {
    return "-";
  }
};

const initProductColors = () => {
  if (!products.value.length) return;

  for (const prod of products.value) {
    if (prod.couleursDetail?.length) {
      prod.colorIds = prod.couleursDetail.map((c) => c.id_couleur);
      if (!prod.id_couleur && prod.colorIds[0]) {
        (prod as any).id_couleur = prod.colorIds[0];
      }
      continue;
    }

    if (!allColors.value.length) continue;

    const labels = (prod.couleur || "")
      .split(",")
      .map((l) => l.trim())
      .filter(Boolean);

    const ids = allColors.value
      .filter((c) => labels.includes(c.label))
      .map((c) => c.id_couleur);

    prod.colorIds = ids;

    if (!prod.id_couleur && ids[0]) {
      (prod as any).id_couleur = ids[0];
    }

    // Pour melangees, reconstruire couleur et reference à partir de allColors
    if (prod.venduPar === "melangees" && ids.length > 0) {
      prod.couleur = labels.join(", ");
      const anyP = prod as any;
      if (anyP.reference_base) {
        prod.reference = `${anyP.reference_base}-${labels
          .map((l) => l.toUpperCase())
          .join(", ")}`;
      }
    }
  }
};

const categoryPathIndex = ref<Record<number, number[]>>({});

const buildCategoryPathIndex = () => {
  const index: Record<number, number[]> = {};

  const dfs = (node: CategorieNode, path: number[]) => {
    const newPath = [...path, node.id_categorie];
    index[node.id_categorie] = newPath;
    if (node.children) {
      node.children.forEach((child) => dfs(child, newPath));
    }
  };

  categoriesTree.value.forEach((root) => dfs(root, []));
  categoryPathIndex.value = index;
};

const initProductCategories = () => {
  if (!categoriesTree.value.length) return;
  if (!products.value.length) return;

  buildCategoryPathIndex();

  for (const prod of products.value) {
    const leafId = prod.catLevel3Id || prod.catLevel2Id || prod.catLevel1Id;
    if (!leafId) continue;

    const path = categoryPathIndex.value[leafId];
    if (!path || !path.length) continue;

    if (path.length === 1) {
      prod.catLevel1Id = path[0];
      prod.catLevel2Id = undefined;
      prod.catLevel3Id = undefined;
    } else if (path.length === 2) {
      prod.catLevel1Id = path[0];
      prod.catLevel2Id = path[1];
      prod.catLevel3Id = undefined;
    } else {
      const l = path.length;
      prod.catLevel1Id = path[l - 3];
      prod.catLevel2Id = path[l - 2];
      prod.catLevel3Id = path[l - 1];
    }
  }
};

// Variables pour détecter le scroll vs clic
let touchStartY = 0;
let touchStartX = 0;
let touchStartTime = 0;
let isScrolling = false;
let touchMoved = false;

// Gérer le début du touch
const handleTouchStart = (event: TouchEvent) => {
  touchStartY = event.touches[0].clientY;
  touchStartX = event.touches[0].clientX;
  touchStartTime = Date.now();
  isScrolling = false;
  touchMoved = false;
};

// Gérer le mouvement du touch
const handleTouchMove = (event: TouchEvent) => {
  if (!touchStartY || !touchStartX) return;

  const touchY = event.touches[0].clientY;
  const touchX = event.touches[0].clientX;
  const deltaY = Math.abs(touchY - touchStartY);
  const deltaX = Math.abs(touchX - touchStartX);

  // Si le mouvement vertical est plus important que le mouvement horizontal, c'est un scroll
  if (deltaY > deltaX && deltaY > 5) {
    isScrolling = true;
    touchMoved = true;
  } else if (deltaX > deltaY && deltaX > 5) {
    touchMoved = true;
  }
};

// Gérer la fin du touch
const handleTouchEnd = (event: TouchEvent) => {
  const touchEndTime = Date.now();
  const touchDuration = touchEndTime - touchStartTime;

  // Si c'était un scroll, ne pas déclencher le clic
  if (isScrolling || touchMoved) {
    // Réinitialiser
    touchStartY = 0;
    touchStartX = 0;
    touchStartTime = 0;
    isScrolling = false;
    touchMoved = false;
    return;
  }

  // Si c'était un tap court (< 300ms) et pas de mouvement, c'est un clic
  if (touchDuration < 300 && !touchMoved) {
    const target = event.target as HTMLElement;
    // Ne pas déclencher si on a cliqué sur un élément interactif
    if (!target.closest("input, select, button, a, .action-menu-container")) {
      const productCard = target.closest("[data-product-id]");
      if (productCard) {
        const productId = productCard.getAttribute("data-product-id");
        const product = products.value.find((p) => p.id === Number(productId));
      }
    }
  }

  // Réinitialiser
  touchStartY = 0;
  touchStartX = 0;
  touchStartTime = 0;
  isScrolling = false;
  touchMoved = false;
};

// Fermer le menu d'actions quand on clique ailleurs (desktop uniquement)
const handleClickOutside = (event: MouseEvent) => {
  // Ignorer les événements touch sur mobile
  if ((event as any).touches) return;

  const target = event.target as HTMLElement;
  if (!target.closest(".action-menu-container")) {
    openActionMenuId.value = null;
  }
};

// Fermer le menu d'actions lors du scroll
const handleScrollClose = () => {
  openActionMenuId.value = null;
};

// Initialisation
onMounted(async () => {
  // Rendre les fonctions disponibles globalement
  (window as any).handleProductSelection = handleProductSelection;
  (window as any).saveProductData = saveProductData;
  (window as any).handleEditProduct = handleEditProduct;
  (window as any).handleDuplicateProduct = handleDuplicateProduct;
  (window as any).handleCopyProduct = handleCopyProduct;

  // Écouter les changements de zoom (visualViewport)
  if (window.visualViewport) {
    window.visualViewport.addEventListener("resize", checkZoomLevel);
  }

  // Ajouter le listener pour fermer le menu d'actions
  document.addEventListener("click", handleClickOutside);
  // Ajouter le listener pour fermer le menu d'actions lors du scroll
  window.addEventListener("scroll", handleScrollClose, true);

  if (!authStore.isInitialized) {
    await authStore.checkAuth();
  }

  if (!authStore.isAuthenticated) {
    router.push({ name: "auth" });
    return;
  }

  // Restaurer les filtres depuis le store Pinia
  if (productsStore.filters) {
    activeFilters.value = { ...productsStore.filters };
  }

  await Promise.all([
    loadCategories(),
    loadCollections(),
    loadProducts(),
    loadTotalAllProducts(),
    loadBrands(),
    loadColors(),
    loadMelReferenceData(),
    loadProvenances(),
  ]);

  initProductCategories();
  initProductColors();
  // Les produits sont maintenant gérés côté serveur
  filteredProducts.value = products.value;

  // Marquer la fin du chargement initial
  isInitialLoad.value = false;
});

onUnmounted(() => {
  // Retirer le listener pour fermer le menu d'actions
  document.removeEventListener("click", handleClickOutside);
  window.removeEventListener("scroll", handleScrollClose, true);

  // Retirer le listener de zoom
  if (window.visualViewport) {
    window.visualViewport.removeEventListener("resize", checkZoomLevel);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(['product-list-mobile-sticky', { 'is-pinned': selectedProducts.value.length === 0 }])
    }, [
      _createVNode(_unref(PageHeader), {
        title: "Liste des produits",
        class: "product-list-header mb-4 pr-10 max-md:mb-0"
      }, {
        subtitle: _withCtx(() => [
          _createElementVNode("p", _hoisted_1, [
            _cache[41] || (_cache[41] = _createTextVNode(" Gérez votre catalogue de produits ")),
            (totalAllProducts.value > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, " (" + _toDisplayString(totalAllProducts.value) + " produits au total) ", 1))
              : _createCommentVNode("", true)
          ])
        ]),
        extra: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
              onClick: handleExportStock,
              disabled: stockExporting.value,
              class: _normalizeClass([
            'inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 transition-colors shadow-sm',
            stockExporting.value
              ? 'bg-green-400 cursor-not-allowed'
              : 'bg-green-600 hover:bg-green-700',
          ])
            }, [
              _createElementVNode("i", {
                class: _normalizeClass([
              'mr-2',
              stockExporting.value ? 'fas fa-spinner fa-spin' : 'fas fa-file-excel',
            ])
              }, null, 2),
              _createElementVNode("span", null, _toDisplayString(stockExporting.value ? "Export en cours..." : "Exporter catalogue"), 1)
            ], 10, _hoisted_4),
            _createElementVNode("button", {
              onClick: openStockImportModal,
              class: "inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-teal-600 hover:bg-teal-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-500 transition-colors shadow-sm"
            }, _cache[42] || (_cache[42] = [
              _createElementVNode("i", { class: "fas fa-file-upload mr-2" }, null, -1),
              _createElementVNode("span", null, "Importer catalogue", -1)
            ])),
            _createElementVNode("button", {
              onClick: handleBulkMea,
              class: "inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors shadow-sm"
            }, _cache[43] || (_cache[43] = [
              _createElementVNode("i", { class: "fas fa-bullhorn mr-2" }, null, -1),
              _createElementVNode("span", null, "Mettre en avant des produits", -1)
            ]))
          ])
        ]),
        _: 1
      }),
      _createElementVNode("div", { class: "md:hidden pt-2 pb-2" }, [
        _createElementVNode("button", {
          onClick: handleBulkMea,
          class: "inline-flex w-full justify-center items-center px-2.5 py-1.5 border border-transparent text-xs font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors shadow-sm"
        }, _cache[44] || (_cache[44] = [
          _createElementVNode("i", { class: "fas fa-bullhorn mr-1.5 text-[11px]" }, null, -1),
          _createElementVNode("span", null, "Mettre des produits en avant", -1)
        ]))
      ])
    ], 2),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_unref(ProductFilters), {
        products: products.value,
        "categories-tree": categoriesTree.value,
        "initial-filters": initialFilters.value,
        "onUpdate:filteredProducts": _cache[0] || (_cache[0] = ($event: any) => (filteredProducts.value = $event)),
        onFilter: handleServerFilter
      }, null, 8, ["products", "categories-tree", "initial-filters"])
    ]),
    (selectedProducts.value.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(_unref(ProductBulkActions), {
            products: products.value,
            "selected-ids": selectedProducts.value,
            "active-tab": activeTab.value,
            onDeleteSelected: handleBulkDelete,
            onMakeVisibleSelected: handleBulkMakeVisible,
            onMakeInvisibleSelected: handleBulkMakeInvisible,
            onLinkColorsSelected: handleBulkLinkColors,
            onDelinkColorsSelected: handleBulkDelinkColors,
            onPublishSelected: handleBulkPublish,
            onReactivateSelected: handleBulkReactivate
          }, null, 8, ["products", "selected-ids", "active-tab"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(ProductColorsModal, {
        visible: colorModalVisible.value,
        product: activeProductForColors.value,
        colors: allColors.value,
        "selected-ids": selectedColorIds.value,
        "tailles-list": taillesListForModal.value,
        "vendu-par": activeProductForColors.value?.venduPar,
        "colors-with-quantities": colorsWithQuantitiesForModal.value,
        "disabled-color-ids": disabledColorIdsForModal.value,
        "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => (colorModalVisible.value = $event)),
        onSave: handleSaveColors,
        onAddColor: handleAddColorFromColorModal
      }, null, 8, ["visible", "product", "colors", "selected-ids", "tailles-list", "vendu-par", "colors-with-quantities", "disabled-color-ids"]),
      _createVNode(ProductSheetModal, {
        visible: ficheModalVisible.value,
        product: activeProductForSheet.value,
        brands: brands.value,
        "categories-tree": categoriesTree.value,
        provenances: provenances.value,
        packs: packs.value,
        declinaisons: declinaisons.value,
        "onUpdate:visible": handleSheetVisibleUpdate,
        onSave: handleSaveProductSheet,
        onStocksUpdated: handleProductSheetStocksUpdated,
        onPendingCover: handlePendingCover,
        onEditColors: openColorModal
      }, null, 8, ["visible", "product", "brands", "categories-tree", "provenances", "packs", "declinaisons"]),
      _createVNode(_unref(ModalComp), {
        isVisible: duplicateConfirmVisible.value,
        "onUpdate:isVisible": _cache[4] || (_cache[4] = ($event: any) => ((duplicateConfirmVisible).value = $event))
      }, {
        header: _withCtx(() => _cache[45] || (_cache[45] = [
          _createElementVNode("h3", { class: "text-lg font-semibold" }, "Dupliquer le produit", -1)
        ])),
        body: _withCtx(() => [
          _createElementVNode("p", _hoisted_8, [
            _cache[46] || (_cache[46] = _createTextVNode(" Vous allez dupliquer le produit ")),
            _createElementVNode("strong", null, _toDisplayString(duplicateOriginalRef.value), 1),
            _cache[47] || (_cache[47] = _createTextVNode(" avec toutes ses variantes couleur. Veuillez saisir une nouvelle référence : "))
          ]),
          _createVNode(_unref(BaseInput), {
            modelValue: duplicateNewReference.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((duplicateNewReference).value = $event)),
            modelModifiers: { trim: true },
            label: "Nouvelle référence",
            placeholder: "Saisir la nouvelle référence",
            required: ""
          }, null, 8, ["modelValue"])
        ]),
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("button", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (duplicateConfirmVisible.value = false)),
              class: "px-4 py-2 bg-gray-300 text-black text-sm rounded-md hover:bg-gray-400"
            }, " Annuler "),
            _createElementVNode("button", {
              onClick: confirmDuplicate,
              disabled: !duplicateNewReference.value || isDuplicating.value,
              class: "px-4 py-2 bg-green-600 text-white text-sm rounded-md hover:bg-green-700 disabled:opacity-50"
            }, [
              (isDuplicating.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_11, "Duplication..."))
                : (_openBlock(), _createElementBlock("span", _hoisted_12, "Dupliquer"))
            ], 8, _hoisted_10)
          ])
        ]),
        _: 1
      }, 8, ["isVisible"]),
      _createVNode(_unref(ConfirmModal), {
        show: deleteConfirmVisible.value,
        title: "Confirmer la suppression",
        message: `Êtes-vous sûr de vouloir supprimer ${selectedProducts.value.length} produit(s) ?`,
        references: selectedProductsReferences.value,
        "confirm-disabled": bulkDeleteConfirmDisabled.value,
        "confirm-text": "Supprimer",
        "confirm-button-class": "bg-red-600 hover:bg-red-700 focus:ring-red-500",
        "max-width-class": "max-w-2xl",
        onConfirm: confirmBulkDelete,
        onCancel: cancelBulkDelete
      }, _createSlots({ _: 2 }, [
        (bulkDeleteMainGroups.value.length > 0)
          ? {
              name: "extra",
              fn: _withCtx(() => [
                _createElementVNode("div", _hoisted_13, [
                  _cache[51] || (_cache[51] = _createElementVNode("p", { class: "text-sm font-medium text-black" }, " Choisissez la nouvelle couleur principale avant la suppression : ", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bulkDeleteMainGroups.value, (group) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: group.liaison,
                      class: "rounded-lg border border-gray-200 bg-gray-50 p-3"
                    }, [
                      _createElementVNode("div", _hoisted_14, [
                        _createTextVNode(_toDisplayString(group.oldMain.reference) + " ", 1),
                        (group.oldMain.couleur)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_15, " · " + _toDisplayString(group.oldMain.couleur), 1))
                          : _createCommentVNode("", true),
                        _cache[48] || (_cache[48] = _createElementVNode("span", { class: "text-black" }, " (principale actuelle)", -1))
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.successors, (successor) => {
                          return (_openBlock(), _createElementBlock("button", {
                            key: successor.id,
                            type: "button",
                            onClick: ($event: any) => (
                  selectBulkDeleteSuccessor(
                    group.liaison,
                    Number(successor.id),
                  )
                ),
                            class: _normalizeClass([
                  'flex-shrink-0 w-28 rounded-lg border-2 p-2 transition-all snap-start text-left',
                  bulkDeleteSuccessorChoices.value.get(group.liaison) === successor.id
                    ? 'border-red-500 bg-red-50 shadow-sm'
                    : 'border-gray-200 bg-white hover:border-gray-300',
                ])
                          }, [
                            _createElementVNode("div", _hoisted_18, [
                              (getDisplayImageForProduct(successor))
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: getProductImageUrl(successor),
                                    alt: successor.reference,
                                    loading: "lazy",
                                    class: "w-full h-full object-cover"
                                  }, null, 8, _hoisted_19))
                                : (_openBlock(), _createElementBlock("div", _hoisted_20, _cache[49] || (_cache[49] = [
                                    _createElementVNode("i", { class: "fas fa-tshirt text-black text-base" }, null, -1)
                                  ]))),
                              (
                      bulkDeleteSuccessorChoices.value.get(group.liaison) ===
                      successor.id
                    )
                                ? (_openBlock(), _createElementBlock("div", _hoisted_21, _cache[50] || (_cache[50] = [
                                    _createElementVNode("i", { class: "fas fa-check text-white text-[10px]" }, null, -1)
                                  ])))
                                : (_openBlock(), _createElementBlock("div", _hoisted_22))
                            ]),
                            _createElementVNode("div", {
                              class: "text-[11px] font-medium text-black truncate",
                              title: successor.reference
                            }, _toDisplayString(successor.reference), 9, _hoisted_23),
                            (successor.couleur)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: "text-[10px] text-black truncate",
                                  title: successor.couleur
                                }, _toDisplayString(successor.couleur), 9, _hoisted_24))
                              : _createCommentVNode("", true)
                          ], 10, _hoisted_17))
                        }), 128))
                      ])
                    ]))
                  }), 128))
                ])
              ]),
              key: "0"
            }
          : undefined
      ]), 1032, ["show", "message", "references", "confirm-disabled"]),
      _createVNode(_unref(ConfirmModal), {
        show: deleteMainConfirmVisible.value,
        title: "Changer la couleur principale",
        message: deleteMainConfirmMessage.value,
        "confirm-disabled": !deleteMainPending.value?.successorId,
        "show-attention-icon": true,
        "confirm-text": "Changer et supprimer",
        "confirm-button-class": "bg-red-600 hover:bg-red-700 focus:ring-red-500",
        "max-width-class": "max-w-lg",
        onConfirm: confirmDeleteMainProduct,
        onCancel: cancelDeleteMainProduct
      }, {
        extra: _withCtx(() => [
          _cache[54] || (_cache[54] = _createElementVNode("p", { class: "text-sm font-medium text-black mb-2" }, " Nouvelle couleur principale ", -1)),
          _createElementVNode("div", _hoisted_25, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(deleteMainPending.value?.successors ?? [], (successor) => {
              return (_openBlock(), _createElementBlock("button", {
                key: successor.id,
                type: "button",
                onClick: ($event: any) => (selectDeleteMainSuccessor(Number(successor.id))),
                class: _normalizeClass([
              'flex-shrink-0 w-28 rounded-lg border-2 p-2 transition-all snap-start text-left',
              deleteMainPending.value?.successorId === successor.id
                ? 'border-red-500 bg-red-50 shadow-sm'
                : 'border-gray-200 bg-white hover:border-gray-300',
            ])
              }, [
                _createElementVNode("div", _hoisted_27, [
                  (getDisplayImageForProduct(successor))
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: getProductImageUrl(successor),
                        alt: successor.reference,
                        loading: "lazy",
                        class: "w-full h-full object-cover"
                      }, null, 8, _hoisted_28))
                    : (_openBlock(), _createElementBlock("div", _hoisted_29, _cache[52] || (_cache[52] = [
                        _createElementVNode("i", { class: "fas fa-tshirt text-black text-base" }, null, -1)
                      ]))),
                  (deleteMainPending.value?.successorId === successor.id)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_30, _cache[53] || (_cache[53] = [
                        _createElementVNode("i", { class: "fas fa-check text-white text-[10px]" }, null, -1)
                      ])))
                    : (_openBlock(), _createElementBlock("div", _hoisted_31))
                ]),
                _createElementVNode("div", {
                  class: "text-[11px] font-medium text-black truncate",
                  title: successor.reference
                }, _toDisplayString(successor.reference), 9, _hoisted_32),
                (successor.couleur)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "text-[10px] text-black truncate",
                      title: successor.couleur
                    }, _toDisplayString(successor.couleur), 9, _hoisted_33))
                  : _createCommentVNode("", true)
              ], 10, _hoisted_26))
            }), 128))
          ])
        ]),
        _: 1
      }, 8, ["show", "message", "confirm-disabled"]),
      _createVNode(_unref(ConfirmModal), {
        show: makeVisibleConfirmVisible.value,
        title: "Confirmer la mise en visibilité",
        message: `Êtes-vous sûr de vouloir rendre visible ${selectedProducts.value.length} produit(s) ?`,
        references: selectedProductsReferences.value,
        "confirm-text": "Rendre visible",
        "confirm-button-class": "bg-green-600 hover:bg-green-700 focus:ring-green-500",
        onConfirm: confirmBulkMakeVisible,
        onCancel: _cache[5] || (_cache[5] = ($event: any) => (makeVisibleConfirmVisible.value = false))
      }, null, 8, ["show", "message", "references"]),
      (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
        _createVNode(_Transition, {
          "enter-active-class": "transition-opacity duration-300",
          "enter-from-class": "opacity-0",
          "enter-to-class": "opacity-100",
          "leave-active-class": "transition-opacity duration-300",
          "leave-from-class": "opacity-100",
          "leave-to-class": "opacity-0"
        }, {
          default: _withCtx(() => [
            (makeInvisibleConfirmVisible.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                  _createElementVNode("div", {
                    class: "absolute inset-0 bg-black bg-opacity-50",
                    onClick: handleCancelMakeInvisible
                  }),
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("div", _hoisted_36, [
                      _cache[62] || (_cache[62] = _createElementVNode("div", { class: "flex-shrink-0 px-6 py-4 border-b border-gray-200" }, [
                        _createElementVNode("h3", { class: "text-lg font-semibold text-black" }, " Confirmer la mise hors ligne ")
                      ], -1)),
                      _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("p", _hoisted_38, _toDisplayString(bulkInvisibleModalMessage.value), 1),
                        (bulkInvisiblePlan.value.secondaryCount > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                              _cache[55] || (_cache[55] = _createElementVNode("i", { class: "fas fa-check-circle text-green-600 mr-2" }, null, -1)),
                              _createTextVNode(" " + _toDisplayString(bulkInvisiblePlan.value.secondaryCount) + " couleur(s) secondaire(s) seront mises hors ligne directement. ", 1)
                            ]))
                          : _createCommentVNode("", true),
                        (bulkInvisiblePlan.value.groupsWithSuccessor.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                              _createElementVNode("div", _hoisted_41, [
                                _createElementVNode("p", _hoisted_42, " Choisir la nouvelle couleur principale (" + _toDisplayString(bulkInvisiblePlan.value.groupsWithSuccessor.length) + " groupe(s)) : ", 1),
                                (bulkInvisiblePlan.value.groupsWithSuccessor.length > 3)
                                  ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                      key: 0,
                                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((bulkInvisibleGroupSearch).value = $event)),
                                      type: "search",
                                      placeholder: "Rechercher une référence...",
                                      class: "w-48 text-sm border border-gray-300 rounded-md px-3 py-1.5 focus:outline-none focus:ring-2 focus:ring-orange-500"
                                    }, null, 512)), [
                                      [_vModelText, bulkInvisibleGroupSearch.value]
                                    ])
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_43, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredBulkGroupsWithSuccessor.value, (group) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: group.liaison,
                                    class: "rounded-lg border border-gray-200 p-4 space-y-3"
                                  }, [
                                    _createElementVNode("div", _hoisted_44, [
                                      _createElementVNode("span", _hoisted_45, _toDisplayString(group.oldMain.reference), 1),
                                      (group.oldMain.couleur)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_46, " · " + _toDisplayString(group.oldMain.couleur), 1))
                                        : _createCommentVNode("", true),
                                      _cache[56] || (_cache[56] = _createElementVNode("span", { class: "text-black" }, " (principale actuelle)", -1))
                                    ]),
                                    _createElementVNode("div", _hoisted_47, [
                                      _createElementVNode("button", {
                                        type: "button",
                                        onClick: ($event: any) => (markBulkGroupFullyOffline(group)),
                                        class: _normalizeClass([
                            'flex-shrink-0 w-28 rounded-lg border-2 border-dashed p-2 transition-all snap-start text-left',
                            bulkInvisibleSuccessorChoices.value.get(group.liaison) ===
                            BULK_WHOLE_GROUP_OFFLINE
                              ? 'border-red-500 bg-red-50 shadow-sm'
                              : 'border-gray-300 hover:border-red-400 hover:bg-red-50',
                          ]),
                                        title: `Mettre tout le groupe hors ligne (${group.successors.length + 1} couleurs)`
                                      }, [
                                        _createElementVNode("div", _hoisted_49, [
                                          _cache[58] || (_cache[58] = _createElementVNode("i", { class: "fas fa-eye-slash text-red-600 text-xl" }, null, -1)),
                                          (
                                bulkInvisibleSuccessorChoices.value.get(
                                  group.liaison,
                                ) === BULK_WHOLE_GROUP_OFFLINE
                              )
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_50, _cache[57] || (_cache[57] = [
                                                _createElementVNode("i", { class: "fas fa-check text-white text-[10px]" }, null, -1)
                                              ])))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _cache[59] || (_cache[59] = _createElementVNode("div", { class: "text-[11px] font-medium text-black leading-tight" }, " Mettre toutes les couleurs hors ligne ", -1)),
                                        _createElementVNode("div", _hoisted_51, _toDisplayString(group.successors.length + 1) + " couleurs ", 1)
                                      ], 10, _hoisted_48),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.successors, (s) => {
                                        return (_openBlock(), _createElementBlock("button", {
                                          key: s.id,
                                          type: "button",
                                          onClick: ($event: any) => (
                            selectBulkSuccessor(group.liaison, Number(s.id))
                          ),
                                          class: _normalizeClass([
                            'flex-shrink-0 w-28 rounded-lg border-2 p-2 transition-all snap-start text-left',
                            bulkInvisibleSuccessorChoices.value.get(group.liaison) ===
                            s.id
                              ? 'border-orange-500 bg-orange-50 shadow-sm'
                              : 'border-gray-200 bg-white hover:border-gray-300',
                          ])
                                        }, [
                                          _createElementVNode("div", _hoisted_53, [
                                            (getDisplayImageForProduct(s))
                                              ? (_openBlock(), _createElementBlock("img", {
                                                  key: 0,
                                                  src: getProductImageUrl(s),
                                                  alt: s.reference,
                                                  loading: "lazy",
                                                  class: "w-full h-full object-cover"
                                                }, null, 8, _hoisted_54))
                                              : (_openBlock(), _createElementBlock("div", _hoisted_55, _cache[60] || (_cache[60] = [
                                                  _createElementVNode("i", { class: "fas fa-tshirt text-black text-base" }, null, -1)
                                                ]))),
                                            (
                                bulkInvisibleSuccessorChoices.value.get(
                                  group.liaison,
                                ) === s.id
                              )
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_56, _cache[61] || (_cache[61] = [
                                                  _createElementVNode("i", { class: "fas fa-check text-white text-[10px]" }, null, -1)
                                                ])))
                                              : (_openBlock(), _createElementBlock("div", _hoisted_57))
                                          ]),
                                          _createElementVNode("div", {
                                            class: "text-[11px] font-medium text-black truncate",
                                            title: s.reference
                                          }, _toDisplayString(s.reference), 9, _hoisted_58),
                                          (s.couleur)
                                            ? (_openBlock(), _createElementBlock("div", {
                                                key: 0,
                                                class: "text-[10px] text-black truncate",
                                                title: s.couleur
                                              }, _toDisplayString(s.couleur), 9, _hoisted_59))
                                            : _createCommentVNode("", true)
                                        ], 10, _hoisted_52))
                                      }), 128))
                                    ])
                                  ]))
                                }), 128))
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_60, [
                        _createElementVNode("button", {
                          type: "button",
                          disabled: isBulkMakingInvisible.value,
                          onClick: handleCancelMakeInvisible,
                          class: "px-4 py-2 text-sm font-medium text-black bg-white border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-50"
                        }, " Annuler ", 8, _hoisted_61),
                        _createElementVNode("button", {
                          type: "button",
                          disabled: isBulkMakingInvisible.value,
                          onClick: confirmBulkMakeInvisible,
                          class: "px-4 py-2 text-sm font-medium text-white bg-orange-600 hover:bg-orange-700 rounded-md disabled:opacity-50"
                        }, _toDisplayString(isBulkMakingInvisible.value
                      ? "Traitement..."
                      : `Rendre invisible (${selectedProducts.value.length})`), 9, _hoisted_62)
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ])),
      _createVNode(_unref(ConfirmModal), {
        show: singleVisibilityMainConfirmVisible.value,
        title: "Mettre la couleur principale en non visible",
        message: singleVisibilityMainConfirmMessage.value,
        "show-attention-icon": true,
        "lock-background-scroll": true,
        "confirm-text": isPromotingMainChange.value ? 'Confirmation...' : 'Confirmer',
        "confirm-disabled": isPromotingMainChange.value,
        "confirm-button-class": "bg-orange-600 hover:bg-orange-700 focus:ring-orange-500",
        onConfirm: confirmSingleVisibilityMainChange,
        onCancel: cancelSingleVisibilityMainChange
      }, _createSlots({ _: 2 }, [
        (visibleSuccessors.value.length > 0)
          ? {
              name: "extra",
              fn: _withCtx(() => [
                _createElementVNode("div", null, [
                  _cache[68] || (_cache[68] = _createElementVNode("p", { class: "text-xs font-medium text-black mb-2" }, " Choisir la nouvelle couleur principale : ", -1)),
                  _createElementVNode("div", _hoisted_63, [
                    _createElementVNode("button", {
                      type: "button",
                      disabled: isPromotingMainChange.value,
                      onClick: selectSingleVisibilityWholeGroupOffline,
                      class: _normalizeClass([
                'flex-shrink-0 w-28 rounded-lg border-2 border-dashed p-2 transition-all snap-start text-left disabled:opacity-50',
                singleVisibilityPending.value?.wholeGroupOffline
                  ? 'border-red-500 bg-red-50 shadow-sm'
                  : 'border-gray-300 hover:border-red-400 hover:bg-red-50',
              ]),
                      title: `Mettre tout le groupe hors ligne (${visibleSuccessors.value.length + 1} couleurs)`
                    }, [
                      _createElementVNode("div", _hoisted_65, [
                        _cache[64] || (_cache[64] = _createElementVNode("i", { class: "fas fa-eye-slash text-red-600 text-xl" }, null, -1)),
                        (singleVisibilityPending.value?.wholeGroupOffline)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_66, _cache[63] || (_cache[63] = [
                              _createElementVNode("i", { class: "fas fa-check text-white text-[10px]" }, null, -1)
                            ])))
                          : _createCommentVNode("", true)
                      ]),
                      _cache[65] || (_cache[65] = _createElementVNode("div", { class: "text-[11px] font-medium text-black leading-tight" }, " Mettre toutes les couleurs hors ligne ", -1)),
                      _createElementVNode("div", _hoisted_67, _toDisplayString(visibleSuccessors.value.length + 1) + " couleurs ", 1)
                    ], 10, _hoisted_64),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleSuccessors.value, (s) => {
                      return (_openBlock(), _createElementBlock("button", {
                        key: s.id,
                        type: "button",
                        onClick: ($event: any) => (selectSuccessor(Number(s.id))),
                        class: _normalizeClass([
                'flex-shrink-0 w-28 rounded-lg border-2 p-2 transition-all snap-start text-left',
                singleVisibilityPending.value?.successorId === s.id
                  ? 'border-orange-500 bg-orange-50 shadow-sm'
                  : 'border-gray-200 bg-white hover:border-gray-300',
              ])
                      }, [
                        _createElementVNode("div", _hoisted_69, [
                          (getDisplayImageForProduct(s))
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: getProductImageUrl(s),
                                alt: s.reference,
                                loading: "lazy",
                                class: "w-full h-full object-cover"
                              }, null, 8, _hoisted_70))
                            : (_openBlock(), _createElementBlock("div", _hoisted_71, _cache[66] || (_cache[66] = [
                                _createElementVNode("i", { class: "fas fa-tshirt text-black text-base" }, null, -1)
                              ]))),
                          (singleVisibilityPending.value?.successorId === s.id)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_72, _cache[67] || (_cache[67] = [
                                _createElementVNode("i", { class: "fas fa-check text-white text-[10px]" }, null, -1)
                              ])))
                            : (_openBlock(), _createElementBlock("div", _hoisted_73))
                        ]),
                        _createElementVNode("div", {
                          class: "text-[11px] font-medium text-black truncate",
                          title: s.reference
                        }, _toDisplayString(s.reference), 9, _hoisted_74),
                        (s.couleur)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "text-[10px] text-black truncate",
                              title: s.couleur
                            }, _toDisplayString(s.couleur), 9, _hoisted_75))
                          : _createCommentVNode("", true)
                      ], 10, _hoisted_68))
                    }), 128))
                  ])
                ])
              ]),
              key: "0"
            }
          : undefined
      ]), 1032, ["show", "message", "confirm-text", "confirm-disabled"]),
      _createVNode(_unref(ConfirmModal), {
        show: invisibleSecondaryToMainConfirmVisible.value,
        title: "Promouvoir en principale",
        message: invisibleSecondaryToMainConfirmMessage.value,
        "show-attention-icon": true,
        "confirm-text": isSettingMainProduct.value ? 'Confirmation...' : 'Confirmer',
        "confirm-disabled": isSettingMainProduct.value,
        "confirm-button-class": "bg-orange-600 hover:bg-orange-700 focus:ring-orange-500",
        onConfirm: confirmSetInvisibleSecondaryAsMain,
        onCancel: cancelSetInvisibleSecondaryAsMain
      }, null, 8, ["show", "message", "confirm-text", "confirm-disabled"]),
      _createVNode(_unref(ConfirmModal), {
        show: linkColorsConfirmVisible.value,
        title: "Liaison couleurs",
        message: linkPreviewMessage.value,
        "confirm-text": linkApplying.value ? 'Liaison...' : 'Appliquer la liaison',
        "confirm-disabled": linkPreviewConfirmDisabled.value,
        "max-width-class": "max-w-4xl",
        "confirm-button-class": "bg-blue-600 hover:bg-blue-700 focus:ring-blue-500",
        onConfirm: confirmBulkLinkColors,
        onCancel: cancelLinkPreview
      }, {
        extra: _withCtx(() => [
          _createElementVNode("div", _hoisted_76, [
            (linkPreviewLoading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_77, _cache[69] || (_cache[69] = [
                  _createElementVNode("i", { class: "fas fa-spinner fa-spin mr-2" }, null, -1),
                  _createTextVNode(" Calcul... ")
                ])))
              : _createCommentVNode("", true),
            (linkPreview.value?.blockingErrors?.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                  _cache[70] || (_cache[70] = _createElementVNode("p", { class: "text-xs font-semibold uppercase text-red-700 mb-1" }, " À corriger ", -1)),
                  _createElementVNode("ul", _hoisted_79, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(linkPreview.value.blockingErrors, (error) => {
                      return (_openBlock(), _createElementBlock("li", { key: error }, _toDisplayString(error), 1))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            (linkPreview.value?.warnings?.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                  _cache[71] || (_cache[71] = _createElementVNode("p", { class: "text-xs font-semibold uppercase text-amber-800 mb-1" }, " Attention ", -1)),
                  _createElementVNode("ul", _hoisted_81, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(linkWarningsVisible.value, (warning) => {
                      return (_openBlock(), _createElementBlock("li", { key: warning }, _toDisplayString(warning), 1))
                    }), 128)),
                    (linkWarningsHiddenCount.value > 0)
                      ? (_openBlock(), _createElementBlock("li", _hoisted_82, " +" + _toDisplayString(linkWarningsHiddenCount.value) + " autre(s) ", 1))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true),
            (linkPreview.value?.duplicateColorGroups?.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                  _cache[72] || (_cache[72] = _createElementVNode("p", { class: "text-xs font-semibold uppercase text-blue-800" }, " Doublons couleur ", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(linkPreview.value.duplicateColorGroups, (group) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: group.colorKey,
                      class: "rounded-md border border-blue-100 bg-white p-2"
                    }, [
                      _createElementVNode("p", _hoisted_84, _toDisplayString(group.couleur || `Couleur #${group.id_couleur}`), 1),
                      _createElementVNode("div", _hoisted_85, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.products, (product) => {
                          return (_openBlock(), _createElementBlock("label", {
                            key: `duplicate-${group.colorKey}-${product.id_produit}`,
                            class: _normalizeClass(["flex items-center gap-2 rounded-md border p-2 cursor-pointer", 
                    isDuplicateColorKeeper(group, product.id_produit)
                      ? 'border-blue-500 bg-blue-50'
                      : 'border-gray-200 bg-white'
                  ])
                          }, [
                            _createElementVNode("input", {
                              type: "radio",
                              name: `duplicate-color-${group.colorKey}`,
                              class: "mt-1",
                              checked: isDuplicateColorKeeper(group, product.id_produit),
                              disabled: linkPreviewLoading.value || linkApplying.value,
                              onChange: ($event: any) => (
                      handleSelectDuplicateColorKeeper(
                        group.colorKey,
                        product.id_produit,
                      )
                    )
                            }, null, 40, _hoisted_86),
                            _createElementVNode("span", _hoisted_87, [
                              (getLinkPreviewProductImageUrl(product))
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: getLinkPreviewProductImageUrl(product),
                                    alt: product.reference || '',
                                    loading: "lazy",
                                    class: "h-full w-full object-cover"
                                  }, null, 8, _hoisted_88))
                                : (_openBlock(), _createElementBlock("i", _hoisted_89))
                            ]),
                            _createElementVNode("span", _hoisted_90, [
                              _createElementVNode("span", _hoisted_91, _toDisplayString(product.reference || `#${product.id_produit}`), 1),
                              _createElementVNode("span", _hoisted_92, [
                                _createTextVNode(_toDisplayString(linkProductSourceLabel(product)) + " ", 1),
                                (isDuplicateColorKeeper(group, product.id_produit))
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_93, " · gardé "))
                                  : (group.keepProductId)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_94, " · brouillon "))
                                    : _createCommentVNode("", true)
                              ])
                            ])
                          ], 2))
                        }), 128))
                      ])
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (linkPreview.value?.referenceBaseOptions?.length > 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
                  _cache[73] || (_cache[73] = _createElementVNode("p", { class: "text-xs font-semibold uppercase text-blue-800" }, " Référence de base ", -1)),
                  _createElementVNode("div", _hoisted_96, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(linkPreview.value.referenceBaseOptions, (option) => {
                      return (_openBlock(), _createElementBlock("label", {
                        key: `reference-base-${option.referenceBase}`,
                        class: _normalizeClass(["flex items-start gap-3 rounded-md border p-2 cursor-pointer", 
                  isReferenceBaseSelected(option)
                    ? 'border-blue-500 bg-blue-50'
                    : 'border-gray-200 bg-white'
                ])
                      }, [
                        _createElementVNode("input", {
                          type: "radio",
                          name: "target-reference-base",
                          class: "mt-1",
                          checked: isReferenceBaseSelected(option),
                          disabled: linkPreviewLoading.value || linkApplying.value,
                          onChange: ($event: any) => (handleSelectReferenceBase(option.referenceBase))
                        }, null, 40, _hoisted_97),
                        _createElementVNode("span", _hoisted_98, [
                          _createElementVNode("span", _hoisted_99, _toDisplayString(option.referenceBase), 1),
                          _createElementVNode("span", _hoisted_100, _toDisplayString(option.products.length) + " produit(s) ", 1)
                        ])
                      ], 2))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            (isAddToExistingGroupPreview.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_101, " Principal du groupe cible conservé. "))
              : (linkMainCandidates.value.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_102, [
                    _cache[74] || (_cache[74] = _createElementVNode("p", { class: "text-xs font-semibold uppercase text-gray-700" }, " Produit principal ", -1)),
                    _createElementVNode("div", _hoisted_103, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(linkMainCandidates.value, (product) => {
                        return (_openBlock(), _createElementBlock("label", {
                          key: `main-${product.id_produit}`,
                          class: _normalizeClass(["flex items-center gap-2 rounded-md border p-2 cursor-pointer", 
                  selectedLinkMainId.value === product.id_produit
                    ? 'border-blue-500 bg-blue-50'
                    : 'border-gray-200 bg-white'
                ])
                        }, [
                          _createElementVNode("input", {
                            type: "radio",
                            name: "link-main-product",
                            class: "mt-1",
                            checked: selectedLinkMainId.value === product.id_produit,
                            disabled: linkPreviewLoading.value || linkApplying.value,
                            onChange: ($event: any) => (handleSelectLinkMain(product.id_produit))
                          }, null, 40, _hoisted_104),
                          _createElementVNode("span", _hoisted_105, [
                            (getLinkPreviewProductImageUrl(product))
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: getLinkPreviewProductImageUrl(product),
                                  alt: product.reference || '',
                                  loading: "lazy",
                                  class: "h-full w-full object-cover"
                                }, null, 8, _hoisted_106))
                              : (_openBlock(), _createElementBlock("i", _hoisted_107))
                          ]),
                          _createElementVNode("span", _hoisted_108, [
                            _createElementVNode("span", _hoisted_109, [
                              _createTextVNode(_toDisplayString(product.reference || `#${product.id_produit}`) + " ", 1),
                              _createElementVNode("span", {
                                class: _normalizeClass(["inline-flex items-center gap-1 text-[10px] font-normal", linkProductSourceClass(product)])
                              }, [
                                _createElementVNode("i", {
                                  class: _normalizeClass(linkProductSourceIcon(product))
                                }, null, 2),
                                _createTextVNode(" " + _toDisplayString(linkProductSourceLabel(product)), 1)
                              ], 2)
                            ]),
                            _createElementVNode("span", _hoisted_110, _toDisplayString(product.couleur || "Couleur non renseignée"), 1)
                          ])
                        ], 2))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
            (linkPreviewProducts.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_111, [
                  _createElementVNode("p", _hoisted_112, " Groupe final (" + _toDisplayString(linkPreviewProducts.value.length) + ") ", 1),
                  _createElementVNode("div", _hoisted_113, [
                    _createElementVNode("table", _hoisted_114, [
                      _cache[75] || (_cache[75] = _createElementVNode("thead", { class: "bg-gray-50 text-gray-600" }, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", { class: "px-3 py-2 text-left font-medium" }, "Produit"),
                          _createElementVNode("th", { class: "px-3 py-2 text-left font-medium" }, "Couleur"),
                          _createElementVNode("th", { class: "px-3 py-2 text-left font-medium" }, "Statut")
                        ])
                      ], -1)),
                      _createElementVNode("tbody", _hoisted_115, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(linkPreviewProducts.value, (product) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: `after-${product.id_produit}`
                          }, [
                            _createElementVNode("td", _hoisted_116, [
                              _createElementVNode("div", _hoisted_117, [
                                _createElementVNode("span", _hoisted_118, [
                                  (getLinkPreviewProductImageUrl(product))
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 0,
                                        src: getLinkPreviewProductImageUrl(product),
                                        alt: product.reference || '',
                                        loading: "lazy",
                                        class: "h-full w-full object-cover"
                                      }, null, 8, _hoisted_119))
                                    : (_openBlock(), _createElementBlock("i", _hoisted_120))
                                ]),
                                _createElementVNode("span", _hoisted_121, [
                                  _createElementVNode("span", _hoisted_122, [
                                    _createElementVNode("span", _hoisted_123, _toDisplayString(product.next_reference ||
                              product.reference ||
                              `#${product.id_produit}`), 1),
                                    (product.willBeMain)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_124, " principal "))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("span", {
                                      class: _normalizeClass(["inline-flex items-center gap-1 text-[10px] font-normal", linkProductSourceClass(product)])
                                    }, [
                                      _createElementVNode("i", {
                                        class: _normalizeClass(linkProductSourceIcon(product))
                                      }, null, 2),
                                      _createTextVNode(" " + _toDisplayString(linkProductSourceLabel(product)), 1)
                                    ], 2)
                                  ]),
                                  _createElementVNode("span", _hoisted_125, [
                                    _createTextVNode(_toDisplayString(effectiveLinkReferenceBase(product) || "-") + " ", 1),
                                    (linkReferenceBaseChanged(product))
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_126, " → " + _toDisplayString(product.next_reference_base), 1))
                                      : _createCommentVNode("", true)
                                  ]),
                                  (linkReferenceChanged(product))
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_127, _toDisplayString(product.reference) + " → " + _toDisplayString(product.next_reference), 1))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_128, _toDisplayString(product.couleur || "-"), 1),
                            _createElementVNode("td", _hoisted_129, [
                              _createElementVNode("span", {
                                class: _normalizeClass(["inline-flex rounded-full px-2 py-0.5 text-[11px] font-medium", linkStatusClass(product)])
                              }, _toDisplayString(formatLinkStatus(product)), 3)
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["show", "message", "confirm-text", "confirm-disabled"]),
      _createVNode(_unref(ConfirmModal), {
        show: delinkColorsConfirmVisible.value,
        title: "Confirmer la suppression de la liaison",
        message: delinkColorsMessage.value,
        references: selectedProductsReferences.value,
        "confirm-text": delinkApplying.value ? 'Suppression...' : 'Délier les couleurs',
        "confirm-disabled": delinkColorsConfirmDisabled.value,
        "max-width-class": delinkMainGroups.value.length ? 'max-w-2xl' : 'max-w-md',
        "confirm-button-class": "bg-gray-700 hover:bg-gray-800 focus:ring-gray-500",
        onConfirm: confirmBulkDelinkColors,
        onCancel: cancelReorganizeColors
      }, _createSlots({ _: 2 }, [
        (delinkMainGroups.value.length)
          ? {
              name: "extra",
              fn: _withCtx(() => [
                _createElementVNode("div", _hoisted_130, [
                  _cache[78] || (_cache[78] = _createElementVNode("p", { class: "text-xs font-semibold uppercase text-gray-700" }, " Nouveau produit principal ", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(delinkMainGroups.value, (group) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: `delink-main-${group.oldMainId}`,
                      class: "rounded-md border border-gray-200 p-3"
                    }, [
                      _createElementVNode("p", _hoisted_131, _toDisplayString(group.oldMainRef) + " sort du groupe. Choisir le principal restant : ", 1),
                      _createElementVNode("div", _hoisted_132, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.candidates, (candidate) => {
                          return (_openBlock(), _createElementBlock("button", {
                            key: `delink-candidate-${group.oldMainId}-${candidate.id}`,
                            type: "button",
                            onClick: ($event: any) => (group.selectedId = Number(candidate.id)),
                            class: _normalizeClass([
                  'flex-shrink-0 w-28 rounded-lg border-2 p-2 transition-all snap-start text-left',
                  group.selectedId === Number(candidate.id)
                    ? 'border-blue-500 bg-blue-50 shadow-sm'
                    : 'border-gray-200 bg-white hover:border-gray-300',
                ])
                          }, [
                            _createElementVNode("div", _hoisted_134, [
                              (getProductImageUrl(candidate))
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: getProductImageUrl(candidate),
                                    alt: candidate.reference,
                                    loading: "lazy",
                                    class: "h-full w-full object-cover"
                                  }, null, 8, _hoisted_135))
                                : (_openBlock(), _createElementBlock("div", _hoisted_136, _cache[76] || (_cache[76] = [
                                    _createElementVNode("i", { class: "fas fa-tshirt text-gray-300 text-base" }, null, -1)
                                  ]))),
                              (group.selectedId === Number(candidate.id))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_137, _cache[77] || (_cache[77] = [
                                    _createElementVNode("i", { class: "fas fa-check text-white text-[10px]" }, null, -1)
                                  ])))
                                : (_openBlock(), _createElementBlock("div", _hoisted_138))
                            ]),
                            _createElementVNode("div", {
                              class: "truncate text-[11px] font-medium text-gray-900",
                              title: candidate.reference
                            }, _toDisplayString(candidate.reference), 9, _hoisted_139),
                            (candidate.couleur)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: "truncate text-[10px] text-gray-500",
                                  title: candidate.couleur
                                }, _toDisplayString(candidate.couleur), 9, _hoisted_140))
                              : _createCommentVNode("", true)
                          ], 10, _hoisted_133))
                        }), 128))
                      ])
                    ]))
                  }), 128))
                ])
              ]),
              key: "0"
            }
          : undefined
      ]), 1032, ["show", "message", "references", "confirm-text", "confirm-disabled", "max-width-class"]),
      _createVNode(_unref(ConfirmModal), {
        show: publishBrouillonConfirmVisible.value,
        title: "Confirmer la mise en ligne",
        message: "Êtes-vous sûr de vouloir mettre ce produit en ligne ? Les sous-produits (couleurs liées) avec photos seront également mis en ligne automatiquement.",
        "confirm-text": "Mettre en ligne",
        "confirm-button-class": "bg-green-600 hover:bg-green-700 focus:ring-green-500",
        onConfirm: confirmPublishBrouillon,
        onCancel: _cache[7] || (_cache[7] = ($event: any) => (publishBrouillonConfirmVisible.value = false))
      }, null, 8, ["show"]),
      _createVNode(_unref(ConfirmModal), {
        show: bulkPublishConfirmVisible.value,
        title: "Mettre en ligne les produits sélectionnés",
        message: `Êtes-vous sûr de vouloir mettre en ligne ${selectedProducts.value.length} produit(s) ? Les produits sans photos seront ignorés.`,
        "confirm-text": "Mettre en ligne",
        "confirm-button-class": "bg-green-600 hover:bg-green-700 focus:ring-green-500",
        onConfirm: confirmBulkPublish,
        onCancel: _cache[8] || (_cache[8] = ($event: any) => (bulkPublishConfirmVisible.value = false))
      }, null, 8, ["show", "message"]),
      _createVNode(_unref(ConfirmModal), {
        show: chooseMainModalVisible.value,
        title: "Choisir la couleur principale",
        message: chooseMainModalMessage.value,
        "show-attention-icon": true,
        "lock-background-scroll": true,
        "confirm-text": 
        isChoosingMain.value ? 'Traitement...' : 'Définir et mettre en ligne'
      ,
        "confirm-disabled": chooseMainConfirmDisabled.value,
        "confirm-button-class": "bg-green-600 hover:bg-green-700 focus:ring-green-500",
        onConfirm: confirmChooseMainAndPublish,
        onCancel: onChooseMainCancel
      }, {
        extra: _withCtx(() => [
          (isMultiGroupChoose.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_141, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chooseMainGroups.value, (g) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: g.oldMainId,
                    class: "border border-gray-200 rounded-lg p-3"
                  }, [
                    _createElementVNode("p", _hoisted_142, " Groupe « " + _toDisplayString(g.oldMainRef) + " » — choisir la nouvelle principale : ", 1),
                    _createElementVNode("div", _hoisted_143, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(g.candidates, (c) => {
                        return (_openBlock(), _createElementBlock("button", {
                          key: c.id,
                          type: "button",
                          onClick: ($event: any) => (g.selectedId = Number(c.id)),
                          class: _normalizeClass([
                  'flex-shrink-0 w-28 rounded-lg border-2 p-2 transition-all snap-start text-left',
                  g.selectedId === Number(c.id)
                    ? 'border-orange-500 bg-orange-50 shadow-sm'
                    : 'border-gray-200 bg-white hover:border-gray-300',
                ])
                        }, [
                          _createElementVNode("div", _hoisted_145, [
                            (getDisplayImageForProduct(c))
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: getProductImageUrl(c),
                                  alt: c.reference,
                                  loading: "lazy",
                                  class: "w-full h-full object-cover"
                                }, null, 8, _hoisted_146))
                              : (_openBlock(), _createElementBlock("div", _hoisted_147, _cache[79] || (_cache[79] = [
                                  _createElementVNode("i", { class: "fas fa-tshirt text-gray-300 text-base" }, null, -1)
                                ]))),
                            (g.selectedId === Number(c.id))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_148, _cache[80] || (_cache[80] = [
                                  _createElementVNode("i", { class: "fas fa-check text-white text-[10px]" }, null, -1)
                                ])))
                              : (_openBlock(), _createElementBlock("div", _hoisted_149))
                          ]),
                          _createElementVNode("div", {
                            class: "text-[11px] font-medium text-gray-900 truncate",
                            title: c.reference
                          }, _toDisplayString(c.reference), 9, _hoisted_150),
                          (c.couleur)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "text-[10px] text-gray-500 truncate",
                                title: c.couleur
                              }, _toDisplayString(c.couleur), 9, _hoisted_151))
                            : _createCommentVNode("", true)
                        ], 10, _hoisted_144))
                      }), 128))
                    ])
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_152, [
                _cache[83] || (_cache[83] = _createElementVNode("p", { class: "text-xs font-medium text-gray-700 mb-2" }, " Choisir la nouvelle couleur principale : ", -1)),
                _createElementVNode("div", _hoisted_153, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chooseMainCandidates.value, (c) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: c.id,
                      type: "button",
                      onClick: ($event: any) => (chooseMainSelectedId.value = Number(c.id)),
                      class: _normalizeClass([
                'flex-shrink-0 w-28 rounded-lg border-2 p-2 transition-all snap-start text-left',
                chooseMainSelectedId.value === Number(c.id)
                  ? 'border-orange-500 bg-orange-50 shadow-sm'
                  : 'border-gray-200 bg-white hover:border-gray-300',
              ])
                    }, [
                      _createElementVNode("div", _hoisted_155, [
                        (getDisplayImageForProduct(c))
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: getProductImageUrl(c),
                              alt: c.reference,
                              loading: "lazy",
                              class: "w-full h-full object-cover"
                            }, null, 8, _hoisted_156))
                          : (_openBlock(), _createElementBlock("div", _hoisted_157, _cache[81] || (_cache[81] = [
                              _createElementVNode("i", { class: "fas fa-tshirt text-gray-300 text-base" }, null, -1)
                            ]))),
                        (chooseMainSelectedId.value === Number(c.id))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_158, _cache[82] || (_cache[82] = [
                              _createElementVNode("i", { class: "fas fa-check text-white text-[10px]" }, null, -1)
                            ])))
                          : (_openBlock(), _createElementBlock("div", _hoisted_159))
                      ]),
                      _createElementVNode("div", {
                        class: "text-[11px] font-medium text-gray-900 truncate",
                        title: c.reference
                      }, _toDisplayString(c.reference), 9, _hoisted_160),
                      (c.couleur)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "text-[10px] text-gray-500 truncate",
                            title: c.couleur
                          }, _toDisplayString(c.couleur), 9, _hoisted_161))
                        : _createCommentVNode("", true)
                    ], 10, _hoisted_154))
                  }), 128))
                ])
              ]))
        ]),
        _: 1
      }, 8, ["show", "message", "confirm-text", "confirm-disabled"]),
      _createVNode(_unref(ProductMeaRowModal), {
        visible: meaModalVisible.value,
        "initial-references": meaModalReferences.value,
        "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => (meaModalVisible.value = $event)),
        onSuccess: handleMeaSuccess
      }, null, 8, ["visible", "initial-references"]),
      _createVNode(NewColorsModal, {
        visible: addColorModalVisible.value,
        product: productForAddColor.value,
        "source-product-id": addColorSourceProductId.value,
        colors: allColors.value,
        "disabled-color-ids": usedColorIdsInLiaison.value,
        "vendu-par": productForAddColor.value?.venduPar,
        "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => (addColorModalVisible.value = $event)),
        onSave: handleAddColorVariant,
        onSaveAndPublish: handleAddColorVariantAndPublish
      }, null, 8, ["visible", "product", "source-product-id", "colors", "disabled-color-ids", "vendu-par"]),
      (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
        (showStockImportModal.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-50 p-4",
              onClick: _withModifiers(closeStockImportModal, ["self"])
            }, [
              _createElementVNode("div", _hoisted_162, [
                _cache[90] || (_cache[90] = _createElementVNode("div", { class: "px-6 py-4 border-b border-gray-200" }, [
                  _createElementVNode("h3", { class: "text-lg font-semibold text-black" }, " Importer le catalogue en masse ")
                ], -1)),
                _createElementVNode("div", _hoisted_163, [
                  _cache[88] || (_cache[88] = _createElementVNode("div", { class: "text-black text-sm leading-relaxed flex items-start gap-3" }, [
                    _createElementVNode("i", { class: "fas fa-exclamation-triangle text-amber-500 text-xl mt-0.5 flex-shrink-0" }),
                    _createElementVNode("span", null, [
                      _createElementVNode("strong", null, "Exportez d'abord"),
                      _createTextVNode(" le fichier Excel actuel. Il contient deux feuilles : "),
                      _createElementVNode("strong", null, "Stock"),
                      _createTextVNode(" et "),
                      _createElementVNode("strong", null, "Promotions"),
                      _createTextVNode(". Modifiez-les puis réimportez le fichier ci-dessous.")
                    ])
                  ], -1)),
                  _cache[89] || (_cache[89] = _createElementVNode("div", { class: "border border-gray-200 rounded-md p-3 bg-gray-50" }, [
                    _createElementVNode("p", { class: "text-xs font-medium text-black mb-1" }, " Feuille « Stock » "),
                    _createElementVNode("ul", { class: "space-y-1 text-xs text-black" }, [
                      _createElementVNode("li", null, [
                        _createTextVNode(" • "),
                        _createElementVNode("strong", null, "Mélangées"),
                        _createTextVNode(" → nombre simple, ex : "),
                        _createElementVNode("code", { class: "bg-gray-100 px-1 rounded" }, "100")
                      ]),
                      _createElementVNode("li", null, [
                        _createTextVNode(" • "),
                        _createElementVNode("strong", null, "Couleurs"),
                        _createTextVNode(" → nombre simple (une ligne par couleur), ex : "),
                        _createElementVNode("code", { class: "bg-gray-100 px-1 rounded" }, "50")
                      ]),
                      _createElementVNode("li", null, [
                        _createTextVNode(" • "),
                        _createElementVNode("strong", null, "Tailles"),
                        _createTextVNode(" → couleur*qté (une ligne par taille), ex : "),
                        _createElementVNode("code", { class: "bg-gray-100 px-1 rounded" }, "Noir*10,Blanc*20")
                      ])
                    ]),
                    _createElementVNode("p", { class: "text-xs font-medium text-black mb-1 mt-2" }, " Feuille « Promotions » "),
                    _createElementVNode("ul", { class: "space-y-1 text-xs text-black" }, [
                      _createElementVNode("li", null, [
                        _createTextVNode(" • Une ligne par produit principal. Remplir "),
                        _createElementVNode("strong", null, "prixReduit"),
                        _createTextVNode(". ")
                      ]),
                      _createElementVNode("li", null, [
                        _createTextVNode(" • Doit être ≤ "),
                        _createElementVNode("strong", null, "prix (original)"),
                        _createTextVNode(". Laisser vide = supprimer la promo. ")
                      ]),
                      _createElementVNode("li", null, [
                        _createTextVNode(" • Le prix promo est automatiquement appliqué à "),
                        _createElementVNode("strong", null, "toutes les couleurs"),
                        _createTextVNode(" du produit. ")
                      ])
                    ])
                  ], -1)),
                  _createElementVNode("div", null, [
                    _cache[84] || (_cache[84] = _createElementVNode("label", { class: "block text-sm font-medium text-black mb-1" }, "Fichier Excel", -1)),
                    _createElementVNode("input", {
                      type: "file",
                      accept: ".xlsx,.xls",
                      onChange: onStockFileSelected,
                      class: "block w-full text-sm text-black border border-gray-300 rounded-md p-2"
                    }, null, 32)
                  ]),
                  (stockValidating.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_164, _cache[85] || (_cache[85] = [
                        _createElementVNode("i", { class: "fas fa-spinner fa-spin" }, null, -1),
                        _createTextVNode(" Validation en cours... ")
                      ])))
                    : _createCommentVNode("", true),
                  (stockImportResult.value && !stockValidating.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: _normalizeClass(["rounded-md p-3 text-sm", 
                stockImportTotalErrors.value
                  ? 'bg-red-50 border border-red-200'
                  : 'bg-green-50 border border-green-200'
              ])
                      }, [
                        (!stockImportTotalErrors.value)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_165, " ✅ Stock : " + _toDisplayString(stockImportResult.value.stock.updated) + " / " + _toDisplayString(stockImportResult.value.stock.total) + " — Promotions : " + _toDisplayString(stockImportResult.value.promo.updated) + " / " + _toDisplayString(stockImportResult.value.promo.total) + " lignes prêtes ", 1))
                          : (_openBlock(), _createElementBlock("p", _hoisted_166, " ❌ " + _toDisplayString(stockImportTotalErrors.value) + " erreur(s) — veuillez corriger le fichier ", 1)),
                        (stockImportResult.value.stock.errors.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_167, [
                              _cache[86] || (_cache[86] = _createElementVNode("p", { class: "font-medium" }, "Stock :", -1)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stockImportResult.value.stock.errors, (err) => {
                                return (_openBlock(), _createElementBlock("p", {
                                  key: 's' + err.ligne + err.message
                                }, " Ligne " + _toDisplayString(err.ligne) + " : " + _toDisplayString(err.message), 1))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true),
                        (stockImportResult.value.promo.errors.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_168, [
                              _cache[87] || (_cache[87] = _createElementVNode("p", { class: "font-medium" }, "Promotions :", -1)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stockImportResult.value.promo.errors, (err) => {
                                return (_openBlock(), _createElementBlock("p", {
                                  key: 'p' + err.ligne + err.message
                                }, " Ligne " + _toDisplayString(err.ligne) + " : " + _toDisplayString(err.message), 1))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ], 2))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_169, [
                  _createElementVNode("button", {
                    onClick: closeStockImportModal,
                    class: "px-4 py-2 text-sm font-medium text-black bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors"
                  }, " Fermer "),
                  _createElementVNode("button", {
                    onClick: handleImportStock,
                    disabled: 
                !stockImportFile.value ||
                stockImporting.value ||
                stockValidating.value ||
                !stockImportResult.value ||
                stockImportTotalErrors.value > 0
              ,
                    class: "px-4 py-2 text-sm font-medium text-white bg-teal-600 rounded-md hover:bg-teal-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-500 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                  }, [
                    (stockImporting.value)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_171))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(stockImporting.value ? "Import en cours..." : "Importer"), 1)
                  ], 8, _hoisted_170)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])),
      _createElementVNode("div", _hoisted_172, [
        _createElementVNode("button", {
          onClick: _cache[11] || (_cache[11] = ($event: any) => (switchTab('en_ligne'))),
          class: _normalizeClass(["px-4 py-2 text-sm font-medium rounded-lg transition-colors", 
          activeTab.value === 'en_ligne'
            ? 'bg-green-600 text-white shadow-sm'
            : 'bg-gray-100 text-black hover:bg-gray-200 border border-gray-300'
        ])
        }, _cache[91] || (_cache[91] = [
          _createElementVNode("i", { class: "fas fa-globe mr-1.5" }, null, -1),
          _createTextVNode(" En ligne ")
        ]), 2),
        _createElementVNode("button", {
          onClick: _cache[12] || (_cache[12] = ($event: any) => (switchTab('brouillon'))),
          class: _normalizeClass(["px-4 py-2 text-sm font-medium rounded-lg transition-colors", 
          activeTab.value === 'brouillon'
            ? 'bg-amber-600 text-white shadow-sm'
            : 'bg-gray-100 text-black hover:bg-gray-200 border border-gray-300'
        ])
        }, _cache[92] || (_cache[92] = [
          _createElementVNode("i", { class: "fas fa-file-alt mr-1.5" }, null, -1),
          _createTextVNode(" Brouillon ")
        ]), 2),
        _createElementVNode("button", {
          onClick: _cache[13] || (_cache[13] = ($event: any) => (switchTab('supprime'))),
          class: _normalizeClass(["px-4 py-2 text-sm font-medium rounded-lg transition-colors", 
          activeTab.value === 'supprime'
            ? 'bg-red-600 text-white shadow-sm'
            : 'bg-gray-100 text-black hover:bg-gray-200 border border-gray-300'
        ])
        }, _cache[93] || (_cache[93] = [
          _createElementVNode("i", { class: "fas fa-trash-alt mr-1.5" }, null, -1),
          _createTextVNode(" Supprimé ")
        ]), 2)
      ]),
      _createVNode(_unref(UnifiedPagination), {
        "total-items": totalProducts.value,
        "current-page": currentPage.value,
        "items-per-page": itemsPerPage.value,
        variant: "product",
        "item-label": "produits principaux",
        "items-per-page-options": [10, 25, 50, 100],
        "show-first-last-buttons": true,
        "onUpdate:currentPage": handlePageChange,
        "onUpdate:itemsPerPage": handleItemsPerPageChange,
        onPageChange: handlePageChange,
        onItemsPerPageChange: handleItemsPerPageChange
      }, null, 8, ["total-items", "current-page", "items-per-page"]),
      (viewMode.value === 'list')
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["xl:hidden mb-4 pl-1", isZoomedOut.value ? 'grid grid-cols-2 gap-2' : 'space-y-3'])
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((groupedProducts.value as any[]), (product) => {
              return (_openBlock(), _createElementBlock("div", {
                key: product.id,
                "data-product-id": product.id,
                class: _normalizeClass([
          'bg-white rounded-lg border border-gray-200 shadow-sm flex flex-col gap-0 relative cursor-pointer hover:shadow-md transition-shadow',
          isZoomedOut.value ? 'p-2' : 'p-3',
          product.isChild ? 'opacity-90' : '',
          product.isChild && isZoomedOut.value ? 'ml-5 scale-[0.97]' : '',
          product.isChild && !isZoomedOut.value ? 'ml-7 scale-95' : '',
          isProductLocked(product) && activeTab.value !== 'supprime'
            ? 'bg-gray-50/70 pointer-events-none select-none'
            : '',
        ]),
                onClick: (event) => {
          // Sur desktop uniquement (les événements touch sont gérés séparément)
          if (!isMobileDevice()) {
            handleRowClick(product)
          }
        },
                onTouchstart: handleTouchStart,
                onTouchmove: handleTouchMove,
                onTouchend: handleTouchEnd
              }, [
                (product.isChild)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_174, _cache[94] || (_cache[94] = [
                      _createElementVNode("span", { class: "absolute left-1.5 top-0 bottom-1/2 w-[2.5px] rounded-full bg-[#C56C4D]" }, null, -1),
                      _createElementVNode("span", { class: "absolute left-1.5 top-1/2 h-[2.5px] w-3.5 -translate-y-1/2 rounded-full bg-[#C56C4D]" }, null, -1),
                      _createElementVNode("i", { class: "fas fa-caret-right absolute left-[14px] top-1/2 -translate-y-1/2 text-[#C56C4D] text-base leading-none" }, null, -1)
                    ])))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_175, [
                  _createElementVNode("div", _hoisted_176, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      id: `mobile-box-${product.id}`,
                      name: "checkProduit[]",
                      value: product.id,
                      checked: isProductSelected(product),
                      ".indeterminate": isProductSelectionIndeterminate(product),
                      onClick: _cache[14] || (_cache[14] = _withModifiers(() => {}, ["stop"])),
                      onChange: (event) => handleProductSelection(
              Number(product.id),
              (event.target as HTMLInputElement).checked
            ),
                      class: "w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500",
                      title: 
                shouldToggleWholeLiaisonGroup(product)
                  ? 'Sélectionner toutes les couleurs de cette référence'
                  : undefined
              
                    }, null, 40, _hoisted_177)
                  ]),
                  _createElementVNode("div", _hoisted_178, [
                    _createElementVNode("p", {
                      class: "text-sm font-bold text-black truncate leading-none m-0",
                      title: product.reference
                    }, _toDisplayString(product.reference), 9, _hoisted_179)
                  ]),
                  _createElementVNode("div", {
                    class: "action-menu-container pointer-events-auto flex flex-col justify-center h-8 flex-shrink-0 relative",
                    onClick: _cache[16] || (_cache[16] = _withModifiers(() => {}, ["stop"]))
                  }, [
                    _createElementVNode("button", {
                      onClick: _withModifiers(($event: any) => (toggleActionMenu(Number(product.id))), ["stop"]),
                      class: "w-8 h-8 flex items-center justify-center text-black hover:text-black rounded-md transition-colors",
                      title: "Actions"
                    }, _cache[95] || (_cache[95] = [
                      _createElementVNode("i", { class: "fas fa-ellipsis-h text-lg" }, null, -1)
                    ]), 8, _hoisted_180),
                    (openActionMenuId.value === Number(product.id))
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "absolute right-0 top-full mt-1 bg-white border border-gray-200 rounded-md shadow-lg z-10 py-1 min-w-[140px]",
                          onClick: _cache[15] || (_cache[15] = _withModifiers(() => {}, ["stop"]))
                        }, [
                          (isProductLocked(product))
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                onClick: _withModifiers(($event: any) => (handleReactivateProduct(Number(product.id))), ["stop"]),
                                class: "w-full px-3 py-2 text-left text-xs text-green-700 hover:bg-green-50 transition-colors flex items-center gap-2"
                              }, _cache[96] || (_cache[96] = [
                                _createElementVNode("span", { class: "w-5 h-5 bg-green-500 rounded flex items-center justify-center" }, [
                                  _createElementVNode("i", { class: "fas fa-undo text-[10px] text-white" })
                                ], -1),
                                _createElementVNode("span", null, "Réactiver", -1)
                              ]), 8, _hoisted_181))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                ((product as any).isChild)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      onClick: _withModifiers(($event: any) => (handleSetAsPrincipale(product)), ["stop"]),
                                      disabled: isSettingMainProduct.value,
                                      class: "w-full px-3 py-2 text-left text-xs text-black hover:bg-orange-50 hover:text-orange-700 transition-colors flex items-center gap-2"
                                    }, [
                                      _cache[97] || (_cache[97] = _createElementVNode("span", { class: "w-5 h-5 bg-orange-500 rounded flex items-center justify-center" }, [
                                        _createElementVNode("i", { class: "fas fa-star text-[10px] text-white" })
                                      ], -1)),
                                      _createElementVNode("span", null, _toDisplayString(isSettingMainProduct.value ? "Mise a jour..." : "Principale"), 1)
                                    ], 8, _hoisted_182))
                                  : _createCommentVNode("", true),
                                _createElementVNode("button", {
                                  onClick: _withModifiers(($event: any) => (handleEditProduct(Number(product.id))), ["stop"]),
                                  class: "w-full px-3 py-2 text-left text-xs text-black hover:bg-blue-50 hover:text-blue-700 transition-colors flex items-center gap-2"
                                }, _cache[98] || (_cache[98] = [
                                  _createElementVNode("span", { class: "w-5 h-5 bg-blue-500 rounded flex items-center justify-center" }, [
                                    _createElementVNode("i", { class: "fas fa-pen text-[10px] text-white" })
                                  ], -1),
                                  _createElementVNode("span", null, "Modifier", -1)
                                ]), 8, _hoisted_183),
                                _createElementVNode("button", {
                                  onClick: _withModifiers(($event: any) => (openAddColorModal(product)), ["stop"]),
                                  class: "w-full px-3 py-2 text-left text-xs text-black hover:bg-pink-50 hover:text-pink-700 transition-colors flex items-center gap-2"
                                }, [
                                  _createElementVNode("span", _hoisted_185, [
                                    _createElementVNode("i", {
                                      class: _normalizeClass([
                        'fas text-[10px] text-white',
                        product.venduPar === 'melangees'
                          ? 'fa-camera'
                          : 'fa-palette',
                      ])
                                    }, null, 2)
                                  ]),
                                  _createElementVNode("span", null, _toDisplayString(product.venduPar === "melangees"
                      ? "Nouvelle photo"
                      : "Nouvelle couleur"), 1)
                                ], 8, _hoisted_184),
                                _createElementVNode("button", {
                                  onClick: _withModifiers(($event: any) => (handleCopyProduct(Number(product.id))), ["stop"]),
                                  class: "w-full px-3 py-2 text-left text-xs text-black hover:bg-purple-50 hover:text-purple-700 transition-colors flex items-center gap-2"
                                }, _cache[99] || (_cache[99] = [
                                  _createElementVNode("span", { class: "w-5 h-5 bg-purple-500 rounded flex items-center justify-center" }, [
                                    _createElementVNode("i", { class: "fas fa-copy text-[10px] text-white" })
                                  ], -1),
                                  _createElementVNode("span", null, "Copier", -1)
                                ]), 8, _hoisted_186),
                                (isUpgrUser.value && product.premel === '1')
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 1,
                                      onClick: _withModifiers(($event: any) => (handlePublishBrouillon(Number(product.id))), ["stop"]),
                                      class: "w-full px-3 py-2 text-left text-xs text-black hover:bg-green-50 hover:text-green-700 transition-colors flex items-center gap-2"
                                    }, _cache[100] || (_cache[100] = [
                                      _createElementVNode("span", { class: "w-5 h-5 bg-green-500 rounded flex items-center justify-center" }, [
                                        _createElementVNode("i", { class: "fas fa-cloud-upload-alt text-[10px] text-white" })
                                      ], -1),
                                      _createElementVNode("span", null, "Mettre en ligne", -1)
                                    ]), 8, _hoisted_187))
                                  : _createCommentVNode("", true),
                                (
                    product.hasSiblings ||
                    (!(product as any).isChild && !product.hasSiblings)
                  )
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 2,
                                      href: getAcheteurUrl(product),
                                      target: "_blank",
                                      class: "w-full px-3 py-2 text-left text-xs text-black hover:bg-green-50 hover:text-green-700 transition-colors flex items-center gap-2",
                                      onClick: _withModifiers(($event: any) => (logVoirMaPageClick($event, product)), ["stop"])
                                    }, [
                                      _cache[101] || (_cache[101] = _createElementVNode("span", { class: "w-5 h-5 bg-green-500 rounded flex items-center justify-center" }, [
                                        _createElementVNode("i", { class: "fas fa-external-link-alt text-[10px] text-white" })
                                      ], -1)),
                                      _createElementVNode("span", null, _toDisplayString((product as any).acheteurUrl
                      ? "Voir sur le site"
                      : "Voir ma page"), 1)
                                    ], 8, _hoisted_188))
                                  : _createCommentVNode("", true)
                              ], 64))
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(isZoomedOut.value ? 'flex flex-col gap-1.5' : 'flex gap-2.5')
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["flex-shrink-0", isZoomedOut.value ? 'w-full' : 'w-36'])
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass([
                'relative bg-gray-100 rounded-md overflow-hidden cursor-pointer',
                isZoomedOut.value ? 'w-full h-40' : 'w-36 h-44',
              ]),
                      onClick: ($event: any) => (handleEditProduct(Number(product.id))),
                      onTouchend: _cache[18] || (_cache[18] = _withModifiers(() => {}, ["stop"]))
                    }, [
                      (getDisplayImageForProduct(product))
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: getProductImageUrl(product),
                            alt: 
                  typeof product.reference === 'string' ? product.reference : ''
                ,
                            loading: "lazy",
                            class: "w-full h-full object-cover",
                            onError: _cache[17] || (_cache[17] = (event) => { const target = event.target as HTMLImageElement; if (target) target.style.display = 'none'; })
                          }, null, 40, _hoisted_190))
                        : (_openBlock(), _createElementBlock("div", _hoisted_191, _cache[102] || (_cache[102] = [
                            _createElementVNode("i", { class: "fas fa-tshirt text-black text-lg" }, null, -1)
                          ]))),
                      (getCollapsedGroupSelectedCount(product) > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_192, [
                            _createElementVNode("span", _hoisted_193, _toDisplayString(getCollapsedGroupSelectedCount(product)), 1),
                            _createElementVNode("span", _hoisted_194, " sélectionné" + _toDisplayString(getCollapsedGroupSelectedCount(product) > 1 ? "s" : ""), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ], 42, _hoisted_189)
                  ], 2),
                  _createElementVNode("div", _hoisted_195, [
                    _createElementVNode("p", {
                      class: _normalizeClass([
                'text-black',
                isZoomedOut.value
                  ? 'text-xs line-clamp-1 mb-1'
                  : 'text-xs line-clamp-2 mb-1.5',
              ])
                    }, _toDisplayString((product as any).descriptionFr || ""), 3),
                    _createElementVNode("div", {
                      class: "flex flex-nowrap items-center gap-1 mb-1 pointer-events-auto min-h-[22px]",
                      onClick: _cache[20] || (_cache[20] = _withModifiers(() => {}, ["stop"]))
                    }, [
                      (product.hasSiblings && isMainProduct(product))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_196, " Principale "))
                        : _createCommentVNode("", true),
                      (product.statut !== 'supprime' && product.premel === '1')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_197, " Brouillon "))
                        : (_openBlock(), _createElementBlock("span", {
                            key: 2,
                            class: _normalizeClass([
                  'inline-flex items-center px-1.5 py-0.5 rounded-full text-[9px] font-medium leading-none',
                  product.statut === 'en-vente'
                    ? 'bg-emerald-500 text-white'
                    : product.statut === 'supprime'
                    ? 'bg-red-700 text-white'
                    : product.statut === 'rupture'
                    ? 'bg-red-500 text-white'
                    : 'bg-gray-400 text-white',
                ])
                          }, _toDisplayString(product.statut === "en-vente"
                    ? "EN VENTE"
                    : product.statut === "supprime"
                    ? "SUPPRIMÉ"
                    : product.statut === "rupture"
                    ? "RUPTURE"
                    : "HORS LIGNE"), 3)),
                      (product.premel !== '1')
                        ? (_openBlock(), _createElementBlock("label", _hoisted_198, [
                            _cache[103] || (_cache[103] = _createElementVNode("span", { class: "text-[9px] text-black uppercase tracking-wide leading-none" }, "Visible", -1)),
                            _createElementVNode("input", {
                              type: "checkbox",
                              checked: 
                    typeof product.visible === 'boolean'
                      ? product.visible
                      : false
                  ,
                              class: _normalizeClass(["m-0 w-4 h-4 shrink-0 text-green-600 bg-gray-100 border-gray-300 rounded focus:ring-green-500", isProductLocked(product) ? 'opacity-60' : '']),
                              disabled: isProductLocked(product),
                              onClick: _cache[19] || (_cache[19] = _withModifiers(() => {}, ["stop"])),
                              onChange: (event) => handleVisibilityChange(Number(product.id), (event.target as HTMLInputElement).checked, product, event)
                            }, null, 42, _hoisted_199)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", {
                      class: _normalizeClass(["flex flex-col gap-0 leading-tight pr-1", { hidden: isZoomedOut.value }]),
                      onClick: _cache[21] || (_cache[21] = _withModifiers(() => {}, ["stop"]))
                    }, [
                      _createElementVNode("div", _hoisted_200, [
                        _cache[104] || (_cache[104] = _createElementVNode("span", { class: "shrink-0 text-[11px] font-semibold text-black leading-tight" }, "Marque :", -1)),
                        _createElementVNode("span", _hoisted_201, _toDisplayString(product.marque || "—"), 1)
                      ]),
                      _createElementVNode("div", _hoisted_202, [
                        _cache[105] || (_cache[105] = _createElementVNode("span", { class: "shrink-0 text-[11px] font-semibold text-black leading-tight" }, "Catégorie :", -1)),
                        _createElementVNode("span", _hoisted_203, _toDisplayString(getLastCategoryLabel(product)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_204, [
                        _cache[106] || (_cache[106] = _createElementVNode("span", { class: "shrink-0 text-[11px] font-semibold text-black leading-tight" }, "Couleur :", -1)),
                        (getRowColorSwatches(product).length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_205, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getRowColorSwatches(product), (swatch, index) => {
                                return (_openBlock(), _createElementBlock("button", {
                                  key: `${product.id}-mobile-swatch-${index}`,
                                  type: "button",
                                  class: _normalizeClass(["color-swatch-dot rounded-full flex-shrink-0 w-4 h-4 border-0 p-0 cursor-pointer hover:ring-2 hover:ring-blue-300 hover:ring-offset-1 transition-shadow", 
                      isProductLocked(product)
                        ? 'cursor-not-allowed opacity-60'
                        : ''
                    ]),
                                  style: _normalizeStyle(swatch.style),
                                  title: swatch.label,
                                  disabled: isProductLocked(product),
                                  onClick: _withModifiers(($event: any) => (openColorModal(product)), ["stop"])
                                }, null, 14, _hoisted_206))
                              }), 128))
                            ]))
                          : (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              type: "button",
                              class: "text-xs text-black underline-offset-2 hover:underline leading-tight",
                              disabled: isProductLocked(product),
                              onClick: _withModifiers(($event: any) => (openColorModal(product)), ["stop"])
                            }, " Choisir ", 8, _hoisted_207))
                      ]),
                      _createElementVNode("div", _hoisted_208, [
                        _cache[107] || (_cache[107] = _createElementVNode("span", { class: "shrink-0 text-[11px] font-semibold text-black leading-tight" }, "Taille :", -1)),
                        _createElementVNode("span", _hoisted_209, _toDisplayString(getDeclinaisonLabel(product)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_210, [
                        _cache[108] || (_cache[108] = _createElementVNode("span", { class: "shrink-0 text-[11px] font-semibold text-black leading-tight" }, "Prix :", -1)),
                        _createElementVNode("span", _hoisted_211, _toDisplayString(typeof product.prix === "number"
                      ? product.prix.toFixed(2) + " €"
                      : "—"), 1)
                      ]),
                      _createElementVNode("div", _hoisted_212, [
                        _cache[109] || (_cache[109] = _createElementVNode("span", { class: "shrink-0 text-[11px] font-semibold text-black leading-tight" }, "Promo :", -1)),
                        _createElementVNode("span", _hoisted_213, _toDisplayString(formatPromotionLabel(product)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_214, [
                        _cache[110] || (_cache[110] = _createElementVNode("span", { class: "shrink-0 text-[11px] font-semibold text-black leading-tight" }, "Stock :", -1)),
                        _createElementVNode("span", _hoisted_215, [
                          (getStocksForRow(product).length > 0)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(getStocksForRow(product).reduce(
                        (sum, s) => sum + (s.quantity ?? 0),
                        0,
                      )), 1)
                              ], 64))
                            : (!loadingStocksForProduct.value.has(Number(product.id)))
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode(_toDisplayString(getStockInputDisplay(product) || "—"), 1)
                                ], 64))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                  _createTextVNode("...")
                                ], 64))
                        ])
                      ])
                    ], 2)
                  ])
                ], 2),
                (product.hasSiblings)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: _normalizeClass(isZoomedOut.value ? '-mx-2 -mb-2 mt-2' : '-mx-3 -mb-3 mt-2')
                    }, [
                      _createElementVNode("button", {
                        onClick: _withModifiers(($event: any) => (toggleLiaison(product.liaison)), ["stop"]),
                        class: _normalizeClass(["w-full flex items-center justify-center gap-1.5 py-1.5 rounded-b-lg transition-all duration-200 text-[11px] cursor-pointer border-t pointer-events-auto text-white", 
              isExpanded(product.liaison) ? 'font-medium' : 'font-semibold'
            ]),
                        style: {
              backgroundColor: '#C56C4D',
              borderColor: '#C56C4D',
            }
                      }, [
                        _createElementVNode("i", {
                          class: _normalizeClass([
                'fas fa-fw text-[10px]',
                isExpanded(product.liaison)
                  ? 'fa-chevron-up'
                  : 'fa-chevron-down',
              ])
                        }, null, 2),
                        _createElementVNode("span", null, _toDisplayString(isExpanded(product.liaison) ? "Réduire" : "Voir couleurs"), 1)
                      ], 10, _hoisted_216)
                    ], 2))
                  : _createCommentVNode("", true)
              ], 42, _hoisted_173))
            }), 128))
          ], 2))
        : _createCommentVNode("", true),
      (viewMode.value === 'list')
        ? (_openBlock(), _createElementBlock("div", _hoisted_217, [
            (isFiltering.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_218, _cache[111] || (_cache[111] = [
                  _createElementVNode("i", { class: "fas fa-spinner fa-spin text-3xl mr-3" }, null, -1),
                  _createElementVNode("span", { class: "text-xl" }, "Chargement des produits...", -1)
                ])))
              : (_openBlock(), _createBlock(ListProduitTable, {
                  key: 1,
                  headers: tableHeaders,
                  data: groupedProducts.value,
                  onRowClick: handleRowClick,
                  "row-class": getRowClass
                }, {
                  "header-checkbox": _withCtx(() => [
                    _createElementVNode("input", {
                      type: "checkbox",
                      checked: areAllCurrentSelected.value,
                      onChange: _cache[22] || (_cache[22] = (event) => handleToggleSelectAll((event.target as HTMLInputElement).checked)),
                      class: "w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500"
                    }, null, 40, _hoisted_219)
                  ]),
                  checkbox: _withCtx(({ row }) => [
                    _createElementVNode("input", {
                      type: "checkbox",
                      id: `box-${row.id}`,
                      name: "checkProduit[]",
                      value: row.id,
                      checked: isProductSelected(row),
                      ".indeterminate": isProductSelectionIndeterminate(row),
                      onClick: _cache[23] || (_cache[23] = _withModifiers(() => {}, ["stop"])),
                      onChange: (event) => handleProductSelection(
          Number(row.id),
          (event.target as HTMLInputElement).checked
          ),
                      class: "w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500",
                      title: 
              shouldToggleWholeLiaisonGroup(row)
                ? 'Sélectionner toutes les couleurs de cette référence'
                : undefined
            
                    }, null, 40, _hoisted_220)
                  ]),
                  image: _withCtx(({ row }) => [
                    _createElementVNode("div", _hoisted_221, [
                      (row.isChild)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_222, _cache[112] || (_cache[112] = [
                            _createElementVNode("span", { class: "absolute left-1 top-0 bottom-1/2 w-[2.5px] rounded-full bg-blue-400" }, null, -1),
                            _createElementVNode("span", { class: "absolute left-1 top-1/2 h-[2.5px] w-3 -translate-y-1/2 rounded-full bg-blue-400" }, null, -1),
                            _createElementVNode("i", { class: "fas fa-caret-right absolute left-[11px] top-1/2 -translate-y-1/2 text-blue-500 text-sm leading-none" }, null, -1)
                          ])))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", {
                        class: _normalizeClass(["relative bg-gray-100 rounded-md flex items-center justify-center overflow-hidden transition-all duration-200 cursor-pointer hover:opacity-80", row.isChild ? 'w-12 h-12' : 'w-20 h-20']),
                        onClick: _withModifiers(($event: any) => (handleEditProduct(Number(row.id))), ["stop"])
                      }, [
                        (getDisplayImageForProduct(row))
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: getProductImageUrl(row),
                              alt: typeof row.reference === 'string' ? row.reference : '',
                              loading: "lazy",
                              class: "w-full h-full object-cover",
                              onError: ($event: any) => (clearPendingCoverForProduct(row.id))
                            }, null, 40, _hoisted_224))
                          : (_openBlock(), _createElementBlock("div", _hoisted_225, [
                              _createElementVNode("i", {
                                class: _normalizeClass(["fas fa-tshirt text-black", row.isChild ? 'text-xs' : 'text-sm'])
                              }, null, 2)
                            ])),
                        (getCollapsedGroupSelectedCount(row) > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_226, [
                              _createElementVNode("span", _hoisted_227, _toDisplayString(getCollapsedGroupSelectedCount(row)), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ], 10, _hoisted_223)
                    ])
                  ]),
                  date: _withCtx(({ row }) => [
                    _createElementVNode("span", _hoisted_228, _toDisplayString(formatDate(row.date)), 1)
                  ]),
                  reference: _withCtx(({ row }) => [
                    _createElementVNode("div", _hoisted_229, [
                      _createElementVNode("div", _hoisted_230, [
                        (row.hasSiblings)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_231, " Principale "))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_232, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["inline-flex items-center gap-1.5 px-2 text-black border border-gray-200 bg-gray-50 rounded-md shadow-sm transition-all duration-200 min-w-0 max-w-full overflow-hidden", [
                    row.isChild
                      ? 'text-[10px] py-0.5 opacity-70'
                      : 'text-xs py-1',
                    { 'border-blue-300 bg-blue-50': row.hasSiblings },
                  ]])
                          }, [
                            _createElementVNode("span", {
                              class: "truncate min-w-0 flex-1",
                              title: row.reference
                            }, _toDisplayString(row.reference), 9, _hoisted_233)
                          ], 2),
                          _createElementVNode("div", _hoisted_234, [
                            (row.hasSiblings)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  onClick: _withModifiers(($event: any) => (toggleLiaison(row.liaison)), ["stop"]),
                                  class: "w-6 h-6 flex items-center justify-center rounded bg-blue-50 text-blue-500 hover:bg-blue-100 hover:text-blue-600 transition-colors",
                                  title: 
                      isExpanded(row.liaison)
                        ? 'Réduire'
                        : 'Voir les autres couleurs'
                    
                                }, [
                                  _createElementVNode("i", {
                                    class: _normalizeClass([
                        'fas text-xs',
                        isExpanded(row.liaison)
                          ? 'fa-chevron-down'
                          : 'fa-chevron-right',
                      ])
                                  }, null, 2)
                                ], 8, _hoisted_235))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ])
                  ]),
                  marque: _withCtx(({ row }) => [
                    _createElementVNode("select", {
                      value: row.marqueId,
                      class: _normalizeClass(["w-24 px-2 text-black border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:shadow-md transition-all", [
              row.isChild || isProductLocked(row)
                ? 'text-[10px] py-1 bg-gray-100 text-black border-gray-200 cursor-not-allowed'
                : 'text-xs py-1.5',
            ]]),
                      disabled: row.isChild || isProductLocked(row),
                      onClick: _cache[24] || (_cache[24] = _withModifiers(() => {}, ["stop"])),
                      onChange: (event) => saveProductData(Number(row.id), 'marqueId', (event.target as HTMLSelectElement).value)
                    }, [
                      _cache[113] || (_cache[113] = _createElementVNode("option", {
                        disabled: "",
                        value: ""
                      }, "Choisir une marque", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(brands.value, (b) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: b.id,
                          value: b.number
                        }, _toDisplayString(b.name), 9, _hoisted_237))
                      }), 128))
                    ], 42, _hoisted_236)
                  ]),
                  collection: _withCtx(({ row }) => [
                    _createElementVNode("select", {
                      value: row.collectionId,
                      class: "w-24 px-2 py-1.5 text-xs text-black border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:shadow-md transition-all",
                      onClick: _cache[25] || (_cache[25] = _withModifiers(() => {}, ["stop"])),
                      onChange: (event) =>
            saveProductData(Number(row.id), 'collectionId', (event.target as HTMLSelectElement).value)
                    }, [
                      _cache[114] || (_cache[114] = _createElementVNode("option", {
                        disabled: "",
                        value: ""
                      }, "Choisir une Collection", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(collections.value, (c) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: c.id_collection,
                          value: c.id_collection
                        }, _toDisplayString(c.libelle), 9, _hoisted_239))
                      }), 128))
                    ], 40, _hoisted_238)
                  ]),
                  categories: _withCtx(({ row }) => [
                    _createElementVNode("div", _hoisted_240, [
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": ($event: any) => ((row.catLevel1Id) = $event),
                        class: "flex-1 px-2 py-1.5 text-xs text-black border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:shadow-md min-w-[120px] max-w-[120px] transition-all",
                        onClick: _cache[26] || (_cache[26] = _withModifiers(() => {}, ["stop"])),
                        onChange: (event) =>
                  saveProductData(
                    Number(row.id),
                    'catLevel1Id',
                    (event.target as HTMLSelectElement).value
                  )
                      }, [
                        _cache[115] || (_cache[115] = _createElementVNode("option", {
                          disabled: "",
                          value: ""
                        }, "Choisir un catégorie", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(level1Options.value, (cat) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: cat.id_categorie,
                            value: cat.id_categorie
                          }, _toDisplayString(cat.label), 9, _hoisted_242))
                        }), 128))
                      ], 40, _hoisted_241), [
                        [_vModelSelect, row.catLevel1Id]
                      ]),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": ($event: any) => ((row.catLevel2Id) = $event),
                        class: "flex-1 px-2 py-1.5 text-xs text-black border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:shadow-md min-w-[120px] max-w-[120px] transition-all",
                        onClick: _cache[27] || (_cache[27] = _withModifiers(() => {}, ["stop"])),
                        onChange: (event) =>
                  saveProductData(
                    Number(row.id),
                    'catLevel2Id',
                    (event.target as HTMLSelectElement).value
                  )
                      }, [
                        _cache[116] || (_cache[116] = _createElementVNode("option", {
                          disabled: "",
                          value: ""
                        }, "Choisir un type", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getLevel2Options(row), (cat) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: cat.id_categorie,
                            value: cat.id_categorie
                          }, _toDisplayString(cat.label), 9, _hoisted_244))
                        }), 128))
                      ], 40, _hoisted_243), [
                        [_vModelSelect, row.catLevel2Id]
                      ]),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": ($event: any) => ((row.catLevel3Id) = $event),
                        class: "flex-1 px-2 py-1.5 text-xs text-black border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:shadow-md min-w-[120px] max-w-[120px] transition-all",
                        onClick: _cache[28] || (_cache[28] = _withModifiers(() => {}, ["stop"])),
                        onChange: (event) =>
                  saveProductData(
                    Number(row.id),
                    'catLevel3Id',
                    (event.target as HTMLSelectElement).value
                  )
                      }, [
                        _cache[117] || (_cache[117] = _createElementVNode("option", {
                          disabled: "",
                          value: ""
                        }, "Choisir un type", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getLevel3Options(row), (cat) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: cat.id_categorie,
                            value: cat.id_categorie
                          }, _toDisplayString(cat.label), 9, _hoisted_246))
                        }), 128))
                      ], 40, _hoisted_245), [
                        [_vModelSelect, row.catLevel3Id]
                      ])
                    ])
                  ]),
                  prix: _withCtx(({ row }) => [
                    _createElementVNode("input", {
                      type: "text",
                      value: typeof row.prix === 'number' ? row.prix.toFixed(2) : '0.00',
                      class: _normalizeClass(["w-14 px-2 text-black border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:shadow-md text-right transition-all", [
              row.isChild || isProductLocked(row)
                ? 'text-[10px] py-1 bg-gray-100 text-black border-gray-200 cursor-not-allowed'
                : 'text-xs py-1.5',
            ]]),
                      disabled: row.isChild || isProductLocked(row),
                      onClick: _cache[29] || (_cache[29] = _withModifiers(() => {}, ["stop"])),
                      onChange: (event) => saveProductData(Number(row.id), 'prix', (event.target as HTMLInputElement).value)
                    }, null, 42, _hoisted_247)
                  ]),
                  promotion: _withCtx(({ row }) => [
                    _createElementVNode("div", _hoisted_248, [
                      (getPromotionInputValue(row) !== '')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_249, " Prix final "))
                        : _createCommentVNode("", true),
                      _createElementVNode("input", {
                        type: "text",
                        value: getPromotionInputValue(row),
                        class: _normalizeClass(["w-14 px-2 text-black border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:shadow-md text-right transition-all", [
                row.isChild || isProductLocked(row)
                  ? 'text-[10px] py-1 bg-gray-100 text-black border-gray-200 cursor-not-allowed'
                  : 'text-xs py-1.5',
              ]]),
                        disabled: row.isChild || isProductLocked(row),
                        placeholder: "",
                        onClick: _cache[30] || (_cache[30] = _withModifiers(() => {}, ["stop"])),
                        onChange: (event) => saveProductData(Number(row.id), 'promotion', (event.target as HTMLInputElement).value, event.target as HTMLInputElement)
                      }, null, 42, _hoisted_250)
                    ])
                  ]),
                  poids: _withCtx(({ row }) => [
                    _createElementVNode("input", {
                      type: "text",
                      value: 
              typeof row.poids === 'number' ? row.poids.toFixed(1) : '0.0'
            ,
                      class: _normalizeClass(["w-14 px-2 text-black border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:shadow-md text-center transition-all", row.isChild ? 'text-[10px] py-1' : 'text-xs py-1.5']),
                      onClick: _cache[31] || (_cache[31] = _withModifiers(() => {}, ["stop"])),
                      onChange: (event) => saveProductData(Number(row.id), 'poids', (event.target as HTMLInputElement).value)
                    }, null, 42, _hoisted_251)
                  ]),
                  statut: _withCtx(({ row }) => [
                    (row.statut !== 'supprime' && row.premel === '1')
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: _normalizeClass([
              'inline-flex items-center rounded-full font-medium pointer-events-auto',
              row.isChild ? 'px-2 py-0.5 text-[10px]' : 'px-3 py-1 text-xs',
              'bg-amber-600 text-white shadow-sm',
            ])
                        }, " Brouillon ", 2))
                      : (_openBlock(), _createElementBlock("span", {
                          key: 1,
                          class: _normalizeClass([
              'inline-flex items-center rounded-full font-medium transition-all pointer-events-auto',
              row.isChild ? 'px-2 py-0.5 text-[10px]' : 'px-3 py-1 text-xs',
              row.statut === 'en-vente'
                ? 'bg-emerald-500 text-white'
                : row.statut === 'supprime'
                ? 'bg-red-700 text-white'
                : row.statut === 'rupture'
                ? 'bg-red-500 text-white'
                : 'bg-gray-400 text-white',
            ])
                        }, _toDisplayString(row.statut === "en-vente"
                ? "En vente"
                : row.statut === "supprime"
                ? "Supprimé"
                : row.statut === "rupture"
                ? "Rupture"
                : "Hors ligne"), 3))
                  ]),
                  couleur: _withCtx(({ row }) => [
                    (getRowColorSwatches(row).length)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "inline-flex flex-wrap gap-1 justify-center items-center max-w-[4.5rem] mx-auto",
                          onClick: _cache[32] || (_cache[32] = _withModifiers(() => {}, ["stop"]))
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getRowColorSwatches(row), (swatch, index) => {
                            return (_openBlock(), _createElementBlock("button", {
                              key: `${row.id}-swatch-${index}`,
                              type: "button",
                              class: _normalizeClass(["color-swatch-dot rounded-full flex-shrink-0 w-4 h-4 border-0 p-0 cursor-pointer hover:ring-2 hover:ring-blue-300 hover:ring-offset-1 transition-shadow", 
                isProductLocked(row) ? 'cursor-not-allowed opacity-60' : ''
              ]),
                              style: _normalizeStyle(swatch.style),
                              title: swatch.label,
                              disabled: isProductLocked(row),
                              onClick: _withModifiers(($event: any) => (openColorModal(row)), ["stop"])
                            }, null, 14, _hoisted_252))
                          }), 128))
                        ]))
                      : (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          type: "button",
                          class: "text-[10px] text-black hover:underline mx-auto block",
                          disabled: isProductLocked(row),
                          onClick: _withModifiers(($event: any) => (openColorModal(row)), ["stop"])
                        }, " — ", 8, _hoisted_253))
                  ]),
                  stock: _withCtx(({ row }) => [
                    _createElementVNode("div", {
                      class: "flex flex-col gap-1",
                      onClick: _cache[35] || (_cache[35] = _withModifiers(() => {}, ["stop"]))
                    }, [
                      (getStocksForRow(row).length > 0)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (row.venduPar === 'tailles')
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: "w-14 px-2 py-1.5 text-xs border border-gray-300 rounded-md shadow-sm text-center text-black hover:bg-gray-50 transition-all cursor-pointer",
                                  onClick: _withModifiers(($event: any) => (handleEditProduct(Number(row.id))), ["stop"])
                                }, _toDisplayString(getStocksForRow(row).reduce(
                      (sum, s) => sum + (s.quantity ?? 0),
                      0,
                    )), 9, _hoisted_254))
                              : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(getStocksForRow(row), (s, index) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: index,
                                    class: "flex items-center gap-1 text-xs"
                                  }, [
                                    _createElementVNode("input", {
                                      value: s.quantity != null ? String(s.quantity) : '',
                                      type: "text",
                                      inputmode: "numeric",
                                      pattern: "[0-9]*",
                                      class: _normalizeClass(["w-14 px-2 py-1.5 text-xs border border-gray-300 rounded-md shadow-sm text-center text-black focus:outline-none focus:ring-2 focus:ring-blue-500 focus:shadow-md transition-all", 
                      isProductLocked(row)
                        ? 'bg-gray-100 text-black border-gray-200 cursor-not-allowed'
                        : ''
                    ]),
                                      onClick: _cache[33] || (_cache[33] = _withModifiers(() => {}, ["stop"])),
                                      onChange: (event) => onStockQuantityChange(row, s, (event.target as HTMLInputElement).value)
                                    }, null, 42, _hoisted_255)
                                  ]))
                                }), 128))
                          ], 64))
                        : (!loadingStocksForProduct.value.has(Number(row.id)))
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              (row.venduPar === 'tailles')
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    class: "w-14 h-[30px] px-2 py-1.5 text-xs border border-gray-300 rounded-md shadow-sm text-center text-black hover:bg-gray-50 transition-all cursor-pointer",
                                    onClick: _withModifiers(($event: any) => (handleEditProduct(Number(row.id))), ["stop"])
                                  }, null, 8, _hoisted_256))
                                : (_openBlock(), _createElementBlock("input", {
                                    key: 1,
                                    type: "text",
                                    inputmode: "numeric",
                                    pattern: "[0-9]*",
                                    value: getStockInputDisplay(row),
                                    placeholder: "",
                                    class: _normalizeClass(["w-16 px-2 text-black border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:shadow-md text-center transition-all", [
                  row.isChild ? 'text-[10px] py-1' : 'text-xs py-1.5',
                  isProductLocked(row)
                    ? 'bg-gray-100 text-black border-gray-200 cursor-not-allowed'
                    : '',
                ]]),
                                    onClick: _cache[34] || (_cache[34] = _withModifiers(() => {}, ["stop"])),
                                    onChange: (event) => onFallbackStockChange(row, (event.target as HTMLInputElement).value)
                                  }, null, 42, _hoisted_257))
                            ], 64))
                          : (_openBlock(), _createElementBlock("span", _hoisted_258, "..."))
                    ])
                  ]),
                  visible: _withCtx(({ row }) => [
                    (row.premel === '1')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_259, "—"))
                      : (_openBlock(), _createElementBlock("input", {
                          key: 1,
                          type: "checkbox",
                          checked: typeof row.visible === 'boolean' ? row.visible : false,
                          class: _normalizeClass(["w-4 h-4 text-green-600 bg-gray-100 border-gray-300 rounded focus:ring-green-500", isProductLocked(row) ? 'opacity-60' : '']),
                          disabled: isProductLocked(row),
                          onClick: _cache[36] || (_cache[36] = _withModifiers(() => {}, ["stop"])),
                          onChange: (event) => handleVisibilityChange(Number(row.id), (event.target as HTMLInputElement).checked, row, event)
                        }, null, 42, _hoisted_260))
                  ]),
                  actions: _withCtx(({ row }) => [
                    _createElementVNode("div", {
                      class: "relative inline-block w-[140px] pointer-events-auto",
                      onClick: _cache[37] || (_cache[37] = _withModifiers(() => {}, ["stop"]))
                    }, [
                      _createElementVNode("button", {
                        onClick: _withModifiers(($event: any) => (toggleActionMenu(Number(row.id), $event)), ["stop"]),
                        class: "w-full px-3 py-1.5 text-sm font-medium text-black bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 flex items-center justify-between"
                      }, _cache[118] || (_cache[118] = [
                        _createElementVNode("span", null, "Actions", -1),
                        _createElementVNode("i", { class: "fas fa-chevron-down text-xs" }, null, -1)
                      ]), 8, _hoisted_261),
                      (openActionMenuId.value === Number(row.id))
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "fixed bg-white border border-gray-200 rounded-md shadow-lg z-[9999] py-1 min-w-[140px]",
                            style: _normalizeStyle({
                top: actionMenuPosition.value.top + 'px',
                left: actionMenuPosition.value.left + 'px',
              })
                          }, [
                            (isProductLocked(row))
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  onClick: _withModifiers(($event: any) => (handleReactivateProduct(Number(row.id))), ["stop"]),
                                  class: "w-full px-3 py-2 text-left text-xs text-green-700 hover:bg-green-50 transition-colors flex items-center gap-2"
                                }, _cache[119] || (_cache[119] = [
                                  _createElementVNode("span", { class: "w-5 h-5 bg-green-500 rounded flex items-center justify-center" }, [
                                    _createElementVNode("i", { class: "fas fa-undo text-[10px] text-white" })
                                  ], -1),
                                  _createElementVNode("span", null, "Réactiver", -1)
                                ]), 8, _hoisted_262))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  (row.isChild)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        onClick: _withModifiers(($event: any) => (handleSetAsPrincipale(row)), ["stop"]),
                                        disabled: isSettingMainProduct.value,
                                        class: "w-full px-3 py-2 text-left text-xs text-black hover:bg-orange-50 hover:text-orange-700 transition-colors flex items-center gap-2"
                                      }, [
                                        _cache[120] || (_cache[120] = _createElementVNode("span", { class: "w-5 h-5 bg-orange-500 rounded flex items-center justify-center" }, [
                                          _createElementVNode("i", { class: "fas fa-star text-[10px] text-white" })
                                        ], -1)),
                                        _createElementVNode("span", null, _toDisplayString(isSettingMainProduct.value ? "Mise a jour..." : "Principale"), 1)
                                      ], 8, _hoisted_263))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("button", {
                                    onClick: _withModifiers(($event: any) => (handleEditProduct(Number(row.id))), ["stop"]),
                                    class: "w-full px-3 py-2 text-left text-xs text-black hover:bg-blue-50 hover:text-blue-700 transition-colors flex items-center gap-2"
                                  }, _cache[121] || (_cache[121] = [
                                    _createElementVNode("span", { class: "w-5 h-5 bg-blue-500 rounded flex items-center justify-center" }, [
                                      _createElementVNode("i", { class: "fas fa-pen text-[10px] text-white" })
                                    ], -1),
                                    _createElementVNode("span", null, "Modifier", -1)
                                  ]), 8, _hoisted_264),
                                  _createElementVNode("button", {
                                    onClick: _withModifiers(($event: any) => (openAddColorModal(row)), ["stop"]),
                                    class: "w-full px-3 py-2 text-left text-xs text-black hover:bg-pink-50 hover:text-pink-700 transition-colors flex items-center gap-2"
                                  }, [
                                    _createElementVNode("span", _hoisted_266, [
                                      _createElementVNode("i", {
                                        class: _normalizeClass([
                        'fas text-[10px] text-white',
                        row.venduPar === 'melangees'
                          ? 'fa-camera'
                          : 'fa-palette',
                      ])
                                      }, null, 2)
                                    ]),
                                    _createElementVNode("span", null, _toDisplayString(row.venduPar === "melangees"
                      ? "Nouvelle photo"
                      : "Nouvelle couleur"), 1)
                                  ], 8, _hoisted_265),
                                  _createElementVNode("button", {
                                    onClick: _withModifiers(($event: any) => (handleCopyProduct(Number(row.id))), ["stop"]),
                                    class: "w-full px-3 py-2 text-left text-xs text-black hover:bg-purple-50 hover:text-purple-700 transition-colors flex items-center gap-2"
                                  }, _cache[122] || (_cache[122] = [
                                    _createElementVNode("span", { class: "w-5 h-5 bg-purple-500 rounded flex items-center justify-center" }, [
                                      _createElementVNode("i", { class: "fas fa-copy text-[10px] text-white" })
                                    ], -1),
                                    _createElementVNode("span", null, "Copier", -1)
                                  ]), 8, _hoisted_267),
                                  (isUpgrUser.value && row.premel === '1')
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 1,
                                        onClick: _withModifiers(($event: any) => (handlePublishBrouillon(Number(row.id))), ["stop"]),
                                        class: "w-full px-3 py-2 text-left text-xs text-black hover:bg-green-50 hover:text-green-700 transition-colors flex items-center gap-2"
                                      }, _cache[123] || (_cache[123] = [
                                        _createElementVNode("span", { class: "w-5 h-5 bg-green-500 rounded flex items-center justify-center" }, [
                                          _createElementVNode("i", { class: "fas fa-cloud-upload-alt text-[10px] text-white" })
                                        ], -1),
                                        _createElementVNode("span", null, "Mettre en ligne", -1)
                                      ]), 8, _hoisted_268))
                                    : _createCommentVNode("", true),
                                  (row.hasSiblings || (!row.isChild && !row.hasSiblings))
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: 2,
                                        href: getAcheteurUrl(row),
                                        target: "_blank",
                                        class: "w-full px-3 py-2 text-left text-xs text-black hover:bg-green-50 hover:text-green-700 transition-colors flex items-center gap-2",
                                        onClick: _withModifiers(($event: any) => (logVoirMaPageClick($event, row)), ["stop"])
                                      }, [
                                        _cache[124] || (_cache[124] = _createElementVNode("span", { class: "w-5 h-5 bg-green-500 rounded flex items-center justify-center" }, [
                                          _createElementVNode("i", { class: "fas fa-external-link-alt text-[10px] text-white" })
                                        ], -1)),
                                        _createElementVNode("span", null, _toDisplayString(row.acheteurUrl ? "Voir sur le site" : "Voir ma page"), 1)
                                      ], 8, _hoisted_269))
                                    : _createCommentVNode("", true)
                                ], 64))
                          ], 4))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }, 8, ["data"]))
          ]))
        : _createCommentVNode("", true),
      (viewMode.value === 'grid')
        ? (_openBlock(), _createElementBlock("div", _hoisted_270, [
            _createElementVNode("div", _hoisted_271, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredProducts.value, (product) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: product.id,
                  class: _normalizeClass(["bg-white border border-gray-200 rounded-lg overflow-hidden hover:shadow-md transition-shadow", {
            'bg-gray-50/70 pointer-events-none select-none':
              isProductLocked(product) && activeTab.value !== 'supprime',
          }])
                }, [
                  _createElementVNode("div", {
                    class: "w-full h-48 bg-gray-100 flex items-center justify-center cursor-pointer hover:opacity-80 transition-opacity",
                    onClick: ($event: any) => (handleEditProduct(Number(product.id)))
                  }, [
                    (getDisplayImageForProduct(product))
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: getProductImageUrl(product),
                          alt: product.reference,
                          class: "w-full h-full object-cover",
                          onError: _cache[38] || (_cache[38] = (event) => { const target = event.target as HTMLImageElement; if (target) target.style.display = 'none'; })
                        }, null, 40, _hoisted_273))
                      : (_openBlock(), _createElementBlock("div", _hoisted_274, "164x208"))
                  ], 8, _hoisted_272),
                  _createElementVNode("div", _hoisted_275, [
                    _createElementVNode("div", _hoisted_276, [
                      _createElementVNode("h3", _hoisted_277, _toDisplayString(product.reference) + "-" + _toDisplayString(product.couleur), 1),
                      _createElementVNode("div", _hoisted_278, [
                        _cache[125] || (_cache[125] = _createElementVNode("span", { class: "text-xs text-black" }, "Prix:", -1)),
                        _createElementVNode("input", {
                          type: "text",
                          value: 
                    typeof product.prix === 'number'
                      ? product.prix.toFixed(2)
                      : '0.00'
                  ,
                          class: _normalizeClass(["w-20 px-1.5 py-0.5 text-[11px] text-black border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-blue-500 focus:shadow-md transition-all text-right h-6", [
                    (product as any).isChild ? 'bg-gray-100 cursor-not-allowed' : '',
                  ]]),
                          disabled: (product as any).isChild,
                          onClick: _cache[39] || (_cache[39] = _withModifiers(() => {}, ["stop"])),
                          onChange: (event) => saveProductData(product.id, 'prix', (event.target as HTMLInputElement).value)
                        }, null, 42, _hoisted_279),
                        _cache[126] || (_cache[126] = _createElementVNode("span", { class: "text-[11px]" }, "€", -1))
                      ]),
                      _createElementVNode("div", _hoisted_280, [
                        _cache[127] || (_cache[127] = _createElementVNode("span", { class: "text-xs text-black" }, "Promo:", -1)),
                        _createElementVNode("input", {
                          type: "text",
                          value: getPromotionInputValue(product),
                          class: _normalizeClass(["w-20 px-1.5 py-0.5 text-[11px] text-black border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-blue-500 focus:shadow-md transition-all text-right h-6", [
                    (product as any).isChild ? 'bg-gray-100 cursor-not-allowed' : '',
                  ]]),
                          disabled: (product as any).isChild,
                          placeholder: "0.00",
                          onClick: _cache[40] || (_cache[40] = _withModifiers(() => {}, ["stop"])),
                          onChange: (event) => saveProductData(product.id, 'promotion', (event.target as HTMLInputElement).value, event.target as HTMLInputElement)
                        }, null, 42, _hoisted_281),
                        _cache[128] || (_cache[128] = _createElementVNode("span", { class: "text-[11px]" }, "€", -1))
                      ]),
                      _createElementVNode("p", _hoisted_282, " À la couleur " + _toDisplayString(product.categories), 1)
                    ]),
                    _createElementVNode("div", _hoisted_283, [
                      _createElementVNode("label", _hoisted_284, [
                        _createElementVNode("input", {
                          type: "checkbox",
                          checked: product.visible,
                          onChange: (event) => handleVisibilityChange(product.id, (event.target as HTMLInputElement).checked, product, event),
                          class: "w-3 h-3 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                        }, null, 40, _hoisted_285),
                        _cache[129] || (_cache[129] = _createElementVNode("span", { class: "text-black" }, "Visible", -1))
                      ])
                    ]),
                    _createElementVNode("button", {
                      onClick: ($event: any) => (handleDeleteProduct(product.id)),
                      class: "w-full text-xs text-red-600 hover:text-red-800 font-medium py-1 px-2 border border-red-200 rounded hover:bg-red-50 transition-colors"
                    }, " Supprimer ", 8, _hoisted_286)
                  ])
                ], 2))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_unref(UnifiedPagination), {
        "total-items": totalProducts.value,
        "current-page": currentPage.value,
        "items-per-page": itemsPerPage.value,
        variant: "product",
        "item-label": "produits principaux",
        "items-per-page-options": [10, 25, 50, 100],
        "show-first-last-buttons": true,
        "onUpdate:currentPage": handlePageChange,
        "onUpdate:itemsPerPage": handleItemsPerPageChange,
        onPageChange: handlePageChange,
        onItemsPerPageChange: handleItemsPerPageChange
      }, null, 8, ["total-items", "current-page", "items-per-page"])
    ])
  ], 64))
}
}

})